// Market data for real estate listings by city, area, and property type
/*
In page 2,3,4 of this pdf, return market updates for detached (page 2), condo(page3), townhomes(page 4), for feb of 2025 for each neighbourhood. record sales, active listings, benchamark price, one year change in json format of {
"Vancouver East": {
"detached": {
"Champlain Heights": {
"sales": 0,
"active_listings": 3,
"benchmark_price": "
0",
"one_year_change": ""
},
"condos": {
"sales": 0,
"active_listings": 3,
"benchmark_price": "$0",
"one_year_change": ""
},
}},
*/

export const marketDataGVRpercityAllMonths = {
	'February 2025': {
		'Vancouver East': {
			detached: {
				'Champlain Heights': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Collingwood VE': {
					sales: 2,
					active_listings: 95,
					benchmark_price: '$1,718,000',
					one_year_change: '0.4%'
				},
				'Downtown VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Fraser VE': {
					sales: 5,
					active_listings: 31,
					benchmark_price: '$1,935,200',
					one_year_change: '+ 8.8%'
				},
				'Fraserview VE': {
					sales: 1,
					active_listings: 28,
					benchmark_price: '$2,321,200',
					one_year_change: '+ 1.7%'
				},
				'Grandview Woodland': {
					sales: 6,
					active_listings: 35,
					benchmark_price: '$1,792,000',
					one_year_change: '- 0.6%'
				},
				Hastings: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,647,700',
					one_year_change: '- 1.8%'
				},
				'Hastings Sunrise': {
					sales: 3,
					active_listings: 15,
					benchmark_price: '$1,690,900',
					one_year_change: '+ 1.6%'
				},
				'Killarney VE': {
					sales: 10,
					active_listings: 42,
					benchmark_price: '$1,999,400',
					one_year_change: '+ 2.1%'
				},
				Knight: {
					sales: 3,
					active_listings: 44,
					benchmark_price: '$1,815,400',
					one_year_change: '+ 3.0%'
				},
				Main: {
					sales: 5,
					active_listings: 18,
					benchmark_price: '$2,086,100',
					one_year_change: '+ 6.5%'
				},
				'Mount Pleasant VE': {
					sales: 0,
					active_listings: 15,
					benchmark_price: '$1,875,100',
					one_year_change: '+ 0.2%'
				},
				'Renfrew Heights': {
					sales: 8,
					active_listings: 51,
					benchmark_price: '$1,791,400',
					one_year_change: '- 0.9%'
				},
				'Renfrew VE': {
					sales: 4,
					active_listings: 70,
					benchmark_price: '$1,766,500',
					one_year_change: '- 1.2%'
				},
				'South Marine': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,478,600',
					one_year_change: '+ 2.3%'
				},
				'South Vancouver': {
					sales: 5,
					active_listings: 52,
					benchmark_price: '$1,849,400',
					one_year_change: '- 2.3%'
				},
				Strathcona: {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$1,578,700',
					one_year_change: '- 1.8%'
				},
				'Victoria VE': {
					sales: 1,
					active_listings: 23,
					benchmark_price: '$1,761,500',
					one_year_change: '+ 2.5%'
				}
			},
			condos: {
				'Champlain Heights': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$794,700',
					one_year_change: '- 2.7%'
				},
				'Collingwood VE': {
					sales: 8,
					active_listings: 79,
					benchmark_price: '$590,600',
					one_year_change: '- 0.7%'
				},
				'Downtown VE': {
					sales: 8,
					active_listings: 50,
					benchmark_price: '$639,400',
					one_year_change: '- 2.9%'
				},
				'Fraser VE': {
					sales: 2,
					active_listings: 15,
					benchmark_price: '$746,400',
					one_year_change: '- 8.7%'
				},
				'Fraserview VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Grandview Woodland': {
					sales: 9,
					active_listings: 30,
					benchmark_price: '$685,600',
					one_year_change: '+ 5.6%'
				},
				Hastings: {
					sales: 6,
					active_listings: 10,
					benchmark_price: '$554,800',
					one_year_change: '+ 0.0%'
				},
				'Hastings Sunrise': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$570,900',
					one_year_change: '+ 3.2%'
				},
				'Killarney VE': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$616,400',
					one_year_change: '- 3.7%'
				},
				Knight: {
					sales: 4,
					active_listings: 6,
					benchmark_price: '$640,800',
					one_year_change: '+ 8.2%'
				},
				Main: {
					sales: 1,
					active_listings: 8,
					benchmark_price: '$921,100',
					one_year_change: '- 8.4%'
				},
				'Mount Pleasant VE': {
					sales: 26,
					active_listings: 99,
					benchmark_price: '$695,200',
					one_year_change: '- 6.0%'
				},
				'Renfrew Heights': {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$427,900',
					one_year_change: '+ 8.4%'
				},
				'Renfrew VE': {
					sales: 5,
					active_listings: 10,
					benchmark_price: '$767,200',
					one_year_change: '+ 5.8%'
				},
				'South Marine': {
					sales: 12,
					active_listings: 81,
					benchmark_price: '$805,100',
					one_year_change: '- 4.5%'
				},
				'South Vancouver': {
					sales: 0,
					active_listings: 16,
					benchmark_price: '$627,000',
					one_year_change: '- 7.4%'
				},
				Strathcona: {
					sales: 7,
					active_listings: 38,
					benchmark_price: '$693,000',
					one_year_change: '- 5.8%'
				},
				'Victoria VE': {
					sales: 2,
					active_listings: 10,
					benchmark_price: '$805,200',
					one_year_change: '+ 1.6%'
				}
			},
			townhomes: {
				'Champlain Heights': {
					sales: 6,
					active_listings: 9,
					benchmark_price: '$1,038,500',
					one_year_change: '+ 4.8%'
				},
				'Collingwood VE': {
					sales: 4,
					active_listings: 10,
					benchmark_price: '$1,024,700',
					one_year_change: '+ 4.5%'
				},
				'Downtown VE': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Fraser VE': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,460,100',
					one_year_change: '+ 2.9%'
				},
				'Fraserview VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Grandview Woodland': {
					sales: 0,
					active_listings: 14,
					benchmark_price: '$1,457,700',
					one_year_change: '+ 5.4%'
				},
				Hastings: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,270,800',
					one_year_change: '+ 5.1%'
				},
				'Hastings Sunrise': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Killarney VE': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$978,600',
					one_year_change: '+ 4.3%'
				},
				Knight: {
					sales: 4,
					active_listings: 4,
					benchmark_price: '$1,325,600',
					one_year_change: '- 2.1%'
				},
				Main: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$1,243,100',
					one_year_change: '+ 2.1%'
				},
				'Mount Pleasant VE': {
					sales: 1,
					active_listings: 17,
					benchmark_price: '$1,206,800',
					one_year_change: '+ 9.5%'
				},
				'Renfrew Heights': {
					sales: 2,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Renfrew VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$1,042,600',
					one_year_change: '+ 5.2%'
				},
				'South Marine': {
					sales: 4,
					active_listings: 14,
					benchmark_price: '$1,066,400',
					one_year_change: '+ 4.1%'
				},
				'South Vancouver': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Strathcona: {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$1,088,700',
					one_year_change: '+ 12.3%'
				},
				'Victoria VE': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$1,334,900',
					one_year_change: '+ 5.0%'
				}
			}
		},

		'Burnaby East': {
			detached: {
				'East Burnaby': {
					sales: 1,
					active_listings: 14,
					benchmark_price: '$1,987,000',
					one_year_change: '+ 3.0%'
				},
				'Edmonds BE': {
					sales: 3,
					active_listings: 13,
					benchmark_price: '$1,794,500',
					one_year_change: '-1.6%'
				},
				'The Crest': {
					sales: 2,
					active_listings: 9,
					benchmark_price: '$1,976,400',
					one_year_change: '+ 3.4%'
				}
			},
			condos: {
				'East Burnaby': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$639,700',
					one_year_change: '-1.2%'
				},
				'Edmonds BE': {
					sales: 9,
					active_listings: 77,
					benchmark_price: '$788,700',
					one_year_change: '-1.0%'
				},
				'The Crest': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'East Burnaby': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Edmonds BE': {
					sales: 4,
					active_listings: 17,
					benchmark_price: '$792,700',
					one_year_change: '+ 1.4%'
				},
				'The Crest': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$1,159,900',
					one_year_change: '+ 3.5%'
				}
			}
		},

		'Maple Ridge': {
			detached: {
				Albion: {
					sales: 7,
					active_listings: 45,
					benchmark_price: '$1,227,100',
					one_year_change: '-3.5%'
				},
				'Cottonwood MR': {
					sales: 9,
					active_listings: 54,
					benchmark_price: '$1,291,600',
					one_year_change: '-2.4%'
				},
				'East Central': {
					sales: 7,
					active_listings: 57,
					benchmark_price: '$1,125,600',
					one_year_change: '-2.3%'
				},
				'North Maple Ridge': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: null
				},
				Northeast: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,731,600',
					one_year_change: '-1.3%'
				},
				'Northwest Maple Ridge': {
					sales: 3,
					active_listings: 31,
					benchmark_price: '$1,194,900',
					one_year_change: '-3.8%'
				},
				'Silver Valley': {
					sales: 6,
					active_listings: 62,
					benchmark_price: '$1,485,200',
					one_year_change: '+2.3%'
				},
				'Southwest Maple Ridge': {
					sales: 7,
					active_listings: 53,
					benchmark_price: '$1,021,700',
					one_year_change: '-10.7%'
				},
				'Thornhill MR': {
					sales: 7,
					active_listings: 23,
					benchmark_price: '$1,666,700',
					one_year_change: '+1.3%'
				},
				'Websters Corners': {
					sales: 2,
					active_listings: 30,
					benchmark_price: '$1,404,500',
					one_year_change: '+2.4%'
				},
				'West Central': {
					sales: 6,
					active_listings: 90,
					benchmark_price: '$1,094,600',
					one_year_change: '-1.1%'
				},
				Whonnock: {
					sales: 1,
					active_listings: 17,
					benchmark_price: '$1,579,700',
					one_year_change: '+5.8%'
				}
			},
			condos: {
				Albion: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Cottonwood MR': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'East Central': {
					sales: 20,
					active_listings: 81,
					benchmark_price: '$514,800',
					one_year_change: '-1.6%'
				},
				'North Maple Ridge': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Northeast: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Northwest Maple Ridge': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$536,700',
					one_year_change: '-2.7%'
				},
				'Silver Valley': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Southwest Maple Ridge': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$419,200',
					one_year_change: '-0.7%'
				},
				'Thornhill MR': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Websters Corners': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'West Central': {
					sales: 15,
					active_listings: 58,
					benchmark_price: '$538,700',
					one_year_change: '-1.2%'
				},
				Whonnock: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				}
			},
			townhomes: {
				Albion: {
					sales: 7,
					active_listings: 16,
					benchmark_price: '$817,200',
					one_year_change: '+0.6%'
				},
				'Cottonwood MR': {
					sales: 14,
					active_listings: 15,
					benchmark_price: '$813,000',
					one_year_change: '+0.5%'
				},
				'East Central': {
					sales: 8,
					active_listings: 27,
					benchmark_price: '$753,800',
					one_year_change: '-1.1%'
				},
				'North Maple Ridge': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Northeast: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Northwest Maple Ridge': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$698,200',
					one_year_change: '+0.4%'
				},
				'Silver Valley': {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$850,200',
					one_year_change: '+0.0%'
				},
				'Southwest Maple Ridge': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$652,200',
					one_year_change: '+1.7%'
				},
				'Thornhill MR': {
					sales: 5,
					active_listings: 11,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Websters Corners': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'West Central': {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$696,000',
					one_year_change: '-0.1%'
				},
				Whonnock: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				}
			}
		},

		Richmond: {
			detached: {
				'Boyd Park': {
					sales: 0,
					active_listings: 13,
					benchmark_price: '$2,142,800',
					one_year_change: '-3.4%'
				},
				'Bridgeport RI': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$1,831,800',
					one_year_change: '+3.6%'
				},
				Brighouse: {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Brighouse South': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Broadmoor: {
					sales: 3,
					active_listings: 37,
					benchmark_price: '$2,675,500',
					one_year_change: '+1.1%'
				},
				'East Cambie': {
					sales: 1,
					active_listings: 13,
					benchmark_price: '$1,893,500',
					one_year_change: '+2.6%'
				},
				'East Richmond': {
					sales: 0,
					active_listings: 13,
					benchmark_price: '$2,236,300',
					one_year_change: '-3.2%'
				},
				'Garden City': {
					sales: 2,
					active_listings: 16,
					benchmark_price: '$1,952,000',
					one_year_change: '+2.7%'
				},
				Gilmore: {
					sales: 0,
					active_listings: 9,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Granville: {
					sales: 4,
					active_listings: 38,
					benchmark_price: '$2,366,600',
					one_year_change: '-6.6%'
				},
				'Hamilton RI': {
					sales: 3,
					active_listings: 22,
					benchmark_price: '$1,357,500',
					one_year_change: '-5.1%'
				},
				Ironwood: {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$1,668,800',
					one_year_change: '-7.5%'
				},
				Lackner: {
					sales: 1,
					active_listings: 15,
					benchmark_price: '$2,264,900',
					one_year_change: '-2.7%'
				},
				McLennan: {
					sales: 1,
					active_listings: 15,
					benchmark_price: '$2,461,200',
					one_year_change: '-6.2%'
				},
				'McLennan North': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$2,635,100',
					one_year_change: '+4.8%'
				},
				McNair: {
					sales: 3,
					active_listings: 17,
					benchmark_price: '$1,733,100',
					one_year_change: '-7.9%'
				},
				'Quilchena RI': {
					sales: 1,
					active_listings: 31,
					benchmark_price: '$2,063,900',
					one_year_change: '-7.8%'
				},
				'Riverdale RI': {
					sales: 2,
					active_listings: 32,
					benchmark_price: '$2,271,100',
					one_year_change: '-7.1%'
				},
				Saunders: {
					sales: 2,
					active_listings: 23,
					benchmark_price: '$2,399,600',
					one_year_change: '+1.8%'
				},
				'Sea Island': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$2,170,400',
					one_year_change: '+3.3%'
				},
				Seafair: {
					sales: 4,
					active_listings: 26,
					benchmark_price: '$2,616,400',
					one_year_change: '-1.7%'
				},
				'South Arm': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$2,335,100',
					one_year_change: '+1.7%'
				},
				'Steveston North': {
					sales: 3,
					active_listings: 27,
					benchmark_price: '$1,874,500',
					one_year_change: '+2.7%'
				},
				'Steveston South': {
					sales: 0,
					active_listings: 10,
					benchmark_price: '$2,100,900',
					one_year_change: '+2.0%'
				},
				'Steveston Village': {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$2,014,500',
					one_year_change: '+3.1%'
				},
				'Terra Nova': {
					sales: 3,
					active_listings: 11,
					benchmark_price: '$2,250,500',
					one_year_change: '-6.6%'
				},
				'West Cambie': {
					sales: 0,
					active_listings: 24,
					benchmark_price: '$1,947,900',
					one_year_change: '+2.9%'
				},
				Westwind: {
					sales: 1,
					active_listings: 13,
					benchmark_price: '$2,213,400',
					one_year_change: '+2.7%'
				},
				Woodwards: {
					sales: 2,
					active_listings: 33,
					benchmark_price: '$2,011,700',
					one_year_change: '+3.1%'
				}
			},
			condos: {
				'Boyd Park': {
					sales: 1,
					active_listings: 8,
					benchmark_price: '$568,500',
					one_year_change: '+0.7%'
				},
				'Bridgeport RI': {
					sales: 2,
					active_listings: 10,
					benchmark_price: '$694,800',
					one_year_change: '-2.2%'
				},
				Brighouse: {
					sales: 41,
					active_listings: 375,
					benchmark_price: '$781,800',
					one_year_change: '-1.6%'
				},
				'Brighouse South': {
					sales: 15,
					active_listings: 68,
					benchmark_price: '$655,000',
					one_year_change: '-1.3%'
				},
				Broadmoor: {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$493,400',
					one_year_change: '-3.5%'
				},
				'East Cambie': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$463,300',
					one_year_change: '+2.7%'
				},
				'East Richmond': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$793,200',
					one_year_change: '-1.9%'
				},
				'Garden City': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Gilmore: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Granville: {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$258,400',
					one_year_change: '-2.7%'
				},
				'Hamilton RI': {
					sales: 0,
					active_listings: 12,
					benchmark_price: '$826,800',
					one_year_change: '-2.5%'
				},
				Ironwood: {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$624,000',
					one_year_change: '-3.1%'
				},
				Lackner: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				McLennan: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'McLennan North': {
					sales: 5,
					active_listings: 33,
					benchmark_price: '$712,400',
					one_year_change: '-0.9%'
				},
				McNair: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Quilchena RI': {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Riverdale RI': {
					sales: 3,
					active_listings: 4,
					benchmark_price: '$639,000',
					one_year_change: '-0.4%'
				},
				Saunders: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sea Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Seafair: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$588,200',
					one_year_change: '+0.0%'
				},
				'South Arm': {
					sales: 2,
					active_listings: 9,
					benchmark_price: '$291,500',
					one_year_change: '-4.0%'
				},
				'Steveston North': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$530,500',
					one_year_change: '-1.2%'
				},
				'Steveston South': {
					sales: 7,
					active_listings: 16,
					benchmark_price: '$799,600',
					one_year_change: '+4.8%'
				},
				'Steveston Village': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Terra Nova': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Cambie': {
					sales: 17,
					active_listings: 169,
					benchmark_price: '$796,500',
					one_year_change: '-3.2%'
				},
				Westwind: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Woodwards: {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Boyd Park': {
					sales: 2,
					active_listings: 3,
					benchmark_price: '$753,400',
					one_year_change: '-6.8%'
				},
				'Bridgeport RI': {
					sales: 0,
					active_listings: 19,
					benchmark_price: '$1,117,900',
					one_year_change: '+2.7%'
				},
				Brighouse: {
					sales: 2,
					active_listings: 27,
					benchmark_price: '$1,063,400',
					one_year_change: '-1.7%'
				},
				'Brighouse South': {
					sales: 4,
					active_listings: 35,
					benchmark_price: '$1,027,400',
					one_year_change: '+3.7%'
				},
				Broadmoor: {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$1,096,400',
					one_year_change: '-7.3%'
				},
				'East Cambie': {
					sales: 0,
					active_listings: 14,
					benchmark_price: '$890,500',
					one_year_change: '+0.2%'
				},
				'East Richmond': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Garden City': {
					sales: 0,
					active_listings: 10,
					benchmark_price: '$1,123,000',
					one_year_change: '-6.5%'
				},
				Gilmore: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Granville: {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,098,500',
					one_year_change: '-0.8%'
				},
				'Hamilton RI': {
					sales: 1,
					active_listings: 19,
					benchmark_price: '$917,600',
					one_year_change: '+0.9%'
				},
				Ironwood: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,080,400',
					one_year_change: '-1.3%'
				},
				Lackner: {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,280,000',
					one_year_change: '-6.6%'
				},
				McLennan: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'McLennan North': {
					sales: 6,
					active_listings: 34,
					benchmark_price: '$1,221,800',
					one_year_change: '+0.7%'
				},
				McNair: {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$873,900',
					one_year_change: '+2.4%'
				},
				'Quilchena RI': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$837,900',
					one_year_change: '-6.8%'
				},
				'Riverdale RI': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,055,500',
					one_year_change: '-5.1%'
				},
				Saunders: {
					sales: 6,
					active_listings: 6,
					benchmark_price: '$1,025,800',
					one_year_change: '-6.9%'
				},
				'Sea Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Seafair: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$932,000',
					one_year_change: '-8.1%'
				},
				'South Arm': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$1,183,200',
					one_year_change: '-6.7%'
				},
				'Steveston North': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$923,300',
					one_year_change: '-5.4%'
				},
				'Steveston South': {
					sales: 5,
					active_listings: 13,
					benchmark_price: '$1,173,500',
					one_year_change: '-7.9%'
				},
				'Steveston Village': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$926,000',
					one_year_change: '-5.2%'
				},
				'Terra Nova': {
					sales: 0,
					active_listings: 13,
					benchmark_price: '$1,218,800',
					one_year_change: '-5.8%'
				},
				'West Cambie': {
					sales: 5,
					active_listings: 28,
					benchmark_price: '$1,198,500',
					one_year_change: '-2.1%'
				},
				Westwind: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$1,017,900',
					one_year_change: '-3.5%'
				},
				Woodwards: {
					sales: 2,
					active_listings: 9,
					benchmark_price: '$1,379,300',
					one_year_change: '-7.7%'
				}
			}
		},

		'Port Moody': {
			detached: {
				Anmore: {
					sales: 0,
					active_listings: 21,
					benchmark_price: '$3,124,100',
					one_year_change: '+ 5.6%'
				},
				'Barber Street': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$2,105,400',
					one_year_change: '- 0.7%'
				},
				Belcarra: {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'College Park PM': {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$1,646,000',
					one_year_change: '- 0.6%'
				},
				Glenayre: {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$1,668,500',
					one_year_change: '- 0.5%'
				},
				'Heritage Mountain': {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$2,019,500',
					one_year_change: '+ 4.5%'
				},
				'Heritage Woods PM': {
					sales: 1,
					active_listings: 18,
					benchmark_price: '$2,152,900',
					one_year_change: '+ 4.6%'
				},
				loco: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Mountain Meadows': {
					sales: 2,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'North Shore Pt Moody': {
					sales: 0,
					active_listings: 12,
					benchmark_price: '$1,881,600',
					one_year_change: '- 1.3%'
				},
				'Port Moody Centre': {
					sales: 1,
					active_listings: 13,
					benchmark_price: '$1,750,800',
					one_year_change: '- 2.8%'
				}
			},
			condos: {
				Anmore: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Barber Street': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Belcarra: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'College Park PM': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$492,200',
					one_year_change: '+ 0.3%'
				},
				Glenayre: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Heritage Mountain': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Heritage Woods PM': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				loco: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Mountain Meadows': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'North Shore Pt Moody': {
					sales: 4,
					active_listings: 18,
					benchmark_price: '$763,900',
					one_year_change: '- 1.3%'
				},
				'Port Moody Centre': {
					sales: 14,
					active_listings: 72,
					benchmark_price: '$719,900',
					one_year_change: '- 1.0%'
				}
			},
			townhomes: {
				Anmore: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Barber Street': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Belcarra: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'College Park PM': {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$877,200',
					one_year_change: '- 7.7%'
				},
				Glenayre: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Heritage Mountain': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,098,300',
					one_year_change: '+ 0.4%'
				},
				'Heritage Woods PM': {
					sales: 3,
					active_listings: 4,
					benchmark_price: '$1,110,400',
					one_year_change: '0.8%'
				},
				loco: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Mountain Meadows': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'North Shore Pt Moody': {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$768,300',
					one_year_change: '+ 1.1%'
				},
				'Port Moody Centre': {
					sales: 2,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Port Moody Centre': {
					sales: 3,
					active_listings: 6,
					benchmark_price: '$1,115,000',
					one_year_change: '- 0.3%'
				}
			}
		},

		'New Westminster': {
			detached: {
				Brunette: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Connaught Heights': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,649,300',
					one_year_change: '1.3%'
				},
				'Downtown NW': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Fraserview NW': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'GlenBrooke North': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$1,718,300',
					one_year_change: '+ 3.4%'
				},
				'Moody Park': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$1,617,000',
					one_year_change: '+ 1.7%'
				},
				'North Arm': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Quay: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Queens Park': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$2,049,500',
					one_year_change: '0.8%'
				},
				Queensborough: {
					sales: 2,
					active_listings: 25,
					benchmark_price: '$1,380,000',
					one_year_change: '- 7.1%'
				},
				Sapperton: {
					sales: 2,
					active_listings: 5,
					benchmark_price: '$1,459,400',
					one_year_change: '+ 4.5%'
				},
				'The Heights NW': {
					sales: 0,
					active_listings: 15,
					benchmark_price: '$1,576,900',
					one_year_change: '+ 4.7%'
				},
				'Uptown NW': {
					sales: 1,
					active_listings: 11,
					benchmark_price: '$1,395,800',
					one_year_change: '+ 0.7%'
				},
				'West End NW': {
					sales: 0,
					active_listings: 12,
					benchmark_price: '$1,540,500',
					one_year_change: '- 0.3%'
				},
				'North Surrey': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			condos: {
				Brunette: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Connaught Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Downtown NW': {
					sales: 23,
					active_listings: 72,
					benchmark_price: '$672,100',
					one_year_change: '- 0.0%'
				},
				'Fraserview NW': {
					sales: 6,
					active_listings: 21,
					benchmark_price: '$703,400',
					one_year_change: '+ 0.3%'
				},
				'GlenBrooke North': {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$604,800',
					one_year_change: '+ 0.5%'
				},
				'Moody Park': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'North Arm': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Quay: {
					sales: 13,
					active_listings: 103,
					benchmark_price: '$729,400',
					one_year_change: '+ 2.8%'
				},
				'Queens Park': {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$722,500',
					one_year_change: '+ 0.1%'
				},
				Queensborough: {
					sales: 4,
					active_listings: 24,
					benchmark_price: '$856,000',
					one_year_change: '- 3.1%'
				},
				Sapperton: {
					sales: 3,
					active_listings: 13,
					benchmark_price: '$551,700',
					one_year_change: '+ 2.0%'
				},
				'The Heights NW': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$580,800',
					one_year_change: '+ 0.9%'
				},
				'Uptown NW': {
					sales: 17,
					active_listings: 55,
					benchmark_price: '$574,700',
					one_year_change: '+ 0.5%'
				},
				'West End NW': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$416,900',
					one_year_change: '- 2.3%'
				},
				'North Surrey': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				Brunette: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Connaught Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Downtown NW': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$789,100',
					one_year_change: '+ 0.9%'
				},
				'Fraserview NW': {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$1,015,200',
					one_year_change: '+ 2.7%'
				},
				'GlenBrooke North': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$837,200',
					one_year_change: '+ 0.4%'
				},
				'Moody Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'North Arm': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Quay: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Queens Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queensborough: {
					sales: 5,
					active_listings: 14,
					benchmark_price: '$1,005,700',
					one_year_change: '+ 1.3%'
				},
				Sapperton: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'The Heights NW': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Uptown NW': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$750,100',
					one_year_change: '+ 0.1%'
				},
				'West End NW': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'North Surrey': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},

		'Burnaby East': {
			detached: {
				'East Burnaby': {
					sales: 1,
					active_listings: 14,
					benchmark_price: '$1,987,000',
					one_year_change: '+ 3.0%'
				},
				'Edmonds BE': {
					sales: 3,
					active_listings: 13,
					benchmark_price: '$1,794,500',
					one_year_change: '- 1.6%'
				},
				'The Crest': {
					sales: 2,
					active_listings: 9,
					benchmark_price: '$1,976,400',
					one_year_change: '+ 3.4%'
				}
			},
			condos: {
				'East Burnaby': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$639,700',
					one_year_change: '- 1.2%'
				},
				'Edmonds BE': {
					sales: 9,
					active_listings: 77,
					benchmark_price: '$788,700',
					one_year_change: '- 1.0%'
				},
				'The Crest': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'East Burnaby': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Edmonds BE': {
					sales: 4,
					active_listings: 17,
					benchmark_price: '$792,700',
					one_year_change: '+ 1.4%'
				},
				'The Crest': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$1,159,900',
					one_year_change: '+ 3.5%'
				}
			}
		},

		'Port Coquitlam': {
			detached: {
				'Birchland Manor': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$1,336,000',
					one_year_change: '+ 1.0%'
				},
				'Central Pt Coquitlam': {
					sales: 1,
					active_listings: 15,
					benchmark_price: '$1,301,700',
					one_year_change: '+ 0.9%'
				},
				'Citadel PQ': {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$1,507,200',
					one_year_change: '+ 2.6%'
				},
				'Glenwood PQ': {
					sales: 3,
					active_listings: 27,
					benchmark_price: '$1,352,200',
					one_year_change: '+ 1.9%'
				},
				'Lincoln Park PQ': {
					sales: 1,
					active_listings: 15,
					benchmark_price: '$1,324,900',
					one_year_change: '+ 1.3%'
				},
				'Lower Mary Hill': {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$1,315,900',
					one_year_change: '+ 3.1%'
				},
				'Mary Hill': {
					sales: 1,
					active_listings: 11,
					benchmark_price: '$1,383,200',
					one_year_change: '+ 2.1%'
				},
				'Oxford Heights': {
					sales: 5,
					active_listings: 20,
					benchmark_price: '$1,435,300',
					one_year_change: '+ 1.9%'
				},
				Riverwood: {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$1,554,400',
					one_year_change: '+ 3.1%'
				},
				'Woodland Acres PQ': {
					sales: 1,
					active_listings: 20,
					benchmark_price: '$1,475,700',
					one_year_change: '+ 3.2%'
				}
			},
			condos: {
				'Birchland Manor': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Central Pt Coquitlam': {
					sales: 21,
					active_listings: 60,
					benchmark_price: '$647,000',
					one_year_change: '- 1.4%'
				},
				'Citadel PQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Glenwood PQ': {
					sales: 5,
					active_listings: 19,
					benchmark_price: '$536,800',
					one_year_change: '- 5.6%'
				},
				'Lincoln Park PQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Lower Mary Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Mary Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Oxford Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Riverwood: {
					sales: 2,
					active_listings: 2,
					benchmark_price: '$688,700',
					one_year_change: '- 5.7%'
				},
				'Woodland Acres PQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				}
			},
			townhomes: {
				'Birchland Manor': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Central Pt Coquitlam': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$820,900',
					one_year_change: '- 0.3%'
				},
				'Citadel PQ': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$1,011,900',
					one_year_change: '+ 1.4%'
				},
				'Glenwood PQ': {
					sales: 1,
					active_listings: 8,
					benchmark_price: '$894,500',
					one_year_change: '+ 2.3%'
				},
				'Lincoln Park PQ': {
					sales: 6,
					active_listings: 20,
					benchmark_price: '$923,100',
					one_year_change: '+ 1.6%'
				},
				'Lower Mary Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Mary Hill': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$926,800',
					one_year_change: '- 0.6%'
				},
				'Oxford Heights': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$961,100',
					one_year_change: '+ 5.0%'
				},
				Riverwood: {
					sales: 5,
					active_listings: 20,
					benchmark_price: '$1,007,800',
					one_year_change: '+ 1.7%'
				},
				'Woodland Acres PQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				}
			}
		},

		'Pitt Meadows': {
			detached: {
				'Central Meadows': {
					sales: 2,
					active_listings: 18,
					benchmark_price: '$1,117,700',
					one_year_change: '-10.9%'
				},
				'Mid Meadows': {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$1,192,000',
					one_year_change: '-9.3%'
				},
				'North Meadows PI': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'South Meadows': {
					sales: 4,
					active_listings: 11,
					benchmark_price: '$1,212,400',
					one_year_change: '-11.1%'
				},
				'West Meadows': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			condos: {
				'Central Meadows': {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$546,100',
					one_year_change: '-1.0%'
				},
				'Mid Meadows': {
					sales: 2,
					active_listings: 9,
					benchmark_price: '$623,300',
					one_year_change: '-1.2%'
				},
				'North Meadows PI': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'South Meadows': {
					sales: 4,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Meadows': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Central Meadows': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$803,900',
					one_year_change: '+ 0.1%'
				},
				'Mid Meadows': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$777,100',
					one_year_change: '+ 0.1%'
				},
				'North Meadows Pl': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'South Meadows': {
					sales: 4,
					active_listings: 12,
					benchmark_price: '$888,400',
					one_year_change: '+ 1.8%'
				},
				'West Meadows': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},

		'North Vancouver': {
			detached: {
				'Blueridge NV': {
					sales: 4,
					active_listings: 7,
					benchmark_price: '$2,171,800',
					one_year_change: '+ 2.0%'
				},
				Boulevard: {
					sales: 2,
					active_listings: 13,
					benchmark_price: '$2,390,000',
					one_year_change: '- 0.1%'
				},
				Braemar: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Calverhall: {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$2,004,100',
					one_year_change: '+ 1.5%'
				},
				'Canyon Heights NV': {
					sales: 4,
					active_listings: 26,
					benchmark_price: '$2,463,000',
					one_year_change: '+ 5.6%'
				},
				'Capilano NV': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$2,440,100',
					one_year_change: '+ 9.0%'
				},
				'Central Lonsdale': {
					sales: 8,
					active_listings: 12,
					benchmark_price: '$2,054,300',
					one_year_change: '- 3.3%'
				},
				'Deep Cove': {
					sales: 0,
					active_listings: 15,
					benchmark_price: '$1,946,100',
					one_year_change: '+ 0.4%'
				},
				Delbrook: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$2,390,700',
					one_year_change: '+ 3.3%'
				},
				Dollarton: {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$2,515,100',
					one_year_change: '1.0%'
				},
				Edgemont: {
					sales: 2,
					active_listings: 13,
					benchmark_price: '$3,016,900',
					one_year_change: '+ 2.3%'
				},
				'Forest Hills NV': {
					sales: 0,
					active_listings: 10,
					benchmark_price: '$3,264,000',
					one_year_change: '+ 8.6%'
				},
				'Grouse Woods': {
					sales: 3,
					active_listings: 1,
					benchmark_price: '$2,382,400',
					one_year_change: '+ 2.2%'
				},
				Harbourside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Indian Arm': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Indian River': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,953,700',
					one_year_change: '+ 1.0%'
				},
				'Lower Lonsdale': {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$2,247,500',
					one_year_change: '6.4%'
				},
				'Lynn Valley': {
					sales: 8,
					active_listings: 21,
					benchmark_price: '$2,056,400',
					one_year_change: '+ 4.7%'
				},
				Lynnmour: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Mosquito Creek': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Norgate: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,747,600',
					one_year_change: '+ 2.6%'
				},
				Northlands: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pemberton Heights': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$2,310,500',
					one_year_change: '4.7%'
				},
				'Pemberton NV': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,663,000',
					one_year_change: '0.8%'
				},
				'Princess Park': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$2,152,100',
					one_year_change: '+ 3.8%'
				},
				Queensbury: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,937,700',
					one_year_change: '+ 1.0%'
				},
				'Roche Point': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$1,775,400',
					one_year_change: '+ 0.6%'
				},
				'Seymour NV': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,967,500',
					one_year_change: '+ 4.8%'
				},
				Tempe: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$2,368,200',
					one_year_change: '+ 7.5%'
				},
				'Upper Delbrook': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$2,426,700',
					one_year_change: '+ 3.0%'
				},
				'Upper Lonsdale': {
					sales: 8,
					active_listings: 21,
					benchmark_price: '$2,238,800',
					one_year_change: '+ 4.2%'
				},
				Westlynn: {
					sales: 4,
					active_listings: 7,
					benchmark_price: '$1,860,700',
					one_year_change: '+ 3.8%'
				},
				'Westlynn Terrace': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Windsor Park NV': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$1,966,500',
					one_year_change: '- 1.3%'
				},
				'Woodlands-Sunshine-Cascade': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			condos: {
				'Blueridge NV': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Boulevard: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Braemar: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Calverhall: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Canyon Heights NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Capilano NV': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,032,400',
					one_year_change: '- 8.3%'
				},
				'Central Lonsdale': {
					sales: 7,
					active_listings: 53,
					benchmark_price: '$815,700',
					one_year_change: '- 2.4%'
				},
				'Deep Cove': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Delbrook: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dollarton: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Edgemont: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,214,800',
					one_year_change: '- 6.8%'
				},
				'Forest Hills NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Grouse Woods': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Harbourside: {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$928,500',
					one_year_change: '- 7.7%'
				},
				'Indian Arm': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Indian River': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$921,000',
					one_year_change: '+ 4.1%'
				},
				'Lower Lonsdale': {
					sales: 23,
					active_listings: 75,
					benchmark_price: '$789,000',
					one_year_change: '- 2.4%'
				},
				'Lynn Valley': {
					sales: 8,
					active_listings: 37,
					benchmark_price: '$937,700',
					one_year_change: '+ 3.3%'
				},
				Lynnmour: {
					sales: 11,
					active_listings: 42,
					benchmark_price: '$936,700',
					one_year_change: '+ 3.0%'
				},
				'Mosquito Creek': {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$698,600',
					one_year_change: '- 1.7%'
				},
				Norgate: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$810,500',
					one_year_change: '- 7.2%'
				},
				Northlands: {
					sales: 4,
					active_listings: 3,
					benchmark_price: '$1,038,500',
					one_year_change: '+ 4.0%'
				},
				'Pemberton Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pemberton NV': {
					sales: 7,
					active_listings: 52,
					benchmark_price: '$508,400',
					one_year_change: '8.2%'
				},
				'Princess Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queensbury: {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Roche Point': {
					sales: 7,
					active_listings: 15,
					benchmark_price: '$814,400',
					one_year_change: '+ 5.6%'
				},
				'Seymour NV': {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Tempe: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Delbrook': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Lonsdale': {
					sales: 3,
					active_listings: 2,
					benchmark_price: '$723,700',
					one_year_change: '+ 4.0%'
				},
				Westlynn: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Westlynn Terrace': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Windsor Park NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Woodlands-Sunshine-Cascade': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Blueridge NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Boulevard: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Braemar: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Calverhall: {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Canyon Heights NV': {
					sales: 15,
					active_listings: 48,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Capilano NV': {
					sales: 4,
					active_listings: 42,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central Lonsdale': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,409,600',
					one_year_change: '+ 7.3%'
				},
				'Deep Cove': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Delbrook: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dollarton: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Edgemont: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$1,938,900',
					one_year_change: '+ 7.6%'
				},
				'Forest Hills NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Grouse Woods': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Harbourside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Indian Arm': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Indian River': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,430,600',
					one_year_change: '- 4.5%'
				},
				'Lower Lonsdale': {
					sales: 2,
					active_listings: 31,
					benchmark_price: '$1,487,300',
					one_year_change: '+ 6.9%'
				},
				'Lynn Valley': {
					sales: 3,
					active_listings: 9,
					benchmark_price: '$1,128,200',
					one_year_change: '- 4.9%'
				},
				Lynnmour: {
					sales: 4,
					active_listings: 13,
					benchmark_price: '$1,163,200',
					one_year_change: '- 4.1%'
				},
				'Mosquito Creek': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,265,000',
					one_year_change: '+ 6.8%'
				},
				Norgate: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,240,900',
					one_year_change: '+ 8.0%'
				},
				Northlands: {
					sales: 2,
					active_listings: 2,
					benchmark_price: '$1,442,600',
					one_year_change: '- 4.8%'
				},
				'Pemberton Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pemberton NV': {
					sales: 1,
					active_listings: 15,
					benchmark_price: '$1,530,200',
					one_year_change: '+ 7.7%'
				},
				'Princess Park': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queensbury: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Roche Point': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$1,360,700',
					one_year_change: '- 4.0%'
				},
				'Seymour NV': {
					sales: 3,
					active_listings: 1,
					benchmark_price: '$1,259,600',
					one_year_change: '- 3.4%'
				},
				Tempe: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Delbrook': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Lonsdale': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$1,155,400',
					one_year_change: '+ 8.3%'
				},
				Westlynn: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$1,252,400',
					one_year_change: '- 4.4%'
				},
				'Westlynn Terrace': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Windsor Park NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Woodlands-Sunshine-Cascade': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},

		'Vancouver West': {
			detached: {
				Arbutus: {
					sales: 2,
					active_listings: 25,
					benchmark_price: '$3,606,400',
					one_year_change: '-6.3%'
				},
				Cambie: {
					sales: 1,
					active_listings: 61,
					benchmark_price: '$2,916,200',
					one_year_change: '-1.1%'
				},
				'Coal Harbour': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Downtown VW': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dunbar: {
					sales: 7,
					active_listings: 75,
					benchmark_price: '$3,334,500',
					one_year_change: '-0.6%'
				},
				'Fairview VW': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'False Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Kerrisdale: {
					sales: 1,
					active_listings: 25,
					benchmark_price: '$3,796,000',
					one_year_change: '+5.3%'
				},
				Kitsilano: {
					sales: 4,
					active_listings: 33,
					benchmark_price: '$2,606,700',
					one_year_change: '-6.2%'
				},
				'MacKenzie Heights': {
					sales: 4,
					active_listings: 19,
					benchmark_price: '$3,947,900',
					one_year_change: '+4.5%'
				},
				Marpole: {
					sales: 3,
					active_listings: 38,
					benchmark_price: '$2,505,700',
					one_year_change: '+3.6%'
				},
				'Mount Pleasant VW': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$2,349,400',
					one_year_change: '+5.8%'
				},
				'Oakridge VW': {
					sales: 0,
					active_listings: 15,
					benchmark_price: '$3,658,100',
					one_year_change: '+8.8%'
				},
				'Point Grey': {
					sales: 5,
					active_listings: 87,
					benchmark_price: '$3,382,000',
					one_year_change: '+8.9%'
				},
				Quilchena: {
					sales: 2,
					active_listings: 21,
					benchmark_price: '$4,188,600',
					one_year_change: '-4.0%'
				},
				'S.W. Marine': {
					sales: 0,
					active_listings: 25,
					benchmark_price: '$3,387,700',
					one_year_change: '+6.7%'
				},
				Shaughnessy: {
					sales: 1,
					active_listings: 69,
					benchmark_price: '$4,770,900',
					one_year_change: '+2.8%'
				},
				'South Cambie': {
					sales: 0,
					active_listings: 9,
					benchmark_price: '$4,763,100',
					one_year_change: '+2.4%'
				},
				'South Granville': {
					sales: 2,
					active_listings: 77,
					benchmark_price: '$4,369,000',
					one_year_change: '+1.5%'
				},
				Southlands: {
					sales: 2,
					active_listings: 37,
					benchmark_price: '$3,770,500',
					one_year_change: '+4.4%'
				},
				'University VW': {
					sales: 1,
					active_listings: 21,
					benchmark_price: '$2,807,600',
					one_year_change: '+10.7%'
				},
				'West End W': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Yaletown: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			condos: {
				Arbutus: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cambie: {
					sales: 9,
					active_listings: 80,
					benchmark_price: '$1,143,300',
					one_year_change: '+0.4%'
				},
				'Coal Harbour': {
					sales: 7,
					active_listings: 140,
					benchmark_price: '$1,075,600',
					one_year_change: '-15.5%'
				},
				'Downtown VW': {
					sales: 48,
					active_listings: 483,
					benchmark_price: '$691,800',
					one_year_change: '-1.5%'
				},
				Dunbar: {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$1,036,700',
					one_year_change: '+4.0%'
				},
				'Fairview VW': {
					sales: 21,
					active_listings: 82,
					benchmark_price: '$812,200',
					one_year_change: '-0.7%'
				},
				'False Creek': {
					sales: 21,
					active_listings: 88,
					benchmark_price: '$903,100',
					one_year_change: '+6.4%'
				},
				Kerrisdale: {
					sales: 1,
					active_listings: 32,
					benchmark_price: '$1,145,700',
					one_year_change: '+1.2%'
				},
				Kitsilano: {
					sales: 27,
					active_listings: 52,
					benchmark_price: '$738,700',
					one_year_change: '+0.0%'
				},
				'MacKenzie Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Marpole: {
					sales: 10,
					active_listings: 91,
					benchmark_price: '$684,000',
					one_year_change: '-0.8%'
				},
				'Mount Pleasant VW': {
					sales: 3,
					active_listings: 6,
					benchmark_price: '$818,300',
					one_year_change: '+7.3%'
				},
				'Oakridge VW': {
					sales: 7,
					active_listings: 26,
					benchmark_price: '$990,000',
					one_year_change: '+1.6%'
				},
				'Point Grey': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$876,700',
					one_year_change: '+0.8%'
				},
				Quilchena: {
					sales: 3,
					active_listings: 14,
					benchmark_price: '$1,285,700',
					one_year_change: '+2.8%'
				},
				'S.W. Marine': {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$725,300',
					one_year_change: '-0.1%'
				},
				Shaughnessy: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$1,215,700',
					one_year_change: '+2.7%'
				},
				'South Cambie': {
					sales: 0,
					active_listings: 52,
					benchmark_price: '$1,141,600',
					one_year_change: '-0.3%'
				},
				'South Granville': {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$1,219,900',
					one_year_change: '+1.3%'
				},
				Southlands: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,003,000',
					one_year_change: '+3.9%'
				},
				'University VW': {
					sales: 16,
					active_listings: 108,
					benchmark_price: '$1,017,500',
					one_year_change: '-8.9%'
				},
				'West End W': {
					sales: 27,
					active_listings: 207,
					benchmark_price: '$613,000',
					one_year_change: '-1.3%'
				},
				Yaletown: {
					sales: 34,
					active_listings: 233,
					benchmark_price: '$802,600',
					one_year_change: '-8.8%'
				}
			},
			townhomes: {
				Arbutus: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cambie: {
					sales: 3,
					active_listings: 44,
					benchmark_price: '$1,725,300',
					one_year_change: '-2.0%'
				},
				'Coal Harbour': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,760,300',
					one_year_change: '+7.0%'
				},
				'Downtown VW': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$1,193,000',
					one_year_change: '+10.9%'
				},
				Dunbar: {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Fairview VW': {
					sales: 4,
					active_listings: 18,
					benchmark_price: '$1,101,800',
					one_year_change: '+9.2%'
				},
				'False Creek': {
					sales: 3,
					active_listings: 6,
					benchmark_price: '$1,074,400',
					one_year_change: '-4.3%'
				},
				Kerrisdale: {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$1,648,300',
					one_year_change: '-0.9%'
				},
				Kitsilano: {
					sales: 2,
					active_listings: 25,
					benchmark_price: '$1,176,300',
					one_year_change: '-11.4%'
				},
				'MacKenzie Heights': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Marpole: {
					sales: 1,
					active_listings: 27,
					benchmark_price: '$1,605,600',
					one_year_change: '-1.7%'
				},
				'Mount Pleasant VW': {
					sales: 3,
					active_listings: 4,
					benchmark_price: '$1,316,800',
					one_year_change: '+10.7%'
				},
				'Oakridge VW': {
					sales: 1,
					active_listings: 12,
					benchmark_price: '$1,657,200',
					one_year_change: '+0.4%'
				},
				'Point Grey': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$1,316,100',
					one_year_change: '-1.3%'
				},
				Quilchena: {
					sales: 2,
					active_listings: 3,
					benchmark_price: '$1,502,300',
					one_year_change: '-4.0%'
				},
				'S.W. Marine': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Shaughnessy: {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$1,914,800',
					one_year_change: '-0.1%'
				},
				'South Cambie': {
					sales: 1,
					active_listings: 23,
					benchmark_price: '$1,607,300',
					one_year_change: '+2.8%'
				},
				'South Granville': {
					sales: 1,
					active_listings: 31,
					benchmark_price: '$1,604,100',
					one_year_change: '-7.2%'
				},
				Southlands: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'University VW': {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$1,750,800',
					one_year_change: '+1.0%'
				},
				'West End W': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$1,222,000',
					one_year_change: '+10.4%'
				},
				Yaletown: {
					sales: 1,
					active_listings: 13,
					benchmark_price: '$1,807,900',
					one_year_change: '+7.6%'
				}
			}
		},

		Coquitlam: {
			detached: {
				'Burke Mountain': {
					sales: 6,
					active_listings: 37,
					benchmark_price: '$2,178,600',
					one_year_change: '+ 1.7%'
				},
				'Canyon Springs': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$1,450,100',
					one_year_change: '- 2.6%'
				},
				'Cape Horn': {
					sales: 1,
					active_listings: 12,
					benchmark_price: '$1,497,900',
					one_year_change: '- 0.8%'
				},
				'Central Coquitlam': {
					sales: 9,
					active_listings: 33,
					benchmark_price: '$1,845,300',
					one_year_change: '- 1.5%'
				},
				Chineside: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$1,742,300',
					one_year_change: '- 1.1%'
				},
				'Coquitlam East': {
					sales: 7,
					active_listings: 21,
					benchmark_price: '$1,691,500',
					one_year_change: '+ 2.2%'
				},
				'Coquitlam West': {
					sales: 5,
					active_listings: 81,
					benchmark_price: '$1,865,500',
					one_year_change: '- 1.5%'
				},
				'Eagle Ridge CQ': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,281,700',
					one_year_change: '- 0.5%'
				},
				'Harbour Chines': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$2,115,500',
					one_year_change: '- 3.7%'
				},
				'Harbour Place': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,818,800',
					one_year_change: '- 3.1%'
				},
				Hockaday: {
					sales: 1,
					active_listings: 8,
					benchmark_price: '$1,794,000',
					one_year_change: '+ 0.7%'
				},
				Maillardville: {
					sales: 2,
					active_listings: 20,
					benchmark_price: '$1,808,300',
					one_year_change: '- 3.5%'
				},
				'Meadow Brook': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$1,113,700',
					one_year_change: '- 1.7%'
				},
				'New Horizons': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$1,348,900',
					one_year_change: '+ 1.6%'
				},
				'North Coquitlam': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Park Ridge Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ranch Park': {
					sales: 1,
					active_listings: 108,
					benchmark_price: '$1,622,300',
					one_year_change: '+ 0.4%'
				},
				'River Springs': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$1,291,200',
					one_year_change: '+ 2.0%'
				},
				'Scott Creek': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$1,731,200',
					one_year_change: '- 2.9%'
				},
				'Summitt View': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Eagle Ridge': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,661,400',
					one_year_change: '- 1.9%'
				},
				'Westwood Plateau': {
					sales: 4,
					active_listings: 42,
					benchmark_price: '$1,921,300',
					one_year_change: '+ 1.3%'
				},
				'Westwood Summit CQ': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			condos: {
				'Burke Mountain': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Canyon Springs': {
					sales: 2,
					active_listings: 4,
					benchmark_price: '$661,500',
					one_year_change: '+ 6.7%'
				},
				'Cape Horn': {
					sales: 0,
					active_listings: 9,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Central Coquitlam': {
					sales: 4,
					active_listings: 44,
					benchmark_price: '$583,600',
					one_year_change: '- 1.9%'
				},
				Chineside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Coquitlam East': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$586,200',
					one_year_change: '- 2.1%'
				},
				'Coquitlam West': {
					sales: 51,
					active_listings: 255,
					benchmark_price: '$752,900',
					one_year_change: '- 3.7%'
				},
				'Eagle Ridge CQ': {
					sales: 2,
					active_listings: 2,
					benchmark_price: '$672,600',
					one_year_change: '0.8%'
				},
				'Harbour Chines': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Harbour Place': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Hockaday: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Maillardville: {
					sales: 3,
					active_listings: 28,
					benchmark_price: '$492,600',
					one_year_change: '+ 0.8%'
				},
				'Meadow Brook': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'New Horizons': {
					sales: 4,
					active_listings: 22,
					benchmark_price: '$792,200',
					one_year_change: '- 6.9%'
				},
				'North Coquitlam': {
					sales: 16,
					active_listings: 90,
					benchmark_price: '$753,300',
					one_year_change: '+ 2.2%'
				},
				'Park Ridge Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Ranch Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'River Springs': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Scott Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Summitt View': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Upper Eagle Ridge': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Westwood Plateau': {
					sales: 5,
					active_listings: 14,
					benchmark_price: '$753,200',
					one_year_change: '+ 6.1%'
				},
				'Westwood Summit CQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				}
			},
			townhomes: {
				'Burke Mountain': {
					sales: 16,
					active_listings: 62,
					benchmark_price: '$1,215,800',
					one_year_change: '+ 3.8%'
				},
				'Canyon Springs': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$731,400',
					one_year_change: '+ 0.2%'
				},
				'Cape Horn': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central Coquitlam': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$673,100',
					one_year_change: '- 10.1%'
				},
				Chineside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Coquitlam East': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$782,600',
					one_year_change: '- 7.5%'
				},
				'Coquitlam West': {
					sales: 5,
					active_listings: 38,
					benchmark_price: '$955,000',
					one_year_change: '- 9.1%'
				},
				'Eagle Ridge CQ': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$972,300',
					one_year_change: '+ 2.6%'
				},
				'Harbour Chines': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Harbour Place': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Hockaday: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Maillardville: {
					sales: 2,
					active_listings: 14,
					benchmark_price: '$714,300',
					one_year_change: '- 6.2%'
				},
				'Meadow Brook': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'New Horizons': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,169,400',
					one_year_change: '+ 2.2%'
				},
				'North Coquitlam': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Park Ridge Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ranch Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$701,300',
					one_year_change: '- 6.7%'
				},
				'River Springs': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Scott Creek': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,074,700',
					one_year_change: '+ 0.5%'
				},
				'Summitt View': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Eagle Ridge': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$840,500',
					one_year_change: '+ 1.5%'
				},
				'Westwood Plateau': {
					sales: 6,
					active_listings: 13,
					benchmark_price: '$1,172,500',
					one_year_change: '- 1.2%'
				},
				'Westwood Summit CQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		'Burnaby South': {
			detached: {
				'Big Bend': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Buckingham Heights': {
					sales: 3,
					active_listings: 4,
					benchmark_price: '$2,995,600',
					one_year_change: '+ 5.8%'
				},
				'Burnaby Hospital': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$2,152,400',
					one_year_change: '+ 2.5%'
				},
				'Burnaby Lake': {
					sales: 1,
					active_listings: 14,
					benchmark_price: '$2,122,000',
					one_year_change: '+ 3.2%'
				},
				'Central Park BS': {
					sales: 0,
					active_listings: 17,
					benchmark_price: '$1,977,400',
					one_year_change: '+ 7.5%'
				},
				'Deer Lake': {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$3,357,000',
					one_year_change: '+ 1.3%'
				},
				'Deer Lake Place': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$2,212,000',
					one_year_change: '+ 7.6%'
				},
				'Forest Glen BS': {
					sales: 2,
					active_listings: 13,
					benchmark_price: '$2,276,100',
					one_year_change: '+ 3.9%'
				},
				'Garden Village': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$2,295,700',
					one_year_change: '+ 6.6%'
				},
				'Greentree Village': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Highgate: {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$1,924,300',
					one_year_change: '- 3.0%'
				},
				Metrotown: {
					sales: 0,
					active_listings: 10,
					benchmark_price: '$2,160,900',
					one_year_change: '- 5.6%'
				},
				Oaklands: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'South Slope': {
					sales: 2,
					active_listings: 26,
					benchmark_price: '$2,056,400',
					one_year_change: '- 3.8%'
				},
				Suncrest: {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$2,115,300',
					one_year_change: '- 0.3%'
				},
				'Upper Deer Lake': {
					sales: 2,
					active_listings: 14,
					benchmark_price: '$2,344,500',
					one_year_change: '+ 3.4%'
				}
			},
			condos: {
				'Big Bend': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Buckingham Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Burnaby Hospital': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$642,100',
					one_year_change: '- 0.4%'
				},
				'Burnaby Lake': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central Park BS': {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$638,900',
					one_year_change: '- 2.1%'
				},
				'Deer Lake': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Deer Lake Place': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Forest Glen BS': {
					sales: 3,
					active_listings: 26,
					benchmark_price: '$794,500',
					one_year_change: '- 2.9%'
				},
				'Garden Village': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Greentree Village': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Highgate: {
					sales: 10,
					active_listings: 29,
					benchmark_price: '$750,300',
					one_year_change: '- 1.8%'
				},
				Metrotown: {
					sales: 34,
					active_listings: 308,
					benchmark_price: '$875,100',
					one_year_change: '- 3.4%'
				},
				Oaklands: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$720,500',
					one_year_change: '- 1.4%'
				},
				'South Slope': {
					sales: 3,
					active_listings: 17,
					benchmark_price: '$748,400',
					one_year_change: '+ 3.1%'
				},
				Suncrest: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Deer Lake': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Big Bend': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Buckingham Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Burnaby Hospital': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$986,600',
					one_year_change: '+ 6.3%'
				},
				'Burnaby Lake': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,204,700',
					one_year_change: '+ 3.0%'
				},
				'Central Park BS': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$1,043,300',
					one_year_change: '+ 4.8%'
				},
				'Deer Lake': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Deer Lake Place': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Forest Glen BS': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,008,800',
					one_year_change: '+ 5.2%'
				},
				'Garden Village': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Greentree Village': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$975,100',
					one_year_change: '+ 8.1%'
				},
				Highgate: {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$915,900',
					one_year_change: '+ 0.3%'
				},
				Metrotown: {
					sales: 4,
					active_listings: 16,
					benchmark_price: '$1,221,200',
					one_year_change: '+ 5.0%'
				},
				Oaklands: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$1,553,500',
					one_year_change: '+ 4.5%'
				},
				'South Slope': {
					sales: 2,
					active_listings: 5,
					benchmark_price: '$1,108,300',
					one_year_change: '+ 5.8%'
				},
				Suncrest: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Deer Lake': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},

		Ladner: {
			detached: {
				'Annacis Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Delta Manor': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,361,200',
					one_year_change: '+ 3.7%'
				},
				'East Delta': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: null
				},
				Hawthorne: {
					sales: 4,
					active_listings: 19,
					benchmark_price: '$1,449,900',
					one_year_change: '+ 3.4%'
				},
				Holly: {
					sales: 3,
					active_listings: 17,
					benchmark_price: '$1,443,300',
					one_year_change: '+ 2.0%'
				},
				'Ladner Elementary': {
					sales: 0,
					active_listings: 13,
					benchmark_price: '$1,322,100',
					one_year_change: '+ 3.1%'
				},
				'Ladner Rural': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Neilsen Grove': {
					sales: 3,
					active_listings: 5,
					benchmark_price: '$1,397,900',
					one_year_change: '+ 3.9%'
				},
				'Port Guichon': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$1,335,700',
					one_year_change: '+ 4.7%'
				},
				Tilbury: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Westham Island': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: null
				}
			},
			condos: {
				'Annacis Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Delta Manor': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$557,900',
					one_year_change: '- 7.7%'
				},
				'East Delta': {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Hawthorne: {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$598,300',
					one_year_change: '- 6.4%'
				},
				Holly: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Ladner Elementary': {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$650,600',
					one_year_change: '8.9%'
				},
				'Ladner Rural': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Neilsen Grove': {
					sales: 2,
					active_listings: 4,
					benchmark_price: '$850,900',
					one_year_change: '- 8.9%'
				},
				'Port Guichon': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Tilbury: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Westham Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				}
			},
			townhomes: {
				'Annacis Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Delta Manor': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$967,300',
					one_year_change: '+ 1.7%'
				},
				'East Delta': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: null
				},
				Hawthorne: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$852,900',
					one_year_change: '+ 1.7%'
				},
				Holly: {
					sales: 2,
					active_listings: 2,
					benchmark_price: '$874,800',
					one_year_change: '+ 0.2%'
				},
				'Ladner Elementary': {
					sales: 1,
					active_listings: 8,
					benchmark_price: '$807,100',
					one_year_change: '+ 0.4%'
				},
				'Ladner Rural': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Neilsen Grove': {
					sales: 6,
					active_listings: 19,
					benchmark_price: '$1,164,700',
					one_year_change: '+ 4.5%'
				},
				'Port Guichon': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Tilbury: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Westham Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				}
			}
		},
		'Burnaby North': {
			detached: {
				'Brentwood Park': {
					sales: 2,
					active_listings: 13,
					benchmark_price: '$1,997,500',
					one_year_change: '-3.5%'
				},
				'Capitol Hill BN': {
					sales: 3,
					active_listings: 12,
					benchmark_price: '$2,038,900',
					one_year_change: '+1.4%'
				},
				Cariboo: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central BN': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$1,864,900',
					one_year_change: '+7.2%'
				},
				'Forest Hills BN': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Government Road': {
					sales: 2,
					active_listings: 17,
					benchmark_price: '$2,361,600',
					one_year_change: '+3.4%'
				},
				'Lake City Industrial': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Montecito: {
					sales: 1,
					active_listings: 13,
					benchmark_price: '$2,057,400',
					one_year_change: '+0.8%'
				},
				Oakdale: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Parkcrest: {
					sales: 3,
					active_listings: 34,
					benchmark_price: '$2,082,100',
					one_year_change: '+0.3%'
				},
				'Simon Fraser Hills': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Simon Fraser Univer.': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$2,352,200',
					one_year_change: '+6.1%'
				},
				'Sperling-Duthie': {
					sales: 3,
					active_listings: 12,
					benchmark_price: '$2,087,900',
					one_year_change: '+0.7%'
				},
				'Sullivan Heights': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Vancouver Heights': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$2,061,400',
					one_year_change: '+2.2%'
				},
				'Westridge BN': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$2,449,700',
					one_year_change: '-1.8%'
				},
				'Willingdon Heights': {
					sales: 2,
					active_listings: 14,
					benchmark_price: '$1,946,400',
					one_year_change: '+4.4%'
				}
			},
			condos: {
				'Brentwood Park': {
					sales: 40,
					active_listings: 345,
					benchmark_price: '$798,500',
					one_year_change: '-5.7%'
				},
				'Capitol Hill BN': {
					sales: 2,
					active_listings: 21,
					benchmark_price: '$554,500',
					one_year_change: '-2.5%'
				},
				Cariboo: {
					sales: 3,
					active_listings: 10,
					benchmark_price: '$536,700',
					one_year_change: '+1.0%'
				},
				'Central BN': {
					sales: 3,
					active_listings: 2,
					benchmark_price: '$760,000',
					one_year_change: '-2.5%'
				},
				'Forest Hills BN': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Government Road': {
					sales: 1,
					active_listings: 11,
					benchmark_price: '$589,000',
					one_year_change: '+0.2%'
				},
				'Lake City Industrial': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Montecito: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Oakdale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Parkcrest: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$836,200',
					one_year_change: '-2.9%'
				},
				'Simon Fraser Hills': {
					sales: 2,
					active_listings: 1,
					benchmark_price: '$472,700',
					one_year_change: '-3.2%'
				},
				'Simon Fraser Univer.': {
					sales: 10,
					active_listings: 69,
					benchmark_price: '$639,500',
					one_year_change: '-3.1%'
				},
				'Sperling-Duthie': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sullivan Heights': {
					sales: 10,
					active_listings: 58,
					benchmark_price: '$664,400',
					one_year_change: '+0.4%'
				},
				'Vancouver Heights': {
					sales: 3,
					active_listings: 8,
					benchmark_price: '$796,100',
					one_year_change: '-2.3%'
				},
				'Westridge BN': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Willingdon Heights': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$618,600',
					one_year_change: '-2.2%'
				}
			},
			townhomes: {
				'Brentwood Park': {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$1,066,600',
					one_year_change: '+1.1%'
				},
				'Capitol Hill BN': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$859,200',
					one_year_change: '+4.7%'
				},
				Cariboo: {
					sales: 3,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central BN': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$974,100',
					one_year_change: '+3.1%'
				},
				'Forest Hills BN': {
					sales: 3,
					active_listings: 4,
					benchmark_price: '$997,500',
					one_year_change: '+1.3%'
				},
				'Government Road': {
					sales: 2,
					active_listings: 4,
					benchmark_price: '$1,097,600',
					one_year_change: '+1.7%'
				},
				'Lake City Industrial': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Montecito: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$751,600',
					one_year_change: '-0.3%'
				},
				Oakdale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Parkcrest: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Simon Fraser Hills': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$816,200',
					one_year_change: '+2.5%'
				},
				'Simon Fraser Univer.': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$771,600',
					one_year_change: '-2.0%'
				},
				'Sperling-Duthie': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sullivan Heights': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$799,000',
					one_year_change: '-2.4%'
				},
				'Vancouver Heights': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$1,010,300',
					one_year_change: '+2.5%'
				},
				'Westridge BN': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$716,400',
					one_year_change: '-1.0%'
				},
				'Willingdon Heights': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$1,016,400',
					one_year_change: '+3.5%'
				}
			}
		},

		'West Vancouver': {
			detached: {
				Altamont: {
					sales: 0,
					active_listings: 14,
					benchmark_price: '$5,120,800',
					one_year_change: '- 2.8%'
				},
				Ambleside: {
					sales: 3,
					active_listings: 36,
					benchmark_price: '$2,814,200',
					one_year_change: '+ 3.6%'
				},
				Bayridge: {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$3,053,600',
					one_year_change: '+ 5.4%'
				},
				'British Properties': {
					sales: 4,
					active_listings: 79,
					benchmark_price: '$3,146,400',
					one_year_change: '- 5.8%'
				},
				'Canterbury WV': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Caulfeild: {
					sales: 2,
					active_listings: 27,
					benchmark_price: '$3,184,400',
					one_year_change: '+ 6.0%'
				},
				Cedardale: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$2,376,200',
					one_year_change: '- 6.9%'
				},
				Chartwell: {
					sales: 0,
					active_listings: 35,
					benchmark_price: '$4,907,500',
					one_year_change: '- 12.5%'
				},
				'Chelsea Park': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cypress: {
					sales: 1,
					active_listings: 11,
					benchmark_price: '$4,107,000',
					one_year_change: '+ 2.3%'
				},
				'Cypress Park Estates': {
					sales: 1,
					active_listings: 17,
					benchmark_price: '$3,038,100',
					one_year_change: '- 1.6%'
				},
				'Deer Ridge WV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dundarave: {
					sales: 2,
					active_listings: 23,
					benchmark_price: '$3,317,800',
					one_year_change: '- 2.0%'
				},
				'Eagle Harbour': {
					sales: 0,
					active_listings: 12,
					benchmark_price: '$2,465,500',
					one_year_change: '+ 8.9%'
				},
				Eagleridge: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Furry Creek': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Gleneagles: {
					sales: 0,
					active_listings: 9,
					benchmark_price: '$3,019,300',
					one_year_change: '+ 4.9%'
				},
				Glenmore: {
					sales: 0,
					active_listings: 20,
					benchmark_price: '$2,196,400',
					one_year_change: '+ 0.9%'
				},
				'Horseshoe Bay WV': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$2,053,400',
					one_year_change: '+ 3.1%'
				},
				'Howe Sound': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Lions Bay': {
					sales: 1,
					active_listings: 18,
					benchmark_price: '$2,163,100',
					one_year_change: '+ 5.6%'
				},
				'Olde Caulfeild': {
					sales: 2,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Panorama Village': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Park Royal': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Passage Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queens: {
					sales: 4,
					active_listings: 9,
					benchmark_price: '$3,304,500',
					one_year_change: '+ 2.0%'
				},
				Rockridge: {
					sales: 1,
					active_listings: 8,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sandy Cove': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sentinel Hill': {
					sales: 0,
					active_listings: 19,
					benchmark_price: '$2,722,500',
					one_year_change: '- 3.0%'
				},
				'Upper Caulfeild': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$3,200,900',
					one_year_change: '+ 5.4%'
				},
				'West Bay': {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$3,871,900',
					one_year_change: '+ 2.9%'
				},
				Westhill: {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Westmount WV': {
					sales: 1,
					active_listings: 12,
					benchmark_price: '$4,653,800',
					one_year_change: '+ 3.4%'
				},
				'Whitby Estates': {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Whytecliff: {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$2,622,000',
					one_year_change: '+ 6.9%'
				}
			},
			condos: {
				Altamont: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Ambleside: {
					sales: 3,
					active_listings: 24,
					benchmark_price: '$910,100',
					one_year_change: '- 14.5%'
				},
				Bayridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'British Properties': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Canterbury WV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Caulfeild: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cedardale: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Chartwell: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Chelsea Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cypress: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cypress Park Estates': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$2,040,900',
					one_year_change: '- 7.3%'
				},
				'Deer Ridge WV': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dundarave: {
					sales: 1,
					active_listings: 17,
					benchmark_price: '$1,461,100',
					one_year_change: '- 6.6%'
				},
				'Eagle Harbour': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Eagleridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Furry Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Gleneagles: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Glenmore: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Horseshoe Bay WV': {
					sales: 1,
					active_listings: 22,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Howe Sound': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Lions Bay': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Olde Caulfeild': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Panorama Village': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,426,800',
					one_year_change: '+ 2.7%'
				},
				'Park Royal': {
					sales: 1,
					active_listings: 25,
					benchmark_price: '$1,258,600',
					one_year_change: '- 5.3%'
				},
				'Passage Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queens: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Rockridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sandy Cove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sentinel Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Caulfeild': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Bay': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Westhill: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Westmount WV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whitby Estates': {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Whytecliff: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				Altamont: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Ambleside: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Bayridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'British Properties': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Canterbury WV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Caulfeild: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cedardale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Chartwell: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Chelsea Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cypress: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cypress Park Estates': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Deer Ridge WV': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dundarave: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Eagle Harbour': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Eagleridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Furry Creek': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Gleneagles: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Glenmore: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Horseshoe Bay WV': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Howe Sound': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Lions Bay': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Olde Caulfeild': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Panorama Village': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Park Royal': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Passage Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queens: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Rockridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sandy Cove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sentinel Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Caulfeild': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Bay': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Westhill: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Westmount WV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whitby Estates': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Whytecliff: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},

		Squamish: {
			detached: {
				Brackendale: {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$1,308,700',
					one_year_change: '+ 2.2%'
				},
				'Brennan Center': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$1,525,000',
					one_year_change: '- 5.6%'
				},
				'Britannia Beach': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Business Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dentville: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Downtown SQ': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Garibaldi Estates': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$1,390,100',
					one_year_change: '+ 4.3%'
				},
				'Garibaldi Highlands': {
					sales: 7,
					active_listings: 10,
					benchmark_price: '$1,562,400',
					one_year_change: '- 1.1%'
				},
				'Hospital Hill': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northyards: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Paradise Valley': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Plateau: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,790,400',
					one_year_change: '- 6.5%'
				},
				'Ring Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Squamish Rural': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Tantalus: {
					sales: 3,
					active_listings: 2,
					benchmark_price: '$1,613,300',
					one_year_change: '- 8.5%'
				},
				'University Highlands': {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$1,714,300',
					one_year_change: '- 6.4%'
				},
				'Upper Squamish': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Valleycliffe: {
					sales: 3,
					active_listings: 1,
					benchmark_price: '$1,260,100',
					one_year_change: '+ 1.2%'
				}
			},
			condos: {
				Brackendale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Brennan Center': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Britannia Beach': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Business Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dentville: {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$556,100',
					one_year_change: '15.6%'
				},
				'Downtown SQ': {
					sales: 7,
					active_listings: 46,
					benchmark_price: '$583,000',
					one_year_change: '15.7%'
				},
				'Garibaldi Estates': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$484,500',
					one_year_change: '- 16.1%'
				},
				'Garibaldi Highlands': {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Hospital Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northyards: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Paradise Valley': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Plateau: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ring Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Squamish Rural': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Tantalus: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$484,500',
					one_year_change: '- 16.1%'
				},
				'University Highlands': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Squamish': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Valleycliffe: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$367,600',
					one_year_change: '- 21.5%'
				}
			},
			townhomes: {
				Brackendale: {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$868,600',
					one_year_change: '13.2%'
				},
				'Brennan Center': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$964,700',
					one_year_change: '14.5%'
				},
				'Britannia Beach': {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Business Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dentville: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$969,600',
					one_year_change: '- 14.0%'
				},
				'Downtown SQ': {
					sales: 4,
					active_listings: 7,
					benchmark_price: '$899,000',
					one_year_change: '- 14.2%'
				},
				'Garibaldi Estates': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$704,900',
					one_year_change: '- 14.3%'
				},
				'Garibaldi Highlands': {
					sales: 2,
					active_listings: 1,
					benchmark_price: '$836,600',
					one_year_change: '- 13.8%'
				},
				'Hospital Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northyards: {
					sales: 2,
					active_listings: 4,
					benchmark_price: '$864,500',
					one_year_change: '- 14.1%'
				},
				'Paradise Valley': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Plateau: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ring Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Squamish Rural': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Tantalus: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$960,200',
					one_year_change: '- 14.1%'
				},
				'University Highlands': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Squamish': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Valleycliffe: {
					sales: 8,
					active_listings: 8,
					benchmark_price: '$765,000',
					one_year_change: '- 14.5%'
				}
			}
		},

		Tsawwassen: {
			detached: {
				'Beach Grove': {
					sales: 0,
					active_listings: 16,
					benchmark_price: '$1,678,500',
					one_year_change: '+ 7.3%'
				},
				'Boundary Beach': {
					sales: 1,
					active_listings: 19,
					benchmark_price: '$1,640,900',
					one_year_change: '+ 5.1%'
				},
				'Cliff Drive': {
					sales: 2,
					active_listings: 13,
					benchmark_price: '$1,513,400',
					one_year_change: '+ 5.6%'
				},
				'English Bluff': {
					sales: 0,
					active_listings: 16,
					benchmark_price: '$1,909,700',
					one_year_change: '+ 3.9%'
				},
				'Pebble Hill': {
					sales: 3,
					active_listings: 25,
					benchmark_price: '$1,692,100',
					one_year_change: '+ 7.5%'
				},
				'Tsawwassen Central': {
					sales: 0,
					active_listings: 18,
					benchmark_price: '$1,524,700',
					one_year_change: '+ 5.9%'
				},
				'Tsawwassen East': {
					sales: 0,
					active_listings: 10,
					benchmark_price: '$1,634,200',
					one_year_change: '+ 5.8%'
				},
				'Tsawwassen North': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$1,782,100',
					one_year_change: '+ 5.5%'
				}
			},
			condos: {
				'Beach Grove': {
					sales: 0,
					active_listings: 17,
					benchmark_price: '$0',
					one_year_change: '- 9.1%'
				},
				'Boundary Beach': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$649,500',
					one_year_change: ''
				},
				'Cliff Drive': {
					sales: 2,
					active_listings: 10,
					benchmark_price: '$572,500',
					one_year_change: '- 8.7%'
				},
				'English Bluff': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pebble Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Tsawwassen Central': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$593,100',
					one_year_change: '- 8.3%'
				},
				'Tsawwassen East': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$618,200',
					one_year_change: '- 7.2%'
				},
				'Tsawwassen North': {
					sales: 11,
					active_listings: 43,
					benchmark_price: '$638,300',
					one_year_change: '- 10.4%'
				}
			},
			townhomes: {
				'Beach Grove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Boundary Beach': {
					sales: 2,
					active_listings: 9,
					benchmark_price: '$1,187,200',
					one_year_change: '- 0.1%'
				},
				'Cliff Drive': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$905,000',
					one_year_change: '+ 0.3%'
				},
				'English Bluff': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pebble Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Tsawwassen Central': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,114,200',
					one_year_change: '+ 0.7%'
				},
				'Tsawwassen East': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Tsawwassen North': {
					sales: 4,
					active_listings: 22,
					benchmark_price: '$974,300',
					one_year_change: '+ 0.4%'
				}
			}
		},

		Whistler: {
			detached: {
				'Alpine Meadows': {
					sales: 3,
					active_listings: 16,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Alta Vista': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Bayshores: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Benchlands: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Black Tusk - Pinecrest': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Blueberry Hill': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Brio: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cheakamus Crossing': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Emerald Estates': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Function Junction': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Green Lake Estates': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Nesters: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Nordic: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Rainbow: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Spring Creek': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Spruce Grove': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				WedgeWoods: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Westside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Cay Estates': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Cay Heights': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Village': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'White Gold': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			condos: {
				'Alpine Meadows': {
					sales: 1,
					active_listings: 13,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Alta Vista': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Bayshores: {
					sales: 8,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Benchlands: {
					sales: 9,
					active_listings: 37,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Black Tusk - Pinecrest': {
					sales: 4,
					active_listings: 26,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Blueberry Hill': {
					sales: 3,
					active_listings: 12,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Brio: {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cheakamus Crossing': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Emerald Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Function Junction': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Green Lake Estates': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Nesters: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Nordic: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Rainbow: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Spring Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Spruce Grove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				WedgeWoods: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Westside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Cay Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Cay Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Creek': {
					sales: 6,
					active_listings: 16,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Village': {
					sales: 12,
					active_listings: 55,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'White Gold': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Alpine Meadows': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Alta Vista': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Bayshores: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Benchlands: {
					sales: 2,
					active_listings: 13,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Black Tusk - Pinecrest': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Blueberry Hill': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Brio: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cheakamus Crossing': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Emerald Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Function Junction': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Green Lake Estates': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Nesters: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Nordic: {
					sales: 2,
					active_listings: 19,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Rainbow: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Spring Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Spruce Grove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				WedgeWoods: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Westside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Cay Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Cay Heights': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Creek': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Village': {
					sales: 4,
					active_listings: 19,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'White Gold': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		}
	},
	'March 2025': {
		Tsawwassen: {
			detached: {
				'Beach Grove': {
					sales: 0,
					active_listings: 19,
					benchmark_price: '$1,672,700',
					one_year_change: '-2.0%'
				},
				'Boundary Beach': {
					sales: 8,
					active_listings: 13,
					benchmark_price: '$1,627,400',
					one_year_change: '-2.6%'
				},
				'Cliff Drive': {
					sales: 0,
					active_listings: 22,
					benchmark_price: '$1,525,000',
					one_year_change: '-1.8%'
				},
				'English Bluff': {
					sales: 3,
					active_listings: 16,
					benchmark_price: '$1,944,000',
					one_year_change: '-4.5%'
				},
				'Pebble Hill': {
					sales: 3,
					active_listings: 24,
					benchmark_price: '$1,675,100',
					one_year_change: '-1.7%'
				},
				'Tsawwassen Central': {
					sales: 5,
					active_listings: 25,
					benchmark_price: '$1,522,500',
					one_year_change: '-2.1%'
				},
				'Tsawwassen East': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$1,637,000',
					one_year_change: '-2.0%'
				},
				'Tsawwassen North': {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$1,740,800',
					one_year_change: '3.9%'
				}
			},
			condos: {
				'Beach Grove': {
					sales: 3,
					active_listings: 18,
					benchmark_price: '$702,000',
					one_year_change: '-1.7%'
				},
				'Boundary Beach': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cliff Drive': {
					sales: 2,
					active_listings: 10,
					benchmark_price: '$626,400',
					one_year_change: '0.1%'
				},
				'English Bluff': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pebble Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Tsawwassen Central': {
					sales: 2,
					active_listings: 5,
					benchmark_price: '$648,900',
					one_year_change: '0.2%'
				},
				'Tsawwassen East': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$679,200',
					one_year_change: '1.4%'
				},
				'Tsawwassen North': {
					sales: 6,
					active_listings: 45,
					benchmark_price: '$699,500',
					one_year_change: '-1.4%'
				}
			},
			townhomes: {
				'Beach Grove': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Boundary Beach': {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$1,144,200',
					one_year_change: '-5.0%'
				},
				'Cliff Drive': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$870,100',
					one_year_change: '-4.7%'
				},
				'English Bluff': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pebble Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Tsawwassen Central': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,067,200',
					one_year_change: '-3.2%'
				},
				'Tsawwassen East': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Tsawwassen North': {
					sales: 2,
					active_listings: 28,
					benchmark_price: '$938,000',
					one_year_change: '-4.5%'
				}
			}
		},
		'Burnaby South': {
			detached: {
				'Big Bend': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Buckingham Heights': {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$2,771,900',
					one_year_change: '+3.2%'
				},
				'Burnaby Hospital': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$2,170,400',
					one_year_change: '+2.5%'
				},
				'Burnaby Lake': {
					sales: 1,
					active_listings: 20,
					benchmark_price: '$2,138,400',
					one_year_change: '+0.7%'
				},
				'Central Park BS': {
					sales: 2,
					active_listings: 14,
					benchmark_price: '$1,973,100',
					one_year_change: '+4.4%'
				},
				'Deer Lake': {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$3,160,600',
					one_year_change: '-7.8%'
				},
				'Deer Lake Place': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$2,150,100',
					one_year_change: '+2.6%'
				},
				'Forest Glen BS': {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$2,269,700',
					one_year_change: '+0.5%'
				},
				'Garden Village': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$2,283,300',
					one_year_change: '+3.8%'
				},
				'Greentree Village': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Highgate: {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$2,050,400',
					one_year_change: '+2.6%'
				},
				Metrotown: {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$2,268,700',
					one_year_change: '-1.4%'
				},
				Oaklands: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'South Slope': {
					sales: 3,
					active_listings: 32,
					benchmark_price: '$2,165,200',
					one_year_change: '+1.0%'
				},
				Suncrest: {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$2,227,200',
					one_year_change: '+5.3%'
				},
				'Upper Deer Lake': {
					sales: 1,
					active_listings: 14,
					benchmark_price: '$2,295,500',
					one_year_change: '-1.4%'
				}
			},
			condos: {
				'Big Bend': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Buckingham Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Burnaby Hospital': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$655,000',
					one_year_change: '-0.5%'
				},
				'Burnaby Lake': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central Park BS': {
					sales: 6,
					active_listings: 5,
					benchmark_price: '$656,500',
					one_year_change: '+3.4%'
				},
				'Deer Lake': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Deer Lake Place': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Forest Glen BS': {
					sales: 4,
					active_listings: 34,
					benchmark_price: '$824,500',
					one_year_change: '+4.5%'
				},
				'Garden Village': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Greentree Village': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Highgate: {
					sales: 9,
					active_listings: 34,
					benchmark_price: '$755,000',
					one_year_change: '-3.1%'
				},
				Metrotown: {
					sales: 32,
					active_listings: 311,
					benchmark_price: '$893,500',
					one_year_change: '-2.2%'
				},
				Oaklands: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$732,100',
					one_year_change: '-0.2%'
				},
				'South Slope': {
					sales: 3,
					active_listings: 18,
					benchmark_price: '$724,800',
					one_year_change: '-1.2%'
				},
				Suncrest: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Deer Lake': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Big Bend': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Buckingham Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Burnaby Hospital': {
					sales: 2,
					active_listings: 1,
					benchmark_price: '$917,200',
					one_year_change: '-2.7%'
				},
				'Burnaby Lake': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$1,159,800',
					one_year_change: '-1.7%'
				},
				'Central Park BS': {
					sales: 2,
					active_listings: 3,
					benchmark_price: '$972,800',
					one_year_change: '-3.7%'
				},
				'Deer Lake': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Deer Lake Place': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Forest Glen BS': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$957,200',
					one_year_change: '-0.9%'
				},
				'Garden Village': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Greentree Village': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$924,100',
					one_year_change: '+1.2%'
				},
				Highgate: {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$913,700',
					one_year_change: '-2.2%'
				},
				Metrotown: {
					sales: 5,
					active_listings: 14,
					benchmark_price: '$1,130,700',
					one_year_change: '-3.7%'
				},
				Oaklands: {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$1,445,900',
					one_year_change: '4.4%'
				},
				'South Slope': {
					sales: 4,
					active_listings: 7,
					benchmark_price: '$1,039,900',
					one_year_change: '-2.4%'
				},
				Suncrest: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Deer Lake': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		'Port Moody': {
			detached: {
				Anmore: {
					sales: 1,
					active_listings: 19,
					benchmark_price: '$3,191,100',
					one_year_change: '+ 0.6%'
				},
				'Barber Street': {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$2,053,500',
					one_year_change: '- 4.2%'
				},
				Belcarra: {
					sales: 0,
					active_listings: 10,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'College Park PM': {
					sales: 2,
					active_listings: 5,
					benchmark_price: '$1,642,100',
					one_year_change: '- 0.5%'
				},
				Glenayre: {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$1,614,100',
					one_year_change: '- 4.4%'
				},
				'Heritage Mountain': {
					sales: 1,
					active_listings: 8,
					benchmark_price: '$2,018,900',
					one_year_change: '+ 1.0%'
				},
				'Heritage Woods PM': {
					sales: 3,
					active_listings: 23,
					benchmark_price: '$2,209,600',
					one_year_change: '+ 2.6%'
				},
				loco: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Mountain Meadows': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'North Shore Pt Moody': {
					sales: 2,
					active_listings: 9,
					benchmark_price: '$1,943,700',
					one_year_change: '- 2.7%'
				},
				'Port Moody Centre': {
					sales: 0,
					active_listings: 16,
					benchmark_price: '$1,747,700',
					one_year_change: '- 2.5%'
				}
			},
			condos: {
				Anmore: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Barber Street': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Belcarra: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'College Park PM': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$506,900',
					one_year_change: '+ 0.6%'
				},
				Glenayre: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Heritage Mountain': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Heritage Woods PM': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				loco: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Mountain Meadows': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'North Shore Pt Moody': {
					sales: 7,
					active_listings: 21,
					benchmark_price: '$789,500',
					one_year_change: '+ 0.7%'
				},
				'Port Moody Centre': {
					sales: 21,
					active_listings: 92,
					benchmark_price: '$738,600',
					one_year_change: '- 0.3%'
				}
			},
			townhomes: {
				Anmore: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Barber Street': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Belcarra: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'College Park PM': {
					sales: 2,
					active_listings: 10,
					benchmark_price: '$994,100',
					one_year_change: '+ 2.3%'
				},
				Glenayre: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Heritage Mountain': {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$1,105,400',
					one_year_change: '+ 1.5%'
				},
				'Heritage Woods PM': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$1,094,400',
					one_year_change: '- 3.2%'
				},
				loco: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Mountain Meadows': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'North Shore Pt Moody': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$769,500',
					one_year_change: '+ 2.7%'
				},
				'Port Moody Centre': {
					sales: 5,
					active_listings: 7,
					benchmark_price: '$1,116,500',
					one_year_change: '+ 0.5%'
				}
			}
		},
		Squamish: {
			detached: {
				Brackendale: {
					sales: 1,
					active_listings: 12,
					benchmark_price: '$1,383,400',
					one_year_change: '+ 4.2%'
				},
				'Brennan Center': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$1,869,100',
					one_year_change: '+ 11.0%'
				},
				'Britannia Beach': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Business Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dentville: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Downtown SQ': {
					sales: 2,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Garibaldi Estates': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$1,477,900',
					one_year_change: '+ 6.8%'
				},
				'Garibaldi Highlands': {
					sales: 3,
					active_listings: 15,
					benchmark_price: '$1,753,500',
					one_year_change: '+ 6.2%'
				},
				'Hospital Hill': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northyards: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Paradise Valley': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Plateau: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$2,166,900',
					one_year_change: '+ 8.5%'
				},
				'Ring Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Squamish Rural': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Tantalus: {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$1,975,100',
					one_year_change: '+ 7.2%'
				},
				'University Highlands': {
					sales: 2,
					active_listings: 10,
					benchmark_price: '$2,103,100',
					one_year_change: '+ 9.4%'
				},
				'Upper Squamish': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Valleycliffe: {
					sales: 2,
					active_listings: 1,
					benchmark_price: '$1,337,500',
					one_year_change: '+ 4.8%'
				}
			},
			condos: {
				Brackendale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Brennan Center': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Britannia Beach': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Business Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dentville: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$619,900',
					one_year_change: '- 4.6%'
				},
				'Downtown SQ': {
					sales: 8,
					active_listings: 50,
					benchmark_price: '$651,000',
					one_year_change: '- 4.8%'
				},
				'Garibaldi Estates': {
					sales: 2,
					active_listings: 5,
					benchmark_price: '$532,200',
					one_year_change: '7.9%'
				},
				'Garibaldi Highlands': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Hospital Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northyards: {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Paradise Valley': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Plateau: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ring Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Squamish Rural': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Tantalus: {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$532,200',
					one_year_change: '- 7.9%'
				},
				'University Highlands': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Squamish': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Valleycliffe: {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$400,200',
					one_year_change: '- 11.3%'
				}
			},
			townhomes: {
				Brackendale: {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,065,500',
					one_year_change: '+ 2.2%'
				},
				'Brennan Center': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,179,800',
					one_year_change: '+ 1.5%'
				},
				'Britannia Beach': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Business Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dentville: {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$1,183,100',
					one_year_change: '+ 1.0%'
				},
				'Downtown SQ': {
					sales: 4,
					active_listings: 3,
					benchmark_price: '$1,076,500',
					one_year_change: '- 0.4%'
				},
				'Garibaldi Estates': {
					sales: 3,
					active_listings: 4,
					benchmark_price: '$868,900',
					one_year_change: '+ 2.2%'
				},
				'Garibaldi Highlands': {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$1,031,800',
					one_year_change: '+ 3.0%'
				},
				'Hospital Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northyards: {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,054,700',
					one_year_change: '+ 0.7%'
				},
				'Paradise Valley': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Plateau: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ring Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Squamish Rural': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Tantalus: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,174,500',
					one_year_change: '+ 1.8%'
				},
				'University Highlands': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Squamish': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Valleycliffe: {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$941,200',
					one_year_change: '+ 2.5%'
				}
			}
		},
		'Vancouver West': {
			detached: {
				Arbutus: {
					sales: 2,
					active_listings: 24,
					benchmark_price: '$3,664,800',
					one_year_change: '- 6.1%'
				},
				Cambie: {
					sales: 9,
					active_listings: 59,
					benchmark_price: '$3,185,700',
					one_year_change: '+ 3.2%'
				},
				'Coal Harbour': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Downtown VW': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dunbar: {
					sales: 4,
					active_listings: 85,
					benchmark_price: '$3,419,300',
					one_year_change: '+ 1.7%'
				},
				'Fairview VW': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'False Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Kerrisdale: {
					sales: 3,
					active_listings: 28,
					benchmark_price: '$3,665,000',
					one_year_change: '+ 0.7%'
				},
				Kitsilano: {
					sales: 5,
					active_listings: 34,
					benchmark_price: '$2,693,900',
					one_year_change: '- 5.5%'
				},
				'MacKenzie Heights': {
					sales: 2,
					active_listings: 20,
					benchmark_price: '$3,823,500',
					one_year_change: '+ 0.1%'
				},
				Marpole: {
					sales: 2,
					active_listings: 39,
					benchmark_price: '$2,371,400',
					one_year_change: '- 3.5%'
				},
				'Mount Pleasant VW': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$2,301,500',
					one_year_change: '- 3.1%'
				},
				'Oakridge VW': {
					sales: 1,
					active_listings: 12,
					benchmark_price: '$3,719,500',
					one_year_change: '+ 5.9%'
				},
				'Point Grey': {
					sales: 8,
					active_listings: 97,
					benchmark_price: '$3,077,400',
					one_year_change: '- 0.2%'
				},
				Quilchena: {
					sales: 1,
					active_listings: 19,
					benchmark_price: '$4,179,400',
					one_year_change: '- 5.7%'
				},
				'S.W. Marine': {
					sales: 2,
					active_listings: 28,
					benchmark_price: '$3,165,200',
					one_year_change: '- 4.3%'
				},
				Shaughnessy: {
					sales: 2,
					active_listings: 71,
					benchmark_price: '$5,086,800',
					one_year_change: '+ 3.8%'
				},
				'South Cambie': {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$4,988,500',
					one_year_change: '+ 9.2%'
				},
				'South Granville': {
					sales: 6,
					active_listings: 83,
					benchmark_price: '$4,292,500',
					one_year_change: '- 0.3%'
				},
				Southlands: {
					sales: 3,
					active_listings: 30,
					benchmark_price: '$3,505,100',
					one_year_change: '- 4.9%'
				},
				'University VW': {
					sales: 1,
					active_listings: 20,
					benchmark_price: '$2,650,900',
					one_year_change: '- 0.1%'
				},
				'West End W': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Yaletown: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			condos: {
				Arbutus: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cambie: {
					sales: 10,
					active_listings: 80,
					benchmark_price: '$1,141,500',
					one_year_change: '- 0.7%'
				},
				'Coal Harbour': {
					sales: 8,
					active_listings: 161,
					benchmark_price: '$1,295,200',
					one_year_change: '+ 1.6%'
				},
				'Downtown W': {
					sales: 58,
					active_listings: 532,
					benchmark_price: '$687,500',
					one_year_change: '- 1.6%'
				},
				Dunbar: {
					sales: 3,
					active_listings: 14,
					benchmark_price: '$1,016,000',
					one_year_change: '+ 3.6%'
				},
				'Fairview VW': {
					sales: 32,
					active_listings: 86,
					benchmark_price: '$853,700',
					one_year_change: '+ 3.9%'
				},
				'False Creek': {
					sales: 25,
					active_listings: 99,
					benchmark_price: '$854,700',
					one_year_change: '- 1.1%'
				},
				Kerrisdale: {
					sales: 6,
					active_listings: 33,
					benchmark_price: '$1,116,400',
					one_year_change: '+ 1.7%'
				},
				Kitsilano: {
					sales: 30,
					active_listings: 70,
					benchmark_price: '$755,000',
					one_year_change: '+ 0.0%'
				},
				'MacKenzie Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Marpole: {
					sales: 13,
					active_listings: 95,
					benchmark_price: '$678,100',
					one_year_change: '- 1.7%'
				},
				'Mount Pleasant VW': {
					sales: 1,
					active_listings: 11,
					benchmark_price: '$782,700',
					one_year_change: '+ 0.5%'
				},
				'Oakridge VW': {
					sales: 4,
					active_listings: 24,
					benchmark_price: '$992,700',
					one_year_change: '+ 1.6%'
				},
				'Point Grey': {
					sales: 0,
					active_listings: 12,
					benchmark_price: '$856,300',
					one_year_change: '+ 0.7%'
				},
				Quilchena: {
					sales: 6,
					active_listings: 13,
					benchmark_price: '$1,249,900',
					one_year_change: '+ 1.2%'
				},
				'S.W. Marine': {
					sales: 1,
					active_listings: 12,
					benchmark_price: '$707,600',
					one_year_change: '+ 0.4%'
				},
				Shaughnessy: {
					sales: 3,
					active_listings: 2,
					benchmark_price: '$1,214,300',
					one_year_change: '+ 10.6%'
				},
				'South Cambie': {
					sales: 5,
					active_listings: 54,
					benchmark_price: '$1,144,500',
					one_year_change: '- 1.3%'
				},
				'South Granville': {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$1,225,200',
					one_year_change: '- 0.5%'
				},
				Southlands: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$982,900',
					one_year_change: '+ 3.5%'
				},
				'University VW': {
					sales: 20,
					active_listings: 120,
					benchmark_price: '$1,129,300',
					one_year_change: '+ 0.8%'
				},
				'West End W': {
					sales: 29,
					active_listings: 247,
					benchmark_price: '$697,800',
					one_year_change: '+ 2.3%'
				},
				Yaletown: {
					sales: 38,
					active_listings: 273,
					benchmark_price: '$837,800',
					one_year_change: '+ 1.7%'
				}
			},
			townhomes: {
				Arbutus: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cambie: {
					sales: 3,
					active_listings: 52,
					benchmark_price: '$1,795,500',
					one_year_change: '- 0.9%'
				},
				'Coal Harbour': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$1,809,400',
					one_year_change: '+ 0.8%'
				},
				'Downtown W': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$1,239,700',
					one_year_change: '+ 4.9%'
				},
				Dunbar: {
					sales: 2,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Fairview VW': {
					sales: 10,
					active_listings: 22,
					benchmark_price: '$1,076,700',
					one_year_change: '+ 3.6%'
				},
				'False Creek': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$1,186,100',
					one_year_change: '- 7.2%'
				},
				Kerrisdale: {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$1,723,000',
					one_year_change: '- 0.7%'
				},
				Kitsilano: {
					sales: 11,
					active_listings: 31,
					benchmark_price: '$1,321,000',
					one_year_change: '- 1.7%'
				},
				'MacKenzie Heights': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Marpole: {
					sales: 1,
					active_listings: 22,
					benchmark_price: '$1,623,300',
					one_year_change: '- 2.7%'
				},
				'Mount Pleasant VW': {
					sales: 2,
					active_listings: 3,
					benchmark_price: '$1,380,400',
					one_year_change: '+ 6.5%'
				},
				'Oakridge VW': {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$1,734,700',
					one_year_change: '+ 1.1%'
				},
				'Point Grey': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$1,381,800',
					one_year_change: '- 0.7%'
				},
				Quilchena: {
					sales: 2,
					active_listings: 3,
					benchmark_price: '$1,566,600',
					one_year_change: '- 4.7%'
				},
				'S.W. Marine': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Shaughnessy: {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$2,007,000',
					one_year_change: '+ 3.1%'
				},
				'South Cambie': {
					sales: 1,
					active_listings: 31,
					benchmark_price: '$1,600,900',
					one_year_change: '+ 1.0%'
				},
				'South Granville': {
					sales: 2,
					active_listings: 37,
					benchmark_price: '$1,663,700',
					one_year_change: '- 4.4%'
				},
				Southlands: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'University VW': {
					sales: 1,
					active_listings: 18,
					benchmark_price: '$1,797,000',
					one_year_change: '- 1.7%'
				},
				'West End W': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,281,800',
					one_year_change: '+ 6.5%'
				},
				Yaletown: {
					sales: 0,
					active_listings: 19,
					benchmark_price: '$1,855,800',
					one_year_change: '+ 1.6%'
				}
			}
		},
		Whistler: {
			detached: {
				'Alpine Meadows': {
					sales: 1,
					active_listings: 15,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Alta Vista': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Bayshores: {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Benchlands: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Black Tusk - Pinecrest': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Blueberry Hill': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Brio: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Cheakamus Crossing': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Emerald Estates': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Function Junction': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Green Lake Estates': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Nesters: {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Nordic: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Rainbow: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Spring Creek': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Spruce Grove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				WedgeWoods: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Westside: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Whistler Cay Estates': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Whistler Cay Heights': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Whistler Creek': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Whistler Village': {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'White Gold': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: '--'
				}
			},
			condos: {
				'Alpine Meadows': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Alta Vista': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Bayshores: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Benchlands: {
					sales: 4,
					active_listings: 28,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Black Tusk - Pinecrest': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Blueberry Hill': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Brio: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Cheakamus Crossing': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Emerald Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Function Junction': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Green Lake Estates': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Nesters: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Nordic: {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Rainbow: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Spring Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Spruce Grove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				WedgeWoods: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Westside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Whistler Cay Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Whistler Cay Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Whistler Creek': {
					sales: 3,
					active_listings: 20,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Whistler Village': {
					sales: 8,
					active_listings: 64,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'White Gold': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				}
			},
			townhomes: {
				'Alpine Meadows': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Alta Vista': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Bayshores: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Benchlands: {
					sales: 1,
					active_listings: 18,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Black Tusk - Pinecrest': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Blueberry Hill': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Brio: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Cheakamus Crossing': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Emerald Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Function Junction': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Green Lake Estates': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Nesters: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Nordic: {
					sales: 3,
					active_listings: 20,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Rainbow: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Spring Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Spruce Grove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				WedgeWoods: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Westside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Whistler Cay Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Whistler Cay Heights': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Whistler Creek': {
					sales: 1,
					active_listings: 12,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Whistler Village': {
					sales: 1,
					active_listings: 24,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'White Gold': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: '--'
				}
			}
		},
		'Burnaby North': {
			detached: {
				'Brentwood Park': {
					sales: 0,
					active_listings: 15,
					benchmark_price: '$2,210,900',
					one_year_change: '+ 5.1%'
				},
				'Capitol Hill BN': {
					sales: 5,
					active_listings: 16,
					benchmark_price: '$2,118,400',
					one_year_change: '+ 4.0%'
				},
				Cariboo: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central BN': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$1,888,400',
					one_year_change: '+ 8.6%'
				},
				'Forest Hills BN': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Government Road': {
					sales: 1,
					active_listings: 20,
					benchmark_price: '$2,374,200',
					one_year_change: '+ 0.7%'
				},
				'Lake City Industrial': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Montecito: {
					sales: 1,
					active_listings: 16,
					benchmark_price: '$2,131,000',
					one_year_change: '+ 0.7%'
				},
				Oakdale: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Parkcrest: {
					sales: 0,
					active_listings: 38,
					benchmark_price: '$2,230,500',
					one_year_change: '+ 6.8%'
				},
				'Simon Fraser Hills': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Simon Fraser Univer.': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$2,322,800',
					one_year_change: '+ 1.9%'
				},
				'Sperling-Duthie': {
					sales: 2,
					active_listings: 13,
					benchmark_price: '$2,163,000',
					one_year_change: '+ 1.0%'
				},
				'Sullivan Heights': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Vancouver Heights': {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$2,096,200',
					one_year_change: '+ 2.5%'
				},
				'Westridge BN': {
					sales: 1,
					active_listings: 8,
					benchmark_price: '$2,430,900',
					one_year_change: '- 5.6%'
				},
				'Willingdon Heights': {
					sales: 0,
					active_listings: 21,
					benchmark_price: '$2,008,300',
					one_year_change: '+ 6.8%'
				}
			},
			condos: {
				'Brentwood Park': {
					sales: 47,
					active_listings: 428,
					benchmark_price: '$833,500',
					one_year_change: '- 2.7%'
				},
				'Capitol Hill BN': {
					sales: 2,
					active_listings: 16,
					benchmark_price: '$561,800',
					one_year_change: '1.3%'
				},
				Cariboo: {
					sales: 3,
					active_listings: 10,
					benchmark_price: '$536,900',
					one_year_change: '0.5%'
				},
				'Central BN': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$772,000',
					one_year_change: '- 2.0%'
				},
				'Forest Hills BN': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Government Road': {
					sales: 6,
					active_listings: 7,
					benchmark_price: '$587,400',
					one_year_change: '- 1.1%'
				},
				'Lake City Industrial': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Montecito: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Oakdale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Parkcrest: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$848,800',
					one_year_change: '- 2.1%'
				},
				'Simon Fraser Hills': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$489,900',
					one_year_change: '- 1.1%'
				},
				'Simon Fraser Univer.': {
					sales: 8,
					active_listings: 74,
					benchmark_price: '$657,900',
					one_year_change: '- 1.4%'
				},
				'Sperling-Duthie': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sullivan Heights': {
					sales: 7,
					active_listings: 63,
					benchmark_price: '$678,300',
					one_year_change: '+ 0.5%'
				},
				'Vancouver Heights': {
					sales: 2,
					active_listings: 10,
					benchmark_price: '$815,500',
					one_year_change: '- 0.6%'
				},
				'Westridge BN': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Willingdon Heights': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$628,800',
					one_year_change: '1.1%'
				}
			},
			townhomes: {
				'Brentwood Park': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$981,500',
					one_year_change: '- 7.8%'
				},
				'Capitol Hill BN': {
					sales: 2,
					active_listings: 1,
					benchmark_price: '$814,600',
					one_year_change: '- 0.5%'
				},
				Cariboo: {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central BN': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$906,700',
					one_year_change: '- 4.1%'
				},
				'Forest Hills BN': {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$1,019,300',
					one_year_change: '+ 0.4%'
				},
				'Government Road': {
					sales: 3,
					active_listings: 5,
					benchmark_price: '$1,062,100',
					one_year_change: '- 1.5%'
				},
				'Lake City Industrial': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Montecito: {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$781,100',
					one_year_change: '+ 1.0%'
				},
				Oakdale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Parkcrest: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Simon Fraser Hills': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$835,300',
					one_year_change: '+ 1.3%'
				},
				'Simon Fraser Univer.': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$783,200',
					one_year_change: '- 1.6%'
				},
				'Sperling-Duthie': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sullivan Heights': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$815,700',
					one_year_change: '- 1.4%'
				},
				'Vancouver Heights': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$949,900',
					one_year_change: '- 4.9%'
				},
				'Westridge BN': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$747,300',
					one_year_change: '+ 0.4%'
				},
				'Willingdon Heights': {
					sales: 2,
					active_listings: 1,
					benchmark_price: '$943,100',
					one_year_change: '- 4.5%'
				}
			}
		},
		'Vancouver East': {
			detached: {
				'Champlain Heights': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Collingwood VE': {
					sales: 3,
					active_listings: 115,
					benchmark_price: '$1,708,800',
					one_year_change: '-1.3%'
				},
				'Downtown VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Fraser VE': {
					sales: 6,
					active_listings: 43,
					benchmark_price: '$1,987,000',
					one_year_change: '+7.9%'
				},
				'Fraserview VE': {
					sales: 4,
					active_listings: 28,
					benchmark_price: '$2,113,800',
					one_year_change: '-6.7%'
				},
				'Grandview Woodland': {
					sales: 5,
					active_listings: 38,
					benchmark_price: '$1,812,500',
					one_year_change: '+0.2%'
				},
				Hastings: {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$1,655,500',
					one_year_change: '-6.0%'
				},
				'Hastings Sunrise': {
					sales: 4,
					active_listings: 15,
					benchmark_price: '$1,664,000',
					one_year_change: '-2.2%'
				},
				'Killarney VE': {
					sales: 10,
					active_listings: 43,
					benchmark_price: '$1,926,300',
					one_year_change: '-4.3%'
				},
				Knight: {
					sales: 5,
					active_listings: 49,
					benchmark_price: '$1,753,900',
					one_year_change: '-0.9%'
				},
				Main: {
					sales: 4,
					active_listings: 18,
					benchmark_price: '$2,217,800',
					one_year_change: '+7.4%'
				},
				'Mount Pleasant VE': {
					sales: 3,
					active_listings: 12,
					benchmark_price: '$1,835,900',
					one_year_change: '-6.1%'
				},
				'Renfrew Heights': {
					sales: 7,
					active_listings: 55,
					benchmark_price: '$1,829,600',
					one_year_change: '+1.2%'
				},
				'Renfrew VE': {
					sales: 3,
					active_listings: 89,
					benchmark_price: '$1,812,400',
					one_year_change: '+1.0%'
				},
				'South Marine': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$1,372,900',
					one_year_change: '-5.1%'
				},
				'South Vancouver': {
					sales: 5,
					active_listings: 61,
					benchmark_price: '$1,769,800',
					one_year_change: '-4.7%'
				},
				Strathcona: {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$1,597,000',
					one_year_change: '-6.1%'
				},
				'Victoria VE': {
					sales: 6,
					active_listings: 23,
					benchmark_price: '$1,720,300',
					one_year_change: '-0.2%'
				}
			},
			condos: {
				'Champlain Heights': {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$813,100',
					one_year_change: '-1.0%'
				},
				'Collingwood VE': {
					sales: 17,
					active_listings: 100,
					benchmark_price: '$592,500',
					one_year_change: '-1.7%'
				},
				'Downtown VE': {
					sales: 6,
					active_listings: 52,
					benchmark_price: '$641,800',
					one_year_change: '-4.9%'
				},
				'Fraser VE': {
					sales: 5,
					active_listings: 10,
					benchmark_price: '$842,700',
					one_year_change: '+1.9%'
				},
				'Fraserview VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Grandview Woodland': {
					sales: 7,
					active_listings: 36,
					benchmark_price: '$660,400',
					one_year_change: '+2.5%'
				},
				Hastings: {
					sales: 3,
					active_listings: 18,
					benchmark_price: '$556,400',
					one_year_change: '-3.3%'
				},
				'Hastings Sunrise': {
					sales: 2,
					active_listings: 0,
					benchmark_price: '$554,300',
					one_year_change: '+0.0%'
				},
				'Killarney VE': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$626,200',
					one_year_change: '-1.9%'
				},
				Knight: {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$726,800',
					one_year_change: '+2.9%'
				},
				Main: {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$1,049,000',
					one_year_change: '+1.2%'
				},
				'Mount Pleasant VE': {
					sales: 30,
					active_listings: 131,
					benchmark_price: '$723,300',
					one_year_change: '-2.4%'
				},
				'Renfrew Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$413,100',
					one_year_change: '+8.9%'
				},
				'Renfrew VE': {
					sales: 2,
					active_listings: 19,
					benchmark_price: '$744,900',
					one_year_change: '+3.8%'
				},
				'South Marine': {
					sales: 14,
					active_listings: 93,
					benchmark_price: '$819,300',
					one_year_change: '-2.7%'
				},
				'South Vancouver': {
					sales: 1,
					active_listings: 16,
					benchmark_price: '$642,000',
					one_year_change: '-5.5%'
				},
				Strathcona: {
					sales: 10,
					active_listings: 38,
					benchmark_price: '$722,300',
					one_year_change: '-2.1%'
				},
				'Victoria VE': {
					sales: 3,
					active_listings: 15,
					benchmark_price: '$777,100',
					one_year_change: '+0.9%'
				}
			},
			townhomes: {
				'Champlain Heights': {
					sales: 5,
					active_listings: 9,
					benchmark_price: '$1,009,300',
					one_year_change: '+1.7%'
				},
				'Collingwood VE': {
					sales: 4,
					active_listings: 9,
					benchmark_price: '$986,400',
					one_year_change: '+0.4%'
				},
				'Downtown VE': {
					sales: 2,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Fraser VE': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$1,500,900',
					one_year_change: '+1.0%'
				},
				'Fraserview VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Grandview Woodland': {
					sales: 0,
					active_listings: 18,
					benchmark_price: '$1,416,400',
					one_year_change: '+2.4%'
				},
				Hastings: {
					sales: 2,
					active_listings: 1,
					benchmark_price: '$1,229,000',
					one_year_change: '+1.1%'
				},
				'Hastings Sunrise': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Killarney VE': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$930,100',
					one_year_change: '-0.9%'
				},
				Knight: {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$1,369,100',
					one_year_change: '-0.9%'
				},
				Main: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,274,600',
					one_year_change: '+1.3%'
				},
				'Mount Pleasant VE': {
					sales: 3,
					active_listings: 21,
					benchmark_price: '$1,260,200',
					one_year_change: '+4.8%'
				},
				'Renfrew Heights': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Renfrew VE': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$1,016,100',
					one_year_change: '+3.0%'
				},
				'South Marine': {
					sales: 5,
					active_listings: 14,
					benchmark_price: '$1,031,300',
					one_year_change: '-0.2%'
				},
				'South Vancouver': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Strathcona: {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$1,156,800',
					one_year_change: '+8.1%'
				},
				'Victoria VE': {
					sales: 2,
					active_listings: 9,
					benchmark_price: '$1,297,300',
					one_year_change: '+0.5%'
				}
			}
		},
		'Maple Ridge': {
			detached: {
				Albion: {
					sales: 12,
					active_listings: 57,
					benchmark_price: '$1,340,300',
					one_year_change: '+ 3.4%'
				},
				'Cottonwood MR': {
					sales: 7,
					active_listings: 59,
					benchmark_price: '$1,326,600',
					one_year_change: '+ 0.7%'
				},
				'East Central': {
					sales: 4,
					active_listings: 80,
					benchmark_price: '$1,145,400',
					one_year_change: '- 1.7%'
				},
				'North Maple Ridge': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northeast: {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$1,745,300',
					one_year_change: '- 3.2%'
				},
				'Northwest Maple Ridge': {
					sales: 4,
					active_listings: 38,
					benchmark_price: '$1,218,700',
					one_year_change: '- 2.1%'
				},
				'Silver Valley': {
					sales: 8,
					active_listings: 63,
					benchmark_price: '$1,480,800',
					one_year_change: '+ 0.8%'
				},
				'Southwest Maple Ridge': {
					sales: 3,
					active_listings: 61,
					benchmark_price: '$1,160,300',
					one_year_change: '- 1.2%'
				},
				'Thornhill MR': {
					sales: 1,
					active_listings: 28,
					benchmark_price: '$1,637,000',
					one_year_change: '- 0.8%'
				},
				'Websters Corners': {
					sales: 3,
					active_listings: 28,
					benchmark_price: '$1,389,000',
					one_year_change: '+ 0.3%'
				},
				'West Central': {
					sales: 7,
					active_listings: 91,
					benchmark_price: '$1,089,500',
					one_year_change: '- 2.9%'
				},
				Whonnock: {
					sales: 1,
					active_listings: 18,
					benchmark_price: '$1,494,400',
					one_year_change: '- 1.1%'
				}
			},
			condos: {
				Albion: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cottonwood MR': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'East Central': {
					sales: 15,
					active_listings: 82,
					benchmark_price: '$512,100',
					one_year_change: '- 2.8%'
				},
				'North Maple Ridge': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northeast: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Northwest Maple Ridge': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$532,200',
					one_year_change: '- 4.4%'
				},
				'Silver Valley': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Southwest Maple Ridge': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$416,000',
					one_year_change: '- 2.3%'
				},
				'Thornhill MR': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Websters Corners': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Central': {
					sales: 8,
					active_listings: 61,
					benchmark_price: '$534,800',
					one_year_change: '- 3.0%'
				},
				Whonnock: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				Albion: {
					sales: 3,
					active_listings: 11,
					benchmark_price: '$825,700',
					one_year_change: '+ 2.2%'
				},
				'Cottonwood MR': {
					sales: 6,
					active_listings: 23,
					benchmark_price: '$821,600',
					one_year_change: '+ 2.1%'
				},
				'East Central': {
					sales: 11,
					active_listings: 31,
					benchmark_price: '$784,700',
					one_year_change: '+ 0.4%'
				},
				'North Maple Ridge': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northeast: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Northwest Maple Ridge': {
					sales: 2,
					active_listings: 4,
					benchmark_price: '$716,000',
					one_year_change: '+ 0.2%'
				},
				'Silver Valley': {
					sales: 3,
					active_listings: 7,
					benchmark_price: '$879,000',
					one_year_change: '+ 0.6%'
				},
				'Southwest Maple Ridge': {
					sales: 4,
					active_listings: 6,
					benchmark_price: '$670,900',
					one_year_change: '+ 0.2%'
				},
				'Thornhill MR': {
					sales: 3,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Websters Corners': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Central': {
					sales: 1,
					active_listings: 14,
					benchmark_price: '$724,300',
					one_year_change: '+ 0.4%'
				},
				Whonnock: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		'Metro Vancouver': {
			'Bowen Island': {
				detached: {
					sales: 3,
					active_listings: 44,
					benchmark_price: '$1,386,300',
					one_year_change: '+ 2.5%'
				},
				condos: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				townhomes: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				}
			},
			'Burnaby East': {
				detached: {
					sales: 6,
					active_listings: 40,
					benchmark_price: '$1,994,800',
					one_year_change: '+ 2.2%'
				},
				condos: {
					sales: 14,
					active_listings: 87,
					benchmark_price: '$784,200',
					one_year_change: '- 2.7%'
				},
				townhomes: {
					sales: 6,
					active_listings: 27,
					benchmark_price: '$906,500',
					one_year_change: '- 1.2%'
				}
			},
			'Burnaby North': {
				detached: {
					sales: 12,
					active_listings: 169,
					benchmark_price: '$2,163,600',
					one_year_change: '+ 3.6%'
				},
				condos: {
					sales: 77,
					active_listings: 621,
					benchmark_price: '$757,200',
					one_year_change: '- 1.8%'
				},
				townhomes: {
					sales: 16,
					active_listings: 51,
					benchmark_price: '$904,800',
					one_year_change: '- 1.6%'
				}
			},
			'Burnaby South': {
				detached: {
					sales: 16,
					active_listings: 161,
					benchmark_price: '$2,238,900',
					one_year_change: '+ 0.9%'
				},
				condos: {
					sales: 54,
					active_listings: 412,
					benchmark_price: '$837,500',
					one_year_change: '- 0.9%'
				},
				townhomes: {
					sales: 18,
					active_listings: 46,
					benchmark_price: '$1,052,000',
					one_year_change: '- 3.3%'
				}
			},
			Coquitlam: {
				detached: {
					sales: 49,
					active_listings: 450,
					benchmark_price: '$1,814,200',
					one_year_change: '- 0.7%'
				},
				condos: {
					sales: 114,
					active_listings: 517,
					benchmark_price: '$734,400',
					one_year_change: '- 2.7%'
				},
				townhomes: {
					sales: 63,
					active_listings: 163,
					benchmark_price: '$1,083,400',
					one_year_change: '+ 1.5%'
				}
			},
			Ladner: {
				detached: {
					sales: 14,
					active_listings: 87,
					benchmark_price: '$1,422,000',
					one_year_change: '+ 0.5%'
				},
				condos: {
					sales: 8,
					active_listings: 18,
					benchmark_price: '$693,200',
					one_year_change: '+ 2.0%'
				},
				townhomes: {
					sales: 8,
					active_listings: 39,
					benchmark_price: '$1,022,500',
					one_year_change: '+ 0.5%'
				}
			},
			'Maple Ridge': {
				detached: {
					sales: 50,
					active_listings: 535,
					benchmark_price: '$1,287,800',
					one_year_change: '+ 0.1%'
				},
				condos: {
					sales: 23,
					active_listings: 146,
					benchmark_price: '$519,200',
					one_year_change: '- 3.1%'
				},
				townhomes: {
					sales: 33,
					active_listings: 103,
					benchmark_price: '$793,500',
					one_year_change: '+ 1.2%'
				}
			},
			'New Westminster': {
				detached: {
					sales: 6,
					active_listings: 117,
					benchmark_price: '$1,608,400',
					one_year_change: '+ 0.7%'
				},
				condos: {
					sales: 86,
					active_listings: 336,
					benchmark_price: '$652,300',
					one_year_change: '- 1.2%'
				},
				townhomes: {
					sales: 10,
					active_listings: 44,
					benchmark_price: '$923,100',
					one_year_change: '- 3.1%'
				}
			},
			'North Vancouver': {
				detached: {
					sales: 60,
					active_listings: 276,
					benchmark_price: '$2,244,200',
					one_year_change: '+ 0.7%'
				},
				condos: {
					sales: 77,
					active_listings: 401,
					benchmark_price: '$817,700',
					one_year_change: '- 0.5%'
				},
				townhomes: {
					sales: 29,
					active_listings: 121,
					benchmark_price: '$1,313,200',
					one_year_change: '- 3.0%'
				}
			},
			'Pitt Meadows': {
				detached: {
					sales: 11,
					active_listings: 56,
					benchmark_price: '$1,324,600',
					one_year_change: '- 1.1%'
				},
				condos: {
					sales: 4,
					active_listings: 28,
					benchmark_price: '$593,100',
					one_year_change: '- 2.7%'
				},
				townhomes: {
					sales: 12,
					active_listings: 22,
					benchmark_price: '$853,500',
					one_year_change: '+ 0.7%'
				}
			},
			'Port Coquitlam': {
				detached: {
					sales: 19,
					active_listings: 153,
					benchmark_price: '$1,418,500',
					one_year_change: '+ 0.8%'
				},
				condos: {
					sales: 28,
					active_listings: 97,
					benchmark_price: '$641,800',
					one_year_change: '+ 0.1%'
				},
				townhomes: {
					sales: 14,
					active_listings: 53,
					benchmark_price: '$950,700',
					one_year_change: '- 0.0%'
				}
			},
			'Port Moody': {
				detached: {
					sales: 13,
					active_listings: 98,
					benchmark_price: '$2,111,300',
					one_year_change: '+ 0.3%'
				},
				condos: {
					sales: 28,
					active_listings: 116,
					benchmark_price: '$738,200',
					one_year_change: '+ 0.1%'
				},
				townhomes: {
					sales: 10,
					active_listings: 41,
					benchmark_price: '$1,034,600',
					one_year_change: '+ 0.7%'
				}
			},
			Richmond: {
				detached: {
					sales: 47,
					active_listings: 546,
					benchmark_price: '$2,171,100',
					one_year_change: '- 2.1%'
				},
				condos: {
					sales: 122,
					active_listings: 856,
					benchmark_price: '$745,400',
					one_year_change: '- 1.9%'
				},
				townhomes: {
					sales: 49,
					active_listings: 286,
					benchmark_price: '$1,124,100',
					one_year_change: '- 2.4%'
				}
			},
			Squamish: {
				detached: {
					sales: 13,
					active_listings: 76,
					benchmark_price: '$1,649,400',
					one_year_change: '+ 8.7%'
				},
				condos: {
					sales: 12,
					active_listings: 78,
					benchmark_price: '$604,700',
					one_year_change: '- 5.4%'
				},
				townhomes: {
					sales: 13,
					active_listings: 34,
					benchmark_price: '$1,049,900',
					one_year_change: '+ 0.5%'
				}
			},
			'Sunshine Coast': {
				detached: {
					sales: 31,
					active_listings: 368,
					benchmark_price: '$873,600',
					one_year_change: '- 0.6%'
				},
				condos: {
					sales: 2,
					active_listings: 48,
					benchmark_price: '$493,800',
					one_year_change: '- 9.5%'
				},
				townhomes: {
					sales: 3,
					active_listings: 29,
					benchmark_price: '$766,700',
					one_year_change: '+ 0.6%'
				}
			},
			Tsawwassen: {
				detached: {
					sales: 19,
					active_listings: 138,
					benchmark_price: '$1,649,800',
					one_year_change: '- 2.1%'
				},
				condos: {
					sales: 13,
					active_listings: 81,
					benchmark_price: '$676,800',
					one_year_change: '- 0.3%'
				},
				townhomes: {
					sales: 4,
					active_listings: 42,
					benchmark_price: '$971,700',
					one_year_change: '- 4.4%'
				}
			},
			'Vancouver East': {
				detached: {
					sales: 69,
					active_listings: 607,
					benchmark_price: '$1,854,600',
					one_year_change: '0.0%'
				},
				condos: {
					sales: 105,
					active_listings: 550,
					benchmark_price: '$702,800',
					one_year_change: '- 1.3%'
				},
				townhomes: {
					sales: 28,
					active_listings: 113,
					benchmark_price: '$1,159,400',
					one_year_change: '+ 2.0%'
				}
			},
			'Vancouver West': {
				detached: {
					sales: 52,
					active_listings: 668,
					benchmark_price: '$3,451,900',
					one_year_change: '+ 0.1%'
				},
				condos: {
					sales: 292,
					active_listings: 1952,
					benchmark_price: '$849,400',
					one_year_change: '- 0.9%'
				},
				townhomes: {
					sales: 38,
					active_listings: 295,
					benchmark_price: '$1,478,800',
					one_year_change: '+ 0.5%'
				}
			},
			'West Vancouver': {
				detached: {
					sales: 28,
					active_listings: 461,
					benchmark_price: '$3,275,300',
					one_year_change: '+ 0.4%'
				},
				condos: {
					sales: 9,
					active_listings: 106,
					benchmark_price: '$1,266,800',
					one_year_change: '- 5.9%'
				},
				townhomes: {
					sales: 1,
					active_listings: 30,
					benchmark_price: '$0',
					one_year_change: null
				}
			},
			Whistler: {
				detached: {
					sales: 4,
					active_listings: 93,
					benchmark_price: '$2,549,100',
					one_year_change: '+ 6.4%'
				},
				condos: {
					sales: 16,
					active_listings: 124,
					benchmark_price: '$651,100',
					one_year_change: '- 10.5%'
				},
				townhomes: {
					sales: 10,
					active_listings: 88,
					benchmark_price: '$1,674,500',
					one_year_change: '- 2.2%'
				}
			}
		},
		'West Vancouver': {
			detached: {
				Altamont: {
					sales: 0,
					active_listings: 18,
					benchmark_price: '$5,566,000',
					one_year_change: '-2.1%'
				},
				Ambleside: {
					sales: 4,
					active_listings: 35,
					benchmark_price: '$3,001,400',
					one_year_change: '3.2%'
				},
				Bayridge: {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$3,009,200',
					one_year_change: '-2.2%'
				},
				'British Properties': {
					sales: 5,
					active_listings: 80,
					benchmark_price: '$3,384,800',
					one_year_change: '-1.7%'
				},
				'Canterbury WV': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Caulfeild: {
					sales: 1,
					active_listings: 28,
					benchmark_price: '$3,150,600',
					one_year_change: '+0.0%'
				},
				Cedardale: {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$2,578,900',
					one_year_change: '-2.5%'
				},
				Chartwell: {
					sales: 2,
					active_listings: 35,
					benchmark_price: '$5,191,300',
					one_year_change: '11.2%'
				},
				'Chelsea Park': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cypress: {
					sales: 0,
					active_listings: 14,
					benchmark_price: '$4,134,400',
					one_year_change: '1.5%'
				},
				'Cypress Park Estates': {
					sales: 0,
					active_listings: 16,
					benchmark_price: '$3,278,300',
					one_year_change: '-1.6%'
				},
				'Deer Ridge WV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dundarave: {
					sales: 3,
					active_listings: 33,
					benchmark_price: '$3,597,900',
					one_year_change: '-1.0%'
				},
				'Eagle Harbour': {
					sales: 1,
					active_listings: 17,
					benchmark_price: '$2,455,100',
					one_year_change: '+3.5%'
				},
				Eagleridge: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Furry Creek': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Gleneagles: {
					sales: 1,
					active_listings: 11,
					benchmark_price: '$3,003,700',
					one_year_change: '0.5%'
				},
				Glenmore: {
					sales: 0,
					active_listings: 16,
					benchmark_price: '$2,309,300',
					one_year_change: '+1.1%'
				},
				'Horseshoe Bay WV': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$2,011,400',
					one_year_change: '-3.0%'
				},
				'Howe Sound': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Lions Bay': {
					sales: 2,
					active_listings: 18,
					benchmark_price: '$2,141,100',
					one_year_change: '-2.5%'
				},
				'Olde Caulfeild': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Panorama Village': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Park Royal': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Passage Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queens: {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$3,455,000',
					one_year_change: '-7.3%'
				},
				Rockridge: {
					sales: 1,
					active_listings: 8,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sandy Cove': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sentinel Hill': {
					sales: 2,
					active_listings: 23,
					benchmark_price: '$2,885,100',
					one_year_change: '-0.5%'
				},
				'Upper Caulfeild': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$3,181,100',
					one_year_change: '+0.0%'
				},
				'West Bay': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$3,859,900',
					one_year_change: '-7.2%'
				},
				Westhill: {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Westmount WV': {
					sales: 0,
					active_listings: 10,
					benchmark_price: '$4,541,100',
					one_year_change: '-3.8%'
				},
				'Whitby Estates': {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Whytecliff: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$2,570,700',
					one_year_change: '+0.5%'
				}
			},
			condos: {
				Altamont: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Ambleside: {
					sales: 5,
					active_listings: 26,
					benchmark_price: '$939,900',
					one_year_change: '6.4%'
				},
				Bayridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'British Properties': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Canterbury WV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Caulfeild: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cedardale: {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Chartwell: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Chelsea Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cypress: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cypress Park Estates': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$2,146,000',
					one_year_change: '-0.7%'
				},
				'Deer Ridge WV': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dundarave: {
					sales: 1,
					active_listings: 17,
					benchmark_price: '$1,513,600',
					one_year_change: '-3.7%'
				},
				'Eagle Harbour': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Eagleridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Furry Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Gleneagles: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Glenmore: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Horseshoe Bay WV': {
					sales: 0,
					active_listings: 19,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Howe Sound': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Lions Bay': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Olde Caulfeild': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Panorama Village': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$1,535,300',
					one_year_change: '-6.1%'
				},
				'Park Royal': {
					sales: 1,
					active_listings: 34,
					benchmark_price: '$1,330,400',
					one_year_change: '4.0%'
				},
				'Passage Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queens: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Rockridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sandy Cove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sentinel Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Caulfeild': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Bay': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Westhill: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Westmount WV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whitby Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Whytecliff: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				Altamont: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Ambleside: {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Bayridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'British Properties': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Canterbury WV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Caulfeild: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cedardale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Chartwell: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Chelsea Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cypress: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cypress Park Estates': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Deer Ridge WV': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dundarave: {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Eagle Harbour': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Eagleridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Furry Creek': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Gleneagles: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Glenmore: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Horseshoe Bay WV': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Howe Sound': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Lions Bay': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Olde Caulfeild': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Panorama Village': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Park Royal': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Passage Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queens: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Rockridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sandy Cove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sentinel Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Caulfeild': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Bay': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Westhill: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Westmount WV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whitby Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Whytecliff: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		'New Westminster': {
			detached: {
				'Connaught Heights': {
					sales: 0,
					active_listings: 15,
					benchmark_price: '$1,712,900',
					one_year_change: '+ 1.5%'
				},
				'Downtown NW': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Fraserview NW': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'GlenBrooke North': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$1,736,400',
					one_year_change: '+ 1.6%'
				},
				'Moody Park': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,706,100',
					one_year_change: '+ 4.1%'
				},
				'North Arm': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Quay: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Queens Park': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$2,124,600',
					one_year_change: '+ 0.7%'
				},
				Queensborough: {
					sales: 1,
					active_listings: 34,
					benchmark_price: '$1,400,700',
					one_year_change: '- 6.8%'
				},
				Sapperton: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,474,800',
					one_year_change: '+ 2.5%'
				},
				'The Heights NW': {
					sales: 4,
					active_listings: 15,
					benchmark_price: '$1,586,900',
					one_year_change: '+ 2.8%'
				},
				'Uptown NW': {
					sales: 0,
					active_listings: 12,
					benchmark_price: '$1,455,500',
					one_year_change: '+ 4.2%'
				},
				'West End NW': {
					sales: 0,
					active_listings: 14,
					benchmark_price: '$1,601,300',
					one_year_change: '+ 0.9%'
				}
			},
			condos: {
				'Downtown NW': {
					sales: 18,
					active_listings: 83,
					benchmark_price: '$662,400',
					one_year_change: '- 1.0%'
				},
				'Fraserview NW': {
					sales: 8,
					active_listings: 29,
					benchmark_price: '$700,900',
					one_year_change: '- 2.1%'
				},
				'GlenBrooke North': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$595,600',
					one_year_change: '- 2.3%'
				},
				Quay: {
					sales: 24,
					active_listings: 122,
					benchmark_price: '$713,600',
					one_year_change: '0.2%'
				},
				Queensborough: {
					sales: 4,
					active_listings: 25,
					benchmark_price: '$869,900',
					one_year_change: '- 2.0%'
				},
				Sapperton: {
					sales: 7,
					active_listings: 11,
					benchmark_price: '$537,600',
					one_year_change: '- 2.0%'
				},
				'Uptown NW': {
					sales: 25,
					active_listings: 54,
					benchmark_price: '$574,400',
					one_year_change: '- 2.2%'
				}
			},
			townhomes: {
				'Fraserview NW': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$997,000',
					one_year_change: '- 2.0%'
				},
				'GlenBrooke North': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$825,600',
					one_year_change: '- 2.7%'
				},
				Queensborough: {
					sales: 8,
					active_listings: 19,
					benchmark_price: '$976,800',
					one_year_change: '- 3.0%'
				},
				'Uptown NW': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$719,600',
					one_year_change: '4.5%'
				}
			}
		},
		'Port Coquitlam': {
			detached: {
				'Birchland Manor': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,349,700',
					one_year_change: '-0.1%'
				},
				'Central Pt Coquitlam': {
					sales: 0,
					active_listings: 12,
					benchmark_price: '$1,286,200',
					one_year_change: '-2.3%'
				},
				'Citadel PQ': {
					sales: 2,
					active_listings: 20,
					benchmark_price: '$1,550,800',
					one_year_change: '+3.0%'
				},
				'Glenwood PQ': {
					sales: 3,
					active_listings: 30,
					benchmark_price: '$1,360,500',
					one_year_change: '-0.5%'
				},
				'Lincoln Park PQ': {
					sales: 1,
					active_listings: 16,
					benchmark_price: '$1,307,300',
					one_year_change: '-1.6%'
				},
				'Lower Mary Hill': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$1,308,100',
					one_year_change: '+0.8%'
				},
				'Mary Hill': {
					sales: 2,
					active_listings: 12,
					benchmark_price: '$1,388,300',
					one_year_change: '+1.4%'
				},
				'Oxford Heights': {
					sales: 5,
					active_listings: 23,
					benchmark_price: '$1,429,200',
					one_year_change: '0.2%'
				},
				Riverwood: {
					sales: 4,
					active_listings: 8,
					benchmark_price: '$1,560,200',
					one_year_change: '+1.8%'
				},
				'Woodland Acres PQ': {
					sales: 1,
					active_listings: 21,
					benchmark_price: '$1,477,600',
					one_year_change: '0.5%'
				}
			},
			condos: {
				'Birchland Manor': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Central Pt Coquitlam': {
					sales: 22,
					active_listings: 72,
					benchmark_price: '$659,800',
					one_year_change: '+0.7%'
				},
				'Citadel PQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Glenwood PQ': {
					sales: 4,
					active_listings: 23,
					benchmark_price: '$540,700',
					one_year_change: '-3.4%'
				},
				'Lincoln Park PQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Lower Mary Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Mary Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Oxford Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Riverwood: {
					sales: 2,
					active_listings: 2,
					benchmark_price: '$700,800',
					one_year_change: '-3.5%'
				},
				'Woodland Acres PQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				}
			},
			townhomes: {
				'Birchland Manor': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Central Pt Coquitlam': {
					sales: 4,
					active_listings: 9,
					benchmark_price: '$811,400',
					one_year_change: '-2.0%'
				},
				'Citadel PQ': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$1,006,800',
					one_year_change: '-0.4%'
				},
				'Glenwood PQ': {
					sales: 3,
					active_listings: 7,
					benchmark_price: '$893,800',
					one_year_change: '+1.1%'
				},
				'Lincoln Park PQ': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$905,700',
					one_year_change: '+0.3%'
				},
				'Lower Mary Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Mary Hill': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$934,400',
					one_year_change: '-0.9%'
				},
				'Oxford Heights': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$945,500',
					one_year_change: '+2.2%'
				},
				Riverwood: {
					sales: 6,
					active_listings: 23,
					benchmark_price: '$1,004,700',
					one_year_change: '-0.2%'
				},
				'Woodland Acres PQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				}
			}
		},
		'Sunshine Coast': {
			detached: {
				'Gambier Island': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Gibsons & Area': {
					sales: 6,
					active_listings: 92,
					benchmark_price: '$886,800',
					one_year_change: '+0.9%'
				},
				'Halfmn Bay Secret Cv Redroofs': {
					sales: 4,
					active_listings: 50,
					benchmark_price: '$921,900',
					one_year_change: '-1.2%'
				},
				'Keats Island': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Nelson Island': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pender Harbour Egmont': {
					sales: 6,
					active_listings: 57,
					benchmark_price: '$777,000',
					one_year_change: '-3.2%'
				},
				'Roberts Creek': {
					sales: 2,
					active_listings: 25,
					benchmark_price: '$983,500',
					one_year_change: '+1.3%'
				},
				'Sechelt District': {
					sales: 12,
					active_listings: 127,
					benchmark_price: '$856,800',
					one_year_change: '1.4%'
				}
			},
			condos: {
				'Gambier Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Gibsons & Area': {
					sales: 1,
					active_listings: 23,
					benchmark_price: '$523,000',
					one_year_change: '9.2%'
				},
				'Halfmn Bay Secret Cv Redroofs': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Keats Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Nelson Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pender Harbour Egmont': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Roberts Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sechelt District': {
					sales: 1,
					active_listings: 21,
					benchmark_price: '$474,000',
					one_year_change: '8.6%'
				}
			},
			townhomes: {
				'Gambier Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Gibsons & Area': {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$792,500',
					one_year_change: '+ 3.6%'
				},
				'Halfmn Bay Secret Cv Redroofs': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Keats Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Nelson Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pender Harbour Egmont': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Roberts Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sechelt District': {
					sales: 1,
					active_listings: 12,
					benchmark_price: '$743,500',
					one_year_change: '- 2.1%'
				}
			}
		},
		Ladner: {
			detached: {
				'Delta Manor': {
					sales: null,
					active_listings: null,
					benchmark_price: '$1,373,200',
					one_year_change: '+1.1%'
				},
				Hawthorne: {
					sales: null,
					active_listings: null,
					benchmark_price: '$1,470,500',
					one_year_change: '+0.6%'
				},
				Holly: {
					sales: null,
					active_listings: null,
					benchmark_price: '$1,485,400',
					one_year_change: '+0.8%'
				},
				'Ladner Elementary': {
					sales: null,
					active_listings: null,
					benchmark_price: '$1,348,600',
					one_year_change: '+0.3%'
				},
				'Neilsen Grove': {
					sales: null,
					active_listings: null,
					benchmark_price: '$1,420,000',
					one_year_change: '+0.1%'
				},
				'Port Guichon': {
					sales: null,
					active_listings: null,
					benchmark_price: '$1,313,300',
					one_year_change: '-1.9%'
				}
			},
			condos: {
				'Delta Manor': {
					sales: null,
					active_listings: null,
					benchmark_price: '$612,100',
					one_year_change: '+1.8%'
				},
				Hawthorne: {
					sales: null,
					active_listings: null,
					benchmark_price: '$657,200',
					one_year_change: '+3.4%'
				},
				'Ladner Elementary': {
					sales: null,
					active_listings: null,
					benchmark_price: '$724,800',
					one_year_change: '+2.3%'
				},
				'Neilsen Grove': {
					sales: null,
					active_listings: null,
					benchmark_price: '$941,300',
					one_year_change: '+1.1%'
				}
			},
			townhomes: {
				'Delta Manor': {
					sales: null,
					active_listings: null,
					benchmark_price: '$938,000',
					one_year_change: '-2.8%'
				},
				Hawthorne: {
					sales: null,
					active_listings: null,
					benchmark_price: '$830,500',
					one_year_change: '-3.1%'
				},
				Holly: {
					sales: null,
					active_listings: null,
					benchmark_price: '$848,100',
					one_year_change: '+4.2%'
				},
				'Ladner Elementary': {
					sales: null,
					active_listings: null,
					benchmark_price: '$793,000',
					one_year_change: '-3.2%'
				},
				'Neilsen Grove': {
					sales: null,
					active_listings: null,
					benchmark_price: '$1,144,100',
					one_year_change: '+0.3%'
				}
			}
		},
		Richmond: {
			detached: {
				'Boyd Park': {
					sales: 2,
					active_listings: 16,
					benchmark_price: '$2,168,400',
					one_year_change: '- 4.7%'
				},
				'Bridgeport RI': {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$1,969,100',
					one_year_change: '+ 9.5%'
				},
				Brighouse: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Brighouse South': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Broadmoor: {
					sales: 0,
					active_listings: 43,
					benchmark_price: '$2,654,300',
					one_year_change: '- 2.8%'
				},
				'East Cambie': {
					sales: 2,
					active_listings: 13,
					benchmark_price: '$2,056,300',
					one_year_change: '+ 9.0%'
				},
				'East Richmond': {
					sales: 1,
					active_listings: 13,
					benchmark_price: '$2,213,700',
					one_year_change: '- 9.9%'
				},
				'Garden City': {
					sales: 2,
					active_listings: 23,
					benchmark_price: '$1,934,300',
					one_year_change: '- 0.5%'
				},
				Gilmore: {
					sales: 0,
					active_listings: 10,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Granville: {
					sales: 2,
					active_listings: 41,
					benchmark_price: '$2,543,400',
					one_year_change: '- 0.1%'
				},
				'Hamilton RI': {
					sales: 2,
					active_listings: 19,
					benchmark_price: '$1,382,200',
					one_year_change: '- 5.7%'
				},
				Ironwood: {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$1,695,600',
					one_year_change: '- 6.5%'
				},
				Lackner: {
					sales: 1,
					active_listings: 21,
					benchmark_price: '$2,301,000',
					one_year_change: '- 4.2%'
				},
				McLennan: {
					sales: 0,
					active_listings: 15,
					benchmark_price: '$2,469,400',
					one_year_change: '- 8.1%'
				},
				'McLennan North': {
					sales: 0,
					active_listings: 9,
					benchmark_price: '$2,845,900',
					one_year_change: '+ 9.5%'
				},
				McNair: {
					sales: 3,
					active_listings: 16,
					benchmark_price: '$1,768,900',
					one_year_change: '- 5.9%'
				},
				'Quilchena RI': {
					sales: 4,
					active_listings: 34,
					benchmark_price: '$2,247,200',
					one_year_change: '+ 0.4%'
				},
				'Riverdale RI': {
					sales: 3,
					active_listings: 39,
					benchmark_price: '$2,455,600',
					one_year_change: '+ 0.8%'
				},
				Saunders: {
					sales: 3,
					active_listings: 23,
					benchmark_price: '$2,369,300',
					one_year_change: '- 1.7%'
				},
				'Sea Island': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$2,025,900',
					one_year_change: '- 2.2%'
				},
				Seafair: {
					sales: 4,
					active_listings: 34,
					benchmark_price: '$2,642,600',
					one_year_change: '- 3.8%'
				},
				'South Arm': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$2,324,000',
					one_year_change: '- 2.7%'
				},
				'Steveston North': {
					sales: 0,
					active_listings: 31,
					benchmark_price: '$1,784,100',
					one_year_change: '5.0%'
				},
				'Steveston South': {
					sales: 3,
					active_listings: 9,
					benchmark_price: '$1,988,800',
					one_year_change: '- 6.1%'
				},
				'Steveston Village': {
					sales: 1,
					active_listings: 11,
					benchmark_price: '$1,905,300',
					one_year_change: '- 4.3%'
				},
				'Terra Nova': {
					sales: 0,
					active_listings: 13,
					benchmark_price: '$2,445,000',
					one_year_change: '+ 1.2%'
				},
				'West Cambie': {
					sales: 2,
					active_listings: 29,
					benchmark_price: '$2,079,000',
					one_year_change: '+ 9.6%'
				},
				Westwind: {
					sales: 3,
					active_listings: 10,
					benchmark_price: '$2,073,000',
					one_year_change: '- 6.5%'
				},
				Woodwards: {
					sales: 3,
					active_listings: 33,
					benchmark_price: '$1,992,400',
					one_year_change: '- 0.8%'
				}
			},
			condos: {
				'Boyd Park': {
					sales: 5,
					active_listings: 8,
					benchmark_price: '$607,000',
					one_year_change: '+ 3.3%'
				},
				'Bridgeport RI': {
					sales: 1,
					active_listings: 12,
					benchmark_price: '$708,500',
					one_year_change: '- 0.5%'
				},
				Brighouse: {
					sales: 47,
					active_listings: 430,
					benchmark_price: '$788,500',
					one_year_change: '- 2.6%'
				},
				'Brighouse South': {
					sales: 24,
					active_listings: 66,
					benchmark_price: '$661,500',
					one_year_change: '- 1.5%'
				},
				Broadmoor: {
					sales: 2,
					active_listings: 2,
					benchmark_price: '$502,000',
					one_year_change: '- 1.3%'
				},
				'East Cambie': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$517,800',
					one_year_change: '+ 1.1%'
				},
				'East Richmond': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$815,000',
					one_year_change: '0.6%'
				},
				'Garden City': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Gilmore: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Granville: {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$264,100',
					one_year_change: '+ 0.3%'
				},
				'Hamilton RI': {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$842,600',
					one_year_change: '- 1.1%'
				},
				Ironwood: {
					sales: 1,
					active_listings: 15,
					benchmark_price: '$636,700',
					one_year_change: '- 1.4%'
				},
				Lackner: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				McLennan: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'McLennan North': {
					sales: 4,
					active_listings: 46,
					benchmark_price: '$761,500',
					one_year_change: '- 4.2%'
				},
				McNair: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Quilchena RI': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Riverdale RI': {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$683,200',
					one_year_change: '+ 4.0%'
				},
				Saunders: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sea Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Seafair: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$629,600',
					one_year_change: '+ 2.6%'
				},
				'South Arm': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$293,600',
					one_year_change: '- 2.5%'
				},
				'Steveston North': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$579,400',
					one_year_change: '+ 4.8%'
				},
				'Steveston South': {
					sales: 5,
					active_listings: 23,
					benchmark_price: '$781,900',
					one_year_change: '+ 1.8%'
				},
				'Steveston Village': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Terra Nova': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Cambie': {
					sales: 27,
					active_listings: 203,
					benchmark_price: '$812,200',
					one_year_change: '- 1.6%'
				},
				Westwind: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Woodwards: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Boyd Park': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$783,400',
					one_year_change: '- 4.4%'
				},
				'Bridgeport RI': {
					sales: 1,
					active_listings: 16,
					benchmark_price: '$1,089,300',
					one_year_change: '- 0.9%'
				},
				Brighouse: {
					sales: 4,
					active_listings: 28,
					benchmark_price: '$1,073,600',
					one_year_change: '+ 0.9%'
				},
				'Brighouse South': {
					sales: 7,
					active_listings: 36,
					benchmark_price: '$1,094,800',
					one_year_change: '+ 2.5%'
				},
				Broadmoor: {
					sales: 4,
					active_listings: 7,
					benchmark_price: '$1,119,100',
					one_year_change: '- 4.1%'
				},
				'East Cambie': {
					sales: 3,
					active_listings: 14,
					benchmark_price: '$857,000',
					one_year_change: '+ 4.9%'
				},
				'East Richmond': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Garden City': {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$1,138,400',
					one_year_change: '- 5.8%'
				},
				Gilmore: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Granville: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$1,109,500',
					one_year_change: '+ 0.9%'
				},
				'Hamilton RI': {
					sales: 5,
					active_listings: 21,
					benchmark_price: '$885,000',
					one_year_change: '- 2.8%'
				},
				Ironwood: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,062,700',
					one_year_change: '- 4.5%'
				},
				Lackner: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,318,700',
					one_year_change: '- 5.1%'
				},
				McLennan: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'McLennan North': {
					sales: 11,
					active_listings: 28,
					benchmark_price: '$1,221,400',
					one_year_change: '- 1.0%'
				},
				McNair: {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$856,800',
					one_year_change: '- 0.9%'
				},
				'Quilchena RI': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$872,700',
					one_year_change: '- 4.6%'
				},
				'Riverdale RI': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$1,087,300',
					one_year_change: '- 4.2%'
				},
				Saunders: {
					sales: 0,
					active_listings: 9,
					benchmark_price: '$1,039,900',
					one_year_change: '- 5.9%'
				},
				'Sea Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Seafair: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$972,600',
					one_year_change: '+ 6.2%'
				},
				'South Arm': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$1,194,200',
					one_year_change: '+ 6.7%'
				},
				'Steveston North': {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$961,000',
					one_year_change: '- 3.6%'
				},
				'Steveston South': {
					sales: 3,
					active_listings: 9,
					benchmark_price: '$1,221,300',
					one_year_change: '- 5.4%'
				},
				'Steveston Village': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$966,500',
					one_year_change: '- 2.6%'
				},
				'Terra Nova': {
					sales: 2,
					active_listings: 17,
					benchmark_price: '$1,262,700',
					one_year_change: '- 4.3%'
				},
				'West Cambie': {
					sales: 2,
					active_listings: 33,
					benchmark_price: '$1,208,700',
					one_year_change: '+ 0.2%'
				},
				Westwind: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$1,049,500',
					one_year_change: '- 2.2%'
				},
				Woodwards: {
					sales: 2,
					active_listings: 14,
					benchmark_price: '$1,373,300',
					one_year_change: '- 6.3%'
				}
			}
		},
		'Bowen Island': {
			detached: {
				'Bowen Island': {
					sales: 3,
					active_listings: 44,
					benchmark_price: '$1,386,300',
					one_year_change: '+ 2.5%'
				}
			},
			condos: {
				'Bowen Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Bowen Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		'Pitt Meadows': {
			detached: {
				'Central Meadows': {
					sales: 2,
					active_listings: 24,
					benchmark_price: '$1,269,600',
					one_year_change: '1.3%'
				},
				'Mid Meadows': {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$1,330,800',
					one_year_change: '+ 0.4%'
				},
				'North Meadows PI': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'South Meadows': {
					sales: 7,
					active_listings: 9,
					benchmark_price: '$1,355,400',
					one_year_change: '- 1.3%'
				},
				'West Meadows': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			condos: {
				'Central Meadows': {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$540,900',
					one_year_change: '- 2.8%'
				},
				'Mid Meadows': {
					sales: 2,
					active_listings: 13,
					benchmark_price: '$616,000',
					one_year_change: '3.0%'
				},
				'North Meadows PI': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'South Meadows': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Meadows': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Central Meadows': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$823,600',
					one_year_change: '+ 0.1%'
				},
				'Mid Meadows': {
					sales: 3,
					active_listings: 3,
					benchmark_price: '$789,800',
					one_year_change: '+ 1.0%'
				},
				'North Meadows PI': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'South Meadows': {
					sales: 8,
					active_listings: 15,
					benchmark_price: '$900,200',
					one_year_change: '+ 0.4%'
				},
				'West Meadows': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		'Burnaby East': {
			detached: {
				'East Burnaby': {
					sales: 4,
					active_listings: 15,
					benchmark_price: '$2,029,500',
					one_year_change: '+ 3.2%'
				},
				'Edmonds BE': {
					sales: 2,
					active_listings: 12,
					benchmark_price: '$1,863,800',
					one_year_change: '+ 0.1%'
				},
				'The Crest': {
					sales: 0,
					active_listings: 13,
					benchmark_price: '$1,977,700',
					one_year_change: '+ 0.4%'
				}
			},
			condos: {
				'East Burnaby': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$644,700',
					one_year_change: '- 3.3%'
				},
				'Edmonds BE': {
					sales: 14,
					active_listings: 86,
					benchmark_price: '$787,400',
					one_year_change: '+ 3.0%'
				},
				'The Crest': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'East Burnaby': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Edmonds BE': {
					sales: 4,
					active_listings: 18,
					benchmark_price: '$803,100',
					one_year_change: '- 1.4%'
				},
				'The Crest': {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$1,111,400',
					one_year_change: '- 1.4%'
				}
			}
		},
		Coquitlam: {
			detached: {
				'Burke Mountain': {
					sales: 3,
					active_listings: 54,
					benchmark_price: '$2,185,600',
					one_year_change: '+ 0.2%'
				},
				'Canyon Springs': {
					sales: 2,
					active_listings: 3,
					benchmark_price: '$1,539,800',
					one_year_change: '+ 4.7%'
				},
				'Cape Horn': {
					sales: 4,
					active_listings: 9,
					benchmark_price: '$1,477,200',
					one_year_change: '- 2.2%'
				},
				'Central Coquitlam': {
					sales: 10,
					active_listings: 39,
					benchmark_price: '$1,831,800',
					one_year_change: '- 2.7%'
				},
				Chineside: {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,683,600',
					one_year_change: '- 5.3%'
				},
				'Coquitlam East': {
					sales: 5,
					active_listings: 25,
					benchmark_price: '$1,747,600',
					one_year_change: '+ 4.2%'
				},
				'Coquitlam West': {
					sales: 5,
					active_listings: 86,
					benchmark_price: '$1,864,900',
					one_year_change: '- 0.1%'
				},
				'Eagle Ridge CQ': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,331,100',
					one_year_change: '+ 1.5%'
				},
				'Harbour Chines': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$2,104,600',
					one_year_change: '+ 1.5%'
				},
				'Harbour Place': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,803,300',
					one_year_change: '- 2.7%'
				},
				Hockaday: {
					sales: 2,
					active_listings: 9,
					benchmark_price: '$1,803,800',
					one_year_change: '- 0.3%'
				},
				Maillardville: {
					sales: 3,
					active_listings: 26,
					benchmark_price: '$1,760,200',
					one_year_change: '- 4.8%'
				},
				'Meadow Brook': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$1,165,400',
					one_year_change: '+ 3.2%'
				},
				'New Horizons': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,375,100',
					one_year_change: '+ 0.3%'
				},
				'North Coquitlam': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Park Ridge Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ranch Park': {
					sales: 1,
					active_listings: 110,
					benchmark_price: '$1,660,900',
					one_year_change: '+ 0.4%'
				},
				'River Springs': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$1,301,400',
					one_year_change: '+ 0.2%'
				},
				'Scott Creek': {
					sales: 4,
					active_listings: 3,
					benchmark_price: '$1,819,500',
					one_year_change: '+ 3.0%'
				},
				'Summitt View': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Eagle Ridge': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$1,735,300',
					one_year_change: '+ 2.8%'
				},
				'Westwood Plateau': {
					sales: 4,
					active_listings: 56,
					benchmark_price: '$2,032,600',
					one_year_change: '- 0.6%'
				},
				'Westwood Summit CQ': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			condos: {
				'Burke Mountain': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Canyon Springs': {
					sales: 2,
					active_listings: 10,
					benchmark_price: '$648,600',
					one_year_change: '+ 1.7%'
				},
				'Cape Horn': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central Coquitlam': {
					sales: 6,
					active_listings: 46,
					benchmark_price: '$594,300',
					one_year_change: '- 2.2%'
				},
				Chineside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Coquitlam East': {
					sales: 2,
					active_listings: 3,
					benchmark_price: '$589,900',
					one_year_change: '- 3.1%'
				},
				'Coquitlam West': {
					sales: 62,
					active_listings: 262,
					benchmark_price: '$766,500',
					one_year_change: '- 4.1%'
				},
				'Eagle Ridge CQ': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$690,400',
					one_year_change: '+ 0.4%'
				},
				'Harbour Chines': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Harbour Place': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Hockaday: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Maillardville: {
					sales: 7,
					active_listings: 22,
					benchmark_price: '$483,200',
					one_year_change: '- 2.0%'
				},
				'Meadow Brook': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'New Horizons': {
					sales: 5,
					active_listings: 28,
					benchmark_price: '$804,600',
					one_year_change: '- 4.8%'
				},
				'North Coquitlam': {
					sales: 21,
					active_listings: 109,
					benchmark_price: '$741,800',
					one_year_change: '- 0.7%'
				},
				'Park Ridge Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ranch Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'River Springs': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Scott Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Summitt View': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Eagle Ridge': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Westwood Plateau': {
					sales: 8,
					active_listings: 25,
					benchmark_price: '$734,700',
					one_year_change: '+ 1.2%'
				},
				'Westwood Summit CQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Burke Mountain': {
					sales: 4,
					active_listings: 72,
					benchmark_price: '$1,204,200',
					one_year_change: '+ 1.8%'
				},
				'Canyon Springs': {
					sales: 2,
					active_listings: 2,
					benchmark_price: '$727,600',
					one_year_change: '+ 1.6%'
				},
				'Cape Horn': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central Coquitlam': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$733,900',
					one_year_change: '- 3.0%'
				},
				Chineside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Coquitlam East': {
					sales: 2,
					active_listings: 1,
					benchmark_price: '$883,100',
					one_year_change: '+ 1.5%'
				},
				'Coquitlam West': {
					sales: 4,
					active_listings: 41,
					benchmark_price: '$1,070,800',
					one_year_change: '+ 0.4%'
				},
				'Eagle Ridge CQ': {
					sales: 2,
					active_listings: 4,
					benchmark_price: '$952,900',
					one_year_change: '+ 0.3%'
				},
				'Harbour Chines': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Harbour Place': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Hockaday: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Maillardville: {
					sales: 3,
					active_listings: 9,
					benchmark_price: '$804,200',
					one_year_change: '+ 2.9%'
				},
				'Meadow Brook': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'New Horizons': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$1,176,700',
					one_year_change: '+ 1.4%'
				},
				'North Coquitlam': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Park Ridge Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ranch Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$791,700',
					one_year_change: '+ 1.0%'
				},
				'River Springs': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Scott Creek': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$1,039,400',
					one_year_change: '- 2.5%'
				},
				'Summitt View': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Eagle Ridge': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$824,900',
					one_year_change: '+ 0.0%'
				},
				'Westwood Plateau': {
					sales: 7,
					active_listings: 16,
					benchmark_price: '$1,144,600',
					one_year_change: '- 3.7%'
				},
				'Westwood Summit CQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		'North Vancouver': {
			detached: {
				'Blueridge NV': {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$2,231,500',
					one_year_change: '+ 1.7%'
				},
				Boulevard: {
					sales: 5,
					active_listings: 14,
					benchmark_price: '$2,451,300',
					one_year_change: '+ 0.8%'
				},
				Braemar: {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Calverhall: {
					sales: 0,
					active_listings: 10,
					benchmark_price: '$2,046,100',
					one_year_change: '+ 1.1%'
				},
				'Canyon Heights NV': {
					sales: 8,
					active_listings: 32,
					benchmark_price: '$2,460,300',
					one_year_change: '+ 3.6%'
				},
				'Capilano NV': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$2,445,100',
					one_year_change: '+ 5.7%'
				},
				'Central Lonsdale': {
					sales: 2,
					active_listings: 20,
					benchmark_price: '$2,031,500',
					one_year_change: '- 3.1%'
				},
				'Deep Cove': {
					sales: 3,
					active_listings: 16,
					benchmark_price: '$2,007,100',
					one_year_change: '+ 1.6%'
				},
				Delbrook: {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$2,367,200',
					one_year_change: '+ 0.9%'
				},
				Dollarton: {
					sales: 3,
					active_listings: 7,
					benchmark_price: '$2,568,700',
					one_year_change: '+ 0.6%'
				},
				Edgemont: {
					sales: 2,
					active_listings: 15,
					benchmark_price: '$3,045,200',
					one_year_change: '+ 2.5%'
				},
				'Forest Hills NV': {
					sales: 4,
					active_listings: 9,
					benchmark_price: '$3,252,200',
					one_year_change: '+ 5.1%'
				},
				'Grouse Woods': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$2,370,200',
					one_year_change: '+ 1.2%'
				},
				Harbourside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Indian Arm': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Indian River': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$2,032,800',
					one_year_change: '+ 2.9%'
				},
				'Lower Lonsdale': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$2,268,200',
					one_year_change: '- 5.2%'
				},
				'Lynn Valley': {
					sales: 5,
					active_listings: 27,
					benchmark_price: '$2,036,500',
					one_year_change: '+ 0.3%'
				},
				Lynnmour: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Mosquito Creek': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Norgate: {
					sales: 2,
					active_listings: 4,
					benchmark_price: '$1,673,700',
					one_year_change: '- 1.2%'
				},
				Northlands: {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pemberton Heights': {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$2,261,200',
					one_year_change: '- 3.7%'
				},
				'Pemberton NV': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$1,654,300',
					one_year_change: '- 3.0%'
				},
				'Princess Park': {
					sales: 3,
					active_listings: 4,
					benchmark_price: '$2,132,100',
					one_year_change: '+ 0.3%'
				},
				Queensbury: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$2,009,600',
					one_year_change: '+ 3.8%'
				},
				'Roche Point': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$1,850,800',
					one_year_change: '+ 1.2%'
				},
				'Seymour NV': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$1,996,200',
					one_year_change: '+ 0.6%'
				},
				Tempe: {
					sales: 3,
					active_listings: 3,
					benchmark_price: '$2,442,700',
					one_year_change: '+ 8.1%'
				},
				'Upper Delbrook': {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$2,402,100',
					one_year_change: '+ 1.1%'
				},
				'Upper Lonsdale': {
					sales: 2,
					active_listings: 24,
					benchmark_price: '$2,239,900',
					one_year_change: '+ 0.5%'
				},
				Westlynn: {
					sales: 4,
					active_listings: 12,
					benchmark_price: '$1,891,300',
					one_year_change: '+ 0.3%'
				},
				'Westlynn Terrace': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Windsor Park NV': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$2,046,600',
					one_year_change: '- 1.4%'
				},
				'Woodlands-Sunshine-Cascade': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			condos: {
				'Blueridge NV': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Boulevard: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Braemar: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Calverhall: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Canyon Heights NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Capilano NV': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$1,101,200',
					one_year_change: '- 0.7%'
				},
				'Central Lonsdale': {
					sales: 14,
					active_listings: 65,
					benchmark_price: '$840,100',
					one_year_change: '+ 0.4%'
				},
				'Deep Cove': {
					sales: 2,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Delbrook: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dollarton: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Edgemont: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,220,700',
					one_year_change: '- 5.5%'
				},
				'Forest Hills NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Grouse Woods': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Harbourside: {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$961,400',
					one_year_change: '- 2.1%'
				},
				'Indian Arm': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Indian River': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$901,600',
					one_year_change: '+ 2.5%'
				},
				'Lower Lonsdale': {
					sales: 15,
					active_listings: 103,
					benchmark_price: '$805,100',
					one_year_change: '- 2.9%'
				},
				'Lynn Valley': {
					sales: 13,
					active_listings: 43,
					benchmark_price: '$932,900',
					one_year_change: '+ 0.9%'
				},
				Lynnmour: {
					sales: 6,
					active_listings: 56,
					benchmark_price: '$933,900',
					one_year_change: '+ 1.0%'
				},
				'Mosquito Creek': {
					sales: 8,
					active_listings: 8,
					benchmark_price: '$722,300',
					one_year_change: '+ 1.9%'
				},
				Norgate: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$854,500',
					one_year_change: '- 2.6%'
				},
				Northlands: {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$1,035,200',
					one_year_change: '+ 2.8%'
				},
				'Pemberton Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pemberton NV': {
					sales: 9,
					active_listings: 61,
					benchmark_price: '$531,500',
					one_year_change: '- 4.8%'
				},
				'Princess Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queensbury: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Roche Point': {
					sales: 8,
					active_listings: 35,
					benchmark_price: '$804,100',
					one_year_change: '+ 4.0%'
				},
				'Seymour NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Tempe: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Delbrook': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Lonsdale': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$717,200',
					one_year_change: '+ 0.7%'
				},
				Westlynn: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Westlynn Terrace': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Windsor Park NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Woodlands-Sunshine-Cascade': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Blueridge NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Boulevard: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Braemar: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Calverhall: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Canyon Heights NV': {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Capilano NV': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central Lonsdale': {
					sales: 4,
					active_listings: 8,
					benchmark_price: '$1,365,500',
					one_year_change: '+ 2.2%'
				},
				'Deep Cove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Delbrook: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dollarton: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Edgemont: {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$1,856,100',
					one_year_change: '+ 0.3%'
				},
				'Forest Hills NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Grouse Woods': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Harbourside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Indian Arm': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Indian River': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$1,361,500',
					one_year_change: '- 8.1%'
				},
				'Lower Lonsdale': {
					sales: 3,
					active_listings: 41,
					benchmark_price: '$1,446,100',
					one_year_change: '+ 2.1%'
				},
				'Lynn Valley': {
					sales: 3,
					active_listings: 7,
					benchmark_price: '$1,087,900',
					one_year_change: '- 9.1%'
				},
				Lynnmour: {
					sales: 1,
					active_listings: 18,
					benchmark_price: '$1,100,100',
					one_year_change: '- 9.5%'
				},
				'Mosquito Creek': {
					sales: 3,
					active_listings: 3,
					benchmark_price: '$1,211,800',
					one_year_change: '- 0.4%'
				},
				Norgate: {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,194,500',
					one_year_change: '+ 1.7%'
				},
				Northlands: {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,380,000',
					one_year_change: '- 9.2%'
				},
				'Pemberton Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pemberton NV': {
					sales: 2,
					active_listings: 14,
					benchmark_price: '$1,494,200',
					one_year_change: '+ 3.2%'
				},
				'Princess Park': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queensbury: {
					sales: 2,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Roche Point': {
					sales: 2,
					active_listings: 5,
					benchmark_price: '$1,292,900',
					one_year_change: '- 8.4%'
				},
				'Seymour NV': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$1,209,700',
					one_year_change: '- 8.5%'
				},
				Tempe: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Delbrook': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Lonsdale': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$1,110,400',
					one_year_change: '+ 3.2%'
				},
				Westlynn: {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$1,185,200',
					one_year_change: '- 9.2%'
				},
				'Westlynn Terrace': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Windsor Park NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Woodlands-Sunshine-Cascade': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		}
	},
	'April 2025': {
		'Vancouver West': {
			detached: {
				Arbutus: {
					sales: 2,
					active_listings: 29,
					benchmark_price: '$3,853,300',
					one_year_change: '-2.3%'
				},
				Cambie: {
					sales: 5,
					active_listings: 62,
					benchmark_price: '$3,052,200',
					one_year_change: '3.5%'
				},
				'Coal Harbour': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Downtown VW': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dunbar: {
					sales: 10,
					active_listings: 88,
					benchmark_price: '$3,309,200',
					one_year_change: '-3.4%'
				},
				'Fairview VW': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'False Creek': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Kerrisdale: {
					sales: 2,
					active_listings: 37,
					benchmark_price: '$3,648,400',
					one_year_change: '-1.4%'
				},
				Kitsilano: {
					sales: 7,
					active_listings: 42,
					benchmark_price: '$2,781,900',
					one_year_change: '-5.1%'
				},
				'MacKenzie Heights': {
					sales: 3,
					active_listings: 24,
					benchmark_price: '$3,822,600',
					one_year_change: '-2.2%'
				},
				Marpole: {
					sales: 2,
					active_listings: 37,
					benchmark_price: '$2,348,000',
					one_year_change: '-7.3%'
				},
				'Mount Pleasant VW': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$2,390,600',
					one_year_change: '-0.9%'
				},
				'Oakridge VW': {
					sales: 0,
					active_listings: 14,
					benchmark_price: '$3,718,600',
					one_year_change: '+5.4%'
				},
				'Point Grey': {
					sales: 9,
					active_listings: 108,
					benchmark_price: '$3,014,500',
					one_year_change: '-4.0%'
				},
				Quilchena: {
					sales: 1,
					active_listings: 24,
					benchmark_price: '$4,398,800',
					one_year_change: '+0.6%'
				},
				'S.W. Marine': {
					sales: 3,
					active_listings: 23,
					benchmark_price: '$3,182,700',
					one_year_change: '-5.1%'
				},
				Shaughnessy: {
					sales: 1,
					active_listings: 78,
					benchmark_price: '$4,834,700',
					one_year_change: '-2.8%'
				},
				'South Cambie': {
					sales: 0,
					active_listings: 12,
					benchmark_price: '$4,816,600',
					one_year_change: '+0.1%'
				},
				'South Granville': {
					sales: 5,
					active_listings: 86,
					benchmark_price: '$4,297,500',
					one_year_change: '-1.6%'
				},
				Southlands: {
					sales: 1,
					active_listings: 38,
					benchmark_price: '$3,511,600',
					one_year_change: '-7.6%'
				},
				'University VW': {
					sales: 1,
					active_listings: 25,
					benchmark_price: '$2,509,500',
					one_year_change: '-7.6%'
				},
				'West End W': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Yaletown: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			condos: {
				Arbutus: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cambie: {
					sales: 10,
					active_listings: 92,
					benchmark_price: '$1,140,400',
					one_year_change: '0.0%'
				},
				'Coal Harbour': {
					sales: 11,
					active_listings: 159,
					benchmark_price: '$1,286,900',
					one_year_change: '+1.1%'
				},
				'Downtown W': {
					sales: 61,
					active_listings: 557,
					benchmark_price: '$672,500',
					one_year_change: '-5.7%'
				},
				Dunbar: {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$1,021,100',
					one_year_change: '+4.0%'
				},
				'Fairview VW': {
					sales: 32,
					active_listings: 103,
					benchmark_price: '$852,600',
					one_year_change: '-0.5%'
				},
				'False Creek': {
					sales: 20,
					active_listings: 117,
					benchmark_price: '$835,900',
					one_year_change: '-3.7%'
				},
				Kerrisdale: {
					sales: 4,
					active_listings: 39,
					benchmark_price: '$1,115,400',
					one_year_change: '+2.9%'
				},
				Kitsilano: {
					sales: 27,
					active_listings: 80,
					benchmark_price: '$753,400',
					one_year_change: '-1.0%'
				},
				'MacKenzie Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Marpole: {
					sales: 13,
					active_listings: 96,
					benchmark_price: '$677,800',
					one_year_change: '-1.9%'
				},
				'Mount Pleasant VW': {
					sales: 7,
					active_listings: 10,
					benchmark_price: '$760,300',
					one_year_change: '-1.7%'
				},
				'Oakridge VW': {
					sales: 2,
					active_listings: 21,
					benchmark_price: '$995,000',
					one_year_change: '+2.6%'
				},
				'Point Grey': {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$855,300',
					one_year_change: '+0.9%'
				},
				Quilchena: {
					sales: 4,
					active_listings: 16,
					benchmark_price: '$1,259,000',
					one_year_change: '+4.2%'
				},
				'S.W. Marine': {
					sales: 2,
					active_listings: 12,
					benchmark_price: '$708,200',
					one_year_change: '+0.7%'
				},
				Shaughnessy: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,242,100',
					one_year_change: '+7.5%'
				},
				'South Cambie': {
					sales: 6,
					active_listings: 54,
					benchmark_price: '$1,143,100',
					one_year_change: '-0.4%'
				},
				'South Granville': {
					sales: 1,
					active_listings: 16,
					benchmark_price: '$1,221,300',
					one_year_change: '+0.3%'
				},
				Southlands: {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$988,200',
					one_year_change: '+3.9%'
				},
				'University VW': {
					sales: 20,
					active_listings: 128,
					benchmark_price: '$1,111,900',
					one_year_change: '-0.6%'
				},
				'West End W': {
					sales: 49,
					active_listings: 253,
					benchmark_price: '$691,800',
					one_year_change: '+2.4%'
				},
				Yaletown: {
					sales: 50,
					active_listings: 269,
					benchmark_price: '$877,100',
					one_year_change: '+1.2%'
				}
			},
			townhomes: {
				Arbutus: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cambie: {
					sales: 4,
					active_listings: 61,
					benchmark_price: '$1,709,800',
					one_year_change: '-4.7%'
				},
				'Coal Harbour': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$1,654,900',
					one_year_change: '-9.8%'
				},
				'Downtown W': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$1,109,500',
					one_year_change: '-12.8%'
				},
				Dunbar: {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Fairview VW': {
					sales: 6,
					active_listings: 27,
					benchmark_price: '$1,103,200',
					one_year_change: '+3.5%'
				},
				'False Creek': {
					sales: 2,
					active_listings: 9,
					benchmark_price: '$1,216,800',
					one_year_change: '-6.7%'
				},
				Kerrisdale: {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$1,634,300',
					one_year_change: '-5.0%'
				},
				Kitsilano: {
					sales: 11,
					active_listings: 34,
					benchmark_price: '$1,310,400',
					one_year_change: '-4.0%'
				},
				'MacKenzie Heights': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Marpole: {
					sales: 1,
					active_listings: 25,
					benchmark_price: '$1,560,500',
					one_year_change: '-6.9%'
				},
				'Mount Pleasant VW': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$1,218,300',
					one_year_change: '-8.3%'
				},
				'Oakridge VW': {
					sales: 0,
					active_listings: 13,
					benchmark_price: '$1,641,600',
					one_year_change: '-3.7%'
				},
				'Point Grey': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,310,100',
					one_year_change: '-4.3%'
				},
				Quilchena: {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,493,400',
					one_year_change: '-7.4%'
				},
				'S.W. Marine': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Shaughnessy: {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$1,883,700',
					one_year_change: '-6.0%'
				},
				'South Cambie': {
					sales: 2,
					active_listings: 27,
					benchmark_price: '$1,510,100',
					one_year_change: '-5.4%'
				},
				'South Granville': {
					sales: 1,
					active_listings: 37,
					benchmark_price: '$1,624,700',
					one_year_change: '-9.1%'
				},
				Southlands: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'University VW': {
					sales: 0,
					active_listings: 21,
					benchmark_price: '$1,715,700',
					one_year_change: '-5.5%'
				},
				'West End W': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,159,400',
					one_year_change: '-5.9%'
				},
				Yaletown: {
					sales: 4,
					active_listings: 20,
					benchmark_price: '$1,710,100',
					one_year_change: '-8.8%'
				}
			}
		},
		'Burnaby South': {
			city: 'Burnaby South',
			detached: {
				'Big Bend': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Buckingham Heights': {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$2,763,800',
					one_year_change: '6.0%'
				},
				'Burnaby Hospital': {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$2,181,300',
					one_year_change: '+ 1.5%'
				},
				'Burnaby Lake': {
					sales: 1,
					active_listings: 23,
					benchmark_price: '$2,153,100',
					one_year_change: '- 1.4%'
				},
				'Central Park BS': {
					sales: 2,
					active_listings: 15,
					benchmark_price: '$1,967,700',
					one_year_change: '+ 3.1%'
				},
				'Deer Lake': {
					sales: 0,
					active_listings: 10,
					benchmark_price: '$3,210,500',
					one_year_change: '- 5.6%'
				},
				'Deer Lake Place': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$2,157,000',
					one_year_change: '+ 1.7%'
				},
				'Forest Glen BS': {
					sales: 2,
					active_listings: 13,
					benchmark_price: '$2,267,300',
					one_year_change: '- 0.9%'
				},
				'Garden Village': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$2,311,600',
					one_year_change: '+ 3.4%'
				},
				'Greentree Village': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Highgate: {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$2,007,400',
					one_year_change: '+ 0.7%'
				},
				Metrotown: {
					sales: 1,
					active_listings: 12,
					benchmark_price: '$2,271,000',
					one_year_change: '- 1.0%'
				},
				Oaklands: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'South Slope': {
					sales: 3,
					active_listings: 37,
					benchmark_price: '$2,149,200',
					one_year_change: '- 0.2%'
				},
				Suncrest: {
					sales: 1,
					active_listings: 8,
					benchmark_price: '$2,204,200',
					one_year_change: '+ 3.0%'
				},
				'Upper Deer Lake': {
					sales: 2,
					active_listings: 19,
					benchmark_price: '$2,308,900',
					one_year_change: '- 1.3%'
				}
			},
			condos: {
				'Big Bend': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Buckingham Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Burnaby Hospital': {
					sales: 2,
					active_listings: 4,
					benchmark_price: '$642,400',
					one_year_change: '- 2.7%'
				},
				'Burnaby Lake': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central Park BS': {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$655,700',
					one_year_change: '+ 4.1%'
				},
				'Deer Lake': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Deer Lake Place': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Forest Glen BS': {
					sales: 6,
					active_listings: 45,
					benchmark_price: '$826,700',
					one_year_change: '+ 3.8%'
				},
				'Garden Village': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Greentree Village': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Highgate: {
					sales: 10,
					active_listings: 41,
					benchmark_price: '$754,700',
					one_year_change: '- 2.8%'
				},
				Metrotown: {
					sales: 41,
					active_listings: 327,
					benchmark_price: '$894,100',
					one_year_change: '- 2.2%'
				},
				Oaklands: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$713,600',
					one_year_change: '- 3.4%'
				},
				'South Slope': {
					sales: 6,
					active_listings: 20,
					benchmark_price: '$712,500',
					one_year_change: '- 3.7%'
				},
				Suncrest: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Deer Lake': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Big Bend': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Buckingham Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Burnaby Hospital': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$933,600',
					one_year_change: '- 2.7%'
				},
				'Burnaby Lake': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$1,164,500',
					one_year_change: '- 2.3%'
				},
				'Central Park BS': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$989,200',
					one_year_change: '4.2%'
				},
				'Deer Lake': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Deer Lake Place': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Forest Glen BS': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$941,500',
					one_year_change: '- 4.7%'
				},
				'Garden Village': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Greentree Village': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$928,100',
					one_year_change: '- 0.3%'
				},
				Highgate: {
					sales: 1,
					active_listings: 11,
					benchmark_price: '$933,300',
					one_year_change: '- 0.5%'
				},
				Metrotown: {
					sales: 4,
					active_listings: 14,
					benchmark_price: '$1,148,800',
					one_year_change: '- 3.5%'
				},
				Oaklands: {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$1,482,900',
					one_year_change: '- 2.8%'
				},
				'South Slope': {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$1,036,300',
					one_year_change: '- 2.8%'
				},
				Suncrest: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Deer Lake': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		'Burnaby North': {
			city: 'Burnaby North',
			detached: {
				'Brentwood Park': {
					sales: 1,
					active_listings: 17,
					benchmark_price: '$2,147,700',
					one_year_change: null
				},
				'Capitol Hill BN': {
					sales: 0,
					active_listings: 14,
					benchmark_price: '$2,133,100',
					one_year_change: null
				},
				Cariboo: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Central BN': {
					sales: 2,
					active_listings: 16,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Forest Hills BN': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Government Road': {
					sales: 3,
					active_listings: 15,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Lake City Industrial': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Montecito: {
					sales: 1,
					active_listings: 15,
					benchmark_price: '$0',
					one_year_change: null
				},
				Oakdale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Parkcrest: {
					sales: 0,
					active_listings: 31,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Simon Fraser Hills': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Simon Fraser Univer.': {
					sales: 0,
					active_listings: 15,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Sperling-Duthie': {
					sales: 2,
					active_listings: 12,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Sullivan Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Vancouver Heights': {
					sales: 1,
					active_listings: 15,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Westridge BN': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Willingdon Heights': {
					sales: 3,
					active_listings: 12,
					benchmark_price: '$0',
					one_year_change: null
				}
			},
			condos: {
				'Brentwood Park': {
					sales: 74,
					active_listings: 572,
					benchmark_price: '$733,300',
					one_year_change: null
				},
				'Capitol Hill BN': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Cariboo: {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Central BN': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Forest Hills BN': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Government Road': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Lake City Industrial': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Montecito: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Oakdale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Parkcrest: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Simon Fraser Hills': {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Simon Fraser Univer.': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Sperling-Duthie': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Sullivan Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Vancouver Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Westridge BN': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Willingdon Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				}
			},
			townhomes: {
				'Brentwood Park': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$908,800',
					one_year_change: null
				},
				'Capitol Hill BN': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: null
				},
				Cariboo: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Central BN': {
					sales: 3,
					active_listings: 10,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Forest Hills BN': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Government Road': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Lake City Industrial': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Montecito: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Oakdale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Parkcrest: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Simon Fraser Hills': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Simon Fraser Univer.': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Sperling-Duthie': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Sullivan Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Vancouver Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Westridge BN': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Willingdon Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				}
			}
		},
		'Vancouver East': {
			detached: {
				'Champlain Heights': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Collingwood VE': {
					sales: 6,
					active_listings: 119,
					benchmark_price: '$1,714,700',
					one_year_change: '-1.9%'
				},
				'Downtown VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Fraser VE': {
					sales: 4,
					active_listings: 59,
					benchmark_price: '$1,932,300',
					one_year_change: '+3.7%'
				},
				'Fraserview VE': {
					sales: 1,
					active_listings: 34,
					benchmark_price: '$2,233,000',
					one_year_change: '-0.9%'
				},
				'Grandview Woodland': {
					sales: 6,
					active_listings: 34,
					benchmark_price: '$1,790,700',
					one_year_change: '-1.4%'
				},
				Hastings: {
					sales: 1,
					active_listings: 11,
					benchmark_price: '$1,652,800',
					one_year_change: '5.9%'
				},
				'Hastings Sunrise': {
					sales: 2,
					active_listings: 24,
					benchmark_price: '$1,695,200',
					one_year_change: '-1.4%'
				},
				'Killarney VE': {
					sales: 5,
					active_listings: 45,
					benchmark_price: '$1,932,100',
					one_year_change: '-2.1%'
				},
				Knight: {
					sales: 7,
					active_listings: 56,
					benchmark_price: '$1,770,400',
					one_year_change: '-2.2%'
				},
				Main: {
					sales: 3,
					active_listings: 25,
					benchmark_price: '$2,127,600',
					one_year_change: '+1.2%'
				},
				'Mount Pleasant VE': {
					sales: 0,
					active_listings: 17,
					benchmark_price: '$1,877,600',
					one_year_change: '-6.0%'
				},
				'Renfrew Heights': {
					sales: 6,
					active_listings: 65,
					benchmark_price: '$1,789,100',
					one_year_change: '-0.6%'
				},
				'Renfrew VE': {
					sales: 15,
					active_listings: 87,
					benchmark_price: '$1,788,000',
					one_year_change: '+0.4%'
				},
				'South Marine': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$1,453,400',
					one_year_change: '+3.7%'
				},
				'South Vancouver': {
					sales: 1,
					active_listings: 65,
					benchmark_price: '$1,886,600',
					one_year_change: '+1.9%'
				},
				Strathcona: {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$1,597,500',
					one_year_change: '-5.7%'
				},
				'Victoria VE': {
					sales: 8,
					active_listings: 24,
					benchmark_price: '$1,727,900',
					one_year_change: '-2.2%'
				}
			},
			condos: {
				'Champlain Heights': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$808,500',
					one_year_change: '-3.5%'
				},
				'Collingwood VE': {
					sales: 17,
					active_listings: 103,
					benchmark_price: '$589,400',
					one_year_change: '3.2%'
				},
				'Downtown VE': {
					sales: 8,
					active_listings: 56,
					benchmark_price: '$644,300',
					one_year_change: '-4.8%'
				},
				'Fraser VE': {
					sales: 0,
					active_listings: 18,
					benchmark_price: '$820,600',
					one_year_change: '-2.1%'
				},
				'Fraserview VE': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Grandview Woodland': {
					sales: 3,
					active_listings: 37,
					benchmark_price: '$656,800',
					one_year_change: '+0.7%'
				},
				Hastings: {
					sales: 9,
					active_listings: 20,
					benchmark_price: '$558,800',
					one_year_change: '-2.9%'
				},
				'Hastings Sunrise': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$552,500',
					one_year_change: '1.9%'
				},
				'Killarney VE': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$628,000',
					one_year_change: '4.0%'
				},
				Knight: {
					sales: 3,
					active_listings: 11,
					benchmark_price: '$703,800',
					one_year_change: '-2.0%'
				},
				Main: {
					sales: 6,
					active_listings: 15,
					benchmark_price: '$1,035,700',
					one_year_change: '-0.9%'
				},
				'Mount Pleasant VE': {
					sales: 33,
					active_listings: 142,
					benchmark_price: '$732,600',
					one_year_change: '-1.3%'
				},
				'Renfrew Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$408,400',
					one_year_change: '+3.9%'
				},
				'Renfrew VE': {
					sales: 6,
					active_listings: 14,
					benchmark_price: '$728,500',
					one_year_change: '-0.8%'
				},
				'South Marine': {
					sales: 11,
					active_listings: 104,
					benchmark_price: '$818,300',
					one_year_change: '-3.8%'
				},
				'South Vancouver': {
					sales: 1,
					active_listings: 16,
					benchmark_price: '$639,200',
					one_year_change: '6.5%'
				},
				Strathcona: {
					sales: 7,
					active_listings: 34,
					benchmark_price: '$733,400',
					one_year_change: '0.7%'
				},
				'Victoria VE': {
					sales: 5,
					active_listings: 20,
					benchmark_price: '$774,500',
					one_year_change: '-3.2%'
				}
			},
			townhomes: {
				'Champlain Heights': {
					sales: 2,
					active_listings: 13,
					benchmark_price: '$1,007,200',
					one_year_change: '+1.3%'
				},
				'Collingwood VE': {
					sales: 0,
					active_listings: 13,
					benchmark_price: '$1,007,600',
					one_year_change: '+0.7%'
				},
				'Downtown VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Fraser VE': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,412,800',
					one_year_change: '-2.8%'
				},
				'Fraserview VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Grandview Woodland': {
					sales: 1,
					active_listings: 23,
					benchmark_price: '$1,424,600',
					one_year_change: '+2.1%'
				},
				Hastings: {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,227,900',
					one_year_change: '+0.1%'
				},
				'Hastings Sunrise': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Killarney VE': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$950,200',
					one_year_change: '-0.4%'
				},
				Knight: {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$1,309,400',
					one_year_change: '-4.2%'
				},
				Main: {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$1,217,000',
					one_year_change: '-1.7%'
				},
				'Mount Pleasant VE': {
					sales: 9,
					active_listings: 15,
					benchmark_price: '$1,113,600',
					one_year_change: '-10.0%'
				},
				'Renfrew Heights': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Renfrew VE': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$1,020,600',
					one_year_change: '+2.4%'
				},
				'South Marine': {
					sales: 1,
					active_listings: 24,
					benchmark_price: '$1,040,300',
					one_year_change: '+0.5%'
				},
				'South Vancouver': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Strathcona: {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$1,025,800',
					one_year_change: '-6.3%'
				},
				'Victoria VE': {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$1,305,600',
					one_year_change: '+1.5%'
				}
			}
		},
		'Maple Ridge': {
			detached: {
				Albion: {
					sales: 12,
					active_listings: 53,
					benchmark_price: '$1,325,900',
					one_year_change: '+ 2.1%'
				},
				'Cottonwood MR': {
					sales: 14,
					active_listings: 55,
					benchmark_price: '$1,364,700',
					one_year_change: '+ 1.5%'
				},
				'East Central': {
					sales: 8,
					active_listings: 95,
					benchmark_price: '$1,150,300',
					one_year_change: '- 2.0%'
				},
				'North Maple Ridge': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: null
				},
				Northeast: {
					sales: 0,
					active_listings: 9,
					benchmark_price: '$1,758,700',
					one_year_change: '- 6.1%'
				},
				'Northwest Maple Ridge': {
					sales: 5,
					active_listings: 42,
					benchmark_price: '$1,251,100',
					one_year_change: '- 0.1%'
				},
				'Silver Valley': {
					sales: 4,
					active_listings: 70,
					benchmark_price: '$1,484,300',
					one_year_change: '+ 0.8%'
				},
				'Southwest Maple Ridge': {
					sales: 10,
					active_listings: 63,
					benchmark_price: '$1,161,100',
					one_year_change: '- 1.5%'
				},
				'Thornhill MR': {
					sales: 1,
					active_listings: 32,
					benchmark_price: '$1,654,200',
					one_year_change: '0.7%'
				},
				'Websters Corners': {
					sales: 2,
					active_listings: 30,
					benchmark_price: '$1,405,300',
					one_year_change: '+ 0.3%'
				},
				'West Central': {
					sales: 5,
					active_listings: 105,
					benchmark_price: '$1,140,800',
					one_year_change: '+ 0.3%'
				},
				Whonnock: {
					sales: 2,
					active_listings: 16,
					benchmark_price: '$1,579,400',
					one_year_change: '+ 1.5%'
				}
			},
			condos: {
				Albion: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Cottonwood MR': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'East Central': {
					sales: 25,
					active_listings: 89,
					benchmark_price: '$511,200',
					one_year_change: '- 4.5%'
				},
				'North Maple Ridge': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Northeast: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Northwest Maple Ridge': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$536,200',
					one_year_change: '- 4.9%'
				},
				'Silver Valley': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Southwest Maple Ridge': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$418,900',
					one_year_change: '- 3.7%'
				},
				'Thornhill MR': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Websters Corners': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'West Central': {
					sales: 7,
					active_listings: 68,
					benchmark_price: '$535,600',
					one_year_change: '- 4.1%'
				},
				Whonnock: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				}
			},
			townhomes: {
				Albion: {
					sales: 5,
					active_listings: 21,
					benchmark_price: '$823,700',
					one_year_change: '+ 1.0%'
				},
				'Cottonwood MR': {
					sales: 10,
					active_listings: 32,
					benchmark_price: '$819,100',
					one_year_change: '+ 0.9%'
				},
				'East Central': {
					sales: 6,
					active_listings: 40,
					benchmark_price: '$766,900',
					one_year_change: '- 1.9%'
				},
				'North Maple Ridge': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Northeast: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Northwest Maple Ridge': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$699,400',
					one_year_change: '- 2.5%'
				},
				'Silver Valley': {
					sales: 1,
					active_listings: 12,
					benchmark_price: '$865,300',
					one_year_change: '1.6%'
				},
				'Southwest Maple Ridge': {
					sales: 3,
					active_listings: 8,
					benchmark_price: '$650,900',
					one_year_change: '- 2.4%'
				},
				'Thornhill MR': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Websters Corners': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'West Central': {
					sales: 4,
					active_listings: 15,
					benchmark_price: '$711,000',
					one_year_change: '- 1.6%'
				},
				Whonnock: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				}
			}
		},
		Whistler: {
			detached: {
				'Alpine Meadows': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Alta Vista': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Bayshores: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Benchlands: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Black Tusk - Pinecrest': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Blueberry Hill': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Brio: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cheakamus Crossing': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Emerald Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Function Junction': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Green Lake Estates': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Nesters: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Nordic: {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Rainbow: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Spring Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Spruce Grove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				WedgeWoods: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Westside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Cay Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Cay Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Creek': {
					sales: 3,
					active_listings: 19,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Village': {
					sales: 9,
					active_listings: 63,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'White Gold': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			condos: {
				'Alpine Meadows': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Alta Vista': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Bayshores: {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Benchlands: {
					sales: 4,
					active_listings: 16,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Black Tusk - Pinecrest': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Blueberry Hill': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Brio: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cheakamus Crossing': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Emerald Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Function Junction': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Green Lake Estates': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Nesters: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Nordic: {
					sales: 3,
					active_listings: 16,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Rainbow: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Spring Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Spruce Grove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				WedgeWoods: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Westside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Cay Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Cay Heights': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Creek': {
					sales: 3,
					active_listings: 10,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Village': {
					sales: 3,
					active_listings: 27,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'White Gold': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Alpine Meadows': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Alta Vista': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Bayshores: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Benchlands: {
					sales: 2,
					active_listings: 33,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Black Tusk - Pinecrest': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Blueberry Hill': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Brio: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cheakamus Crossing': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Emerald Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Function Junction': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Green Lake Estates': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Nesters: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Nordic: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Rainbow: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Spring Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Spruce Grove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				WedgeWoods: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Westside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Cay Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Cay Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Creek': {
					sales: 3,
					active_listings: 19,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whistler Village': {
					sales: 9,
					active_listings: 63,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'White Gold': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		'New Westminster': {
			detached: {
				'Connaught Heights': {
					sales: 0,
					active_listings: 18,
					benchmark_price: '$1,700,300',
					one_year_change: '+ 0.4%'
				},
				'Downtown NW': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Fraserview NW': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'GlenBrooke North': {
					sales: 0,
					active_listings: 10,
					benchmark_price: '$1,685,900',
					one_year_change: '- 0.9%'
				},
				'Moody Park': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$1,627,000',
					one_year_change: '+ 0.7%'
				},
				'North Arm': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				Quay: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: '--'
				},
				'Queens Park': {
					sales: 3,
					active_listings: 5,
					benchmark_price: '$2,074,400',
					one_year_change: '- 2.5%'
				},
				Queensborough: {
					sales: 4,
					active_listings: 32,
					benchmark_price: '$1,438,800',
					one_year_change: '6.0%'
				},
				Sapperton: {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$1,458,200',
					one_year_change: '+ 2.6%'
				},
				'The Heights NW': {
					sales: 2,
					active_listings: 20,
					benchmark_price: '$1,580,700',
					one_year_change: '+ 1.8%'
				},
				'Uptown NW': {
					sales: 1,
					active_listings: 11,
					benchmark_price: '$1,367,800',
					one_year_change: '- 2.8%'
				},
				'West End NW': {
					sales: 1,
					active_listings: 17,
					benchmark_price: '$1,601,100',
					one_year_change: '+ 0.9%'
				},
				'North Surrey': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			condos: {
				'Downtown NW': {
					sales: 10,
					active_listings: 96,
					benchmark_price: '$656,800',
					one_year_change: '- 1.2%'
				},
				'Fraserview NW': {
					sales: 13,
					active_listings: 35,
					benchmark_price: '$708,200',
					one_year_change: '- 2.1%'
				},
				'GlenBrooke North': {
					sales: 0,
					active_listings: 9,
					benchmark_price: '$611,100',
					one_year_change: '- 1.9%'
				},
				'Moody Park': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'North Arm': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Quay: {
					sales: 21,
					active_listings: 116,
					benchmark_price: '$692,100',
					one_year_change: '- 1.5%'
				},
				'Queens Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$729,300',
					one_year_change: '2.8%'
				},
				Queensborough: {
					sales: 3,
					active_listings: 26,
					benchmark_price: '$835,100',
					one_year_change: '- 5.6%'
				},
				Sapperton: {
					sales: 2,
					active_listings: 14,
					benchmark_price: '$542,100',
					one_year_change: '- 1.9%'
				},
				'The Heights NW': {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$578,500',
					one_year_change: '- 0.9%'
				},
				'Uptown NW': {
					sales: 14,
					active_listings: 63,
					benchmark_price: '$582,100',
					one_year_change: '- 1.6%'
				},
				'West End NW': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$420,800',
					one_year_change: '- 2.0%'
				},
				'North Surrey': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Downtown NW': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$761,600',
					one_year_change: '- 4.9%'
				},
				'Fraserview NW': {
					sales: 5,
					active_listings: 7,
					benchmark_price: '$1,003,400',
					one_year_change: '- 1.4%'
				},
				'GlenBrooke North': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$818,700',
					one_year_change: '4.8%'
				},
				'Moody Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'North Arm': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Queens Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queensborough: {
					sales: 3,
					active_listings: 25,
					benchmark_price: '$985,400',
					one_year_change: '- 2.1%'
				},
				Sapperton: {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Uptown NW': {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$722,300',
					one_year_change: '4.9%'
				}
			}
		},
		'Port Coquitlam': {
			detached: {
				'Birchland Manor': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,344,100',
					one_year_change: '- 2.5%'
				},
				'Central Pt Coquitlam': {
					sales: 1,
					active_listings: 13,
					benchmark_price: '$1,311,300',
					one_year_change: '- 2.2%'
				},
				'Citadel PQ': {
					sales: 3,
					active_listings: 15,
					benchmark_price: '$1,545,100',
					one_year_change: '- 1.5%'
				},
				'Glenwood PQ': {
					sales: 7,
					active_listings: 32,
					benchmark_price: '$1,328,400',
					one_year_change: '- 3.6%'
				},
				'Lincoln Park PQ': {
					sales: 1,
					active_listings: 20,
					benchmark_price: '$1,305,000',
					one_year_change: '- 3.8%'
				},
				'Lower Mary Hill': {
					sales: 0,
					active_listings: 9,
					benchmark_price: '$1,321,500',
					one_year_change: '- 1.2%'
				},
				'Mary Hill': {
					sales: 3,
					active_listings: 16,
					benchmark_price: '$1,399,400',
					one_year_change: '- 2.7%'
				},
				'Oxford Heights': {
					sales: 4,
					active_listings: 20,
					benchmark_price: '$1,409,600',
					one_year_change: '3.0%'
				},
				Riverwood: {
					sales: 4,
					active_listings: 13,
					benchmark_price: '$1,539,500',
					one_year_change: '0.6%'
				},
				'Woodland Acres PQ': {
					sales: 4,
					active_listings: 20,
					benchmark_price: '$1,442,200',
					one_year_change: '- 2.7%'
				}
			},
			condos: {
				'Birchland Manor': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central Pt Coquitlam': {
					sales: 15,
					active_listings: 95,
					benchmark_price: '$655,600',
					one_year_change: '+ 0.1%'
				},
				'Citadel PQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Glenwood PQ': {
					sales: 8,
					active_listings: 28,
					benchmark_price: '$558,200',
					one_year_change: '0.0%'
				},
				'Lincoln Park PQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Lower Mary Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Mary Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Oxford Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Riverwood: {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$718,400',
					one_year_change: '0.8%'
				},
				'Woodland Acres PQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Birchland Manor': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central Pt Coquitlam': {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$827,300',
					one_year_change: '- 1.6%'
				},
				'Citadel PQ': {
					sales: 2,
					active_listings: 5,
					benchmark_price: '$1,009,400',
					one_year_change: '- 1.2%'
				},
				'Glenwood PQ': {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$907,000',
					one_year_change: '+ 1.1%'
				},
				'Lincoln Park PQ': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$923,400',
					one_year_change: '+ 0.6%'
				},
				'Lower Mary Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Mary Hill': {
					sales: 4,
					active_listings: 4,
					benchmark_price: '$935,400',
					one_year_change: '0.9%'
				},
				'Oxford Heights': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$918,600',
					one_year_change: '4.5%'
				},
				Riverwood: {
					sales: 7,
					active_listings: 30,
					benchmark_price: '$1,007,100',
					one_year_change: '- 1.8%'
				},
				'Woodland Acres PQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		Squamish: {
			detached: {
				Brackendale: {
					sales: 6,
					active_listings: 7,
					benchmark_price: '$1,399,400',
					one_year_change: '+ 4.3%'
				},
				'Brennan Center': {
					sales: 4,
					active_listings: 7,
					benchmark_price: '$1,874,300',
					one_year_change: '+ 12.2%'
				},
				'Britannia Beach': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Business Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dentville: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Downtown SQ': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Garibaldi Estates': {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$1,456,500',
					one_year_change: '+ 4.1%'
				},
				'Garibaldi Highlands': {
					sales: 6,
					active_listings: 13,
					benchmark_price: '$1,751,200',
					one_year_change: '+ 5.7%'
				},
				'Hospital Hill': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northyards: {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Paradise Valley': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Plateau: {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$2,197,900',
					one_year_change: '+ 10.5%'
				},
				'Ring Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Squamish Rural': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Tantalus: {
					sales: 2,
					active_listings: 5,
					benchmark_price: '$1,984,700',
					one_year_change: '+ 8.1%'
				},
				'University Highlands': {
					sales: 1,
					active_listings: 12,
					benchmark_price: '$2,118,700',
					one_year_change: '+ 11.2%'
				},
				'Upper Squamish': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Valleycliffe: {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$1,349,600',
					one_year_change: '+ 5.5%'
				}
			},
			condos: {
				Brackendale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Brennan Center': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Britannia Beach': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Business Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dentville: {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$635,200',
					one_year_change: '- 0.4%'
				},
				'Downtown SQ': {
					sales: 12,
					active_listings: 48,
					benchmark_price: '$666,200',
					one_year_change: '- 0.6%'
				},
				'Garibaldi Estates': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$554,800',
					one_year_change: '- 1.1%'
				},
				'Garibaldi Highlands': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Hospital Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northyards: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Paradise Valley': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Plateau: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ring Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Squamish Rural': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Tantalus: {
					sales: 4,
					active_listings: 7,
					benchmark_price: '$554,800',
					one_year_change: '- 1.1%'
				},
				'University Highlands': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Squamish': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Valleycliffe: {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$413,100',
					one_year_change: '- 6.4%'
				}
			},
			townhomes: {
				Brackendale: {
					sales: 2,
					active_listings: 0,
					benchmark_price: '$1,062,400',
					one_year_change: '- 1.1%'
				},
				'Brennan Center': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,165,700',
					one_year_change: '- 2.6%'
				},
				'Britannia Beach': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Business Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dentville: {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$1,171,500',
					one_year_change: '- 3.4%'
				},
				'Downtown SQ': {
					sales: 2,
					active_listings: 10,
					benchmark_price: '$1,080,600',
					one_year_change: '- 2.6%'
				},
				'Garibaldi Estates': {
					sales: 3,
					active_listings: 5,
					benchmark_price: '$856,200',
					one_year_change: '3.8%'
				},
				'Garibaldi Highlands': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,017,500',
					one_year_change: '- 2.5%'
				},
				'Hospital Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northyards: {
					sales: 2,
					active_listings: 1,
					benchmark_price: '$1,045,500',
					one_year_change: '- 4.1%'
				},
				'Paradise Valley': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Plateau: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ring Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Squamish Rural': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Tantalus: {
					sales: 4,
					active_listings: 1,
					benchmark_price: '$1,164,100',
					one_year_change: '3.0%'
				},
				'University Highlands': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Squamish': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Valleycliffe: {
					sales: 5,
					active_listings: 11,
					benchmark_price: '$919,500',
					one_year_change: '- 2.9%'
				}
			}
		},
		Tsawwassen: {
			detached: {
				'Beach Grove': {
					sales: 5,
					active_listings: 21,
					benchmark_price: '$1,601,300',
					one_year_change: '-2.6%'
				},
				'Boundary Beach': {
					sales: 3,
					active_listings: 19,
					benchmark_price: '$1,594,600',
					one_year_change: '1.3%'
				},
				'Cliff Drive': {
					sales: 0,
					active_listings: 13,
					benchmark_price: '$1,535,900',
					one_year_change: '-2.1%'
				},
				'English Bluff': {
					sales: 2,
					active_listings: 12,
					benchmark_price: '$1,811,700',
					one_year_change: '-5.0%'
				},
				'Pebble Hill': {
					sales: 3,
					active_listings: 31,
					benchmark_price: '$1,613,600',
					one_year_change: '-1.0%'
				},
				'Tsawwassen Central': {
					sales: 2,
					active_listings: 24,
					benchmark_price: '$1,473,100',
					one_year_change: '-3.5%'
				},
				'Tsawwassen East': {
					sales: 1,
					active_listings: 13,
					benchmark_price: '$1,570,300',
					one_year_change: '-1.1%'
				},
				'Tsawwassen North': {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$1,633,400',
					one_year_change: '-2.0%'
				}
			},
			condos: {
				'Beach Grove': {
					sales: 1,
					active_listings: 11,
					benchmark_price: '$633,000',
					one_year_change: ''
				},
				'Boundary Beach': {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cliff Drive': {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$623,600',
					one_year_change: ''
				},
				'English Bluff': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pebble Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Tsawwassen Central': {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$639,700',
					one_year_change: ''
				},
				'Tsawwassen East': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Tsawwassen North': {
					sales: 9,
					active_listings: 66,
					benchmark_price: '$646,100',
					one_year_change: ''
				}
			},
			townhomes: {
				'Beach Grove': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Boundary Beach': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$1,013,200',
					one_year_change: ''
				},
				'Cliff Drive': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'English Bluff': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pebble Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Tsawwassen Central': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Tsawwassen East': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Tsawwassen North': {
					sales: 2,
					active_listings: 29,
					benchmark_price: '$971,700',
					one_year_change: ''
				}
			}
		},
		'West Vancouver': {
			detached: {
				Altamont: {
					sales: 0,
					active_listings: 23,
					benchmark_price: '$5,774,900',
					one_year_change: '+ 4.1%'
				},
				Ambleside: {
					sales: 0,
					active_listings: 48,
					benchmark_price: '$3,135,900',
					one_year_change: '+ 1.6%'
				},
				Bayridge: {
					sales: 2,
					active_listings: 12,
					benchmark_price: '$2,964,700',
					one_year_change: '- 2.6%'
				},
				'British Properties': {
					sales: 6,
					active_listings: 90,
					benchmark_price: '$3,438,800',
					one_year_change: '- 0.5%'
				},
				'Canterbury WV': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Caulfeild: {
					sales: 1,
					active_listings: 36,
					benchmark_price: '$3,089,800',
					one_year_change: '- 1.1%'
				},
				Cedardale: {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$2,736,000',
					one_year_change: '+ 1.8%'
				},
				Chartwell: {
					sales: 0,
					active_listings: 35,
					benchmark_price: '$5,432,100',
					one_year_change: '- 3.9%'
				},
				'Chelsea Park': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cypress: {
					sales: 3,
					active_listings: 13,
					benchmark_price: '$4,039,700',
					one_year_change: '+ 7.4%'
				},
				'Cypress Park Estates': {
					sales: 1,
					active_listings: 18,
					benchmark_price: '$3,533,300',
					one_year_change: '+ 6.5%'
				},
				'Deer Ridge WV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dundarave: {
					sales: 0,
					active_listings: 41,
					benchmark_price: '$3,718,300',
					one_year_change: '+ 4.2%'
				},
				'Eagle Harbour': {
					sales: 2,
					active_listings: 17,
					benchmark_price: '$2,437,400',
					one_year_change: '+ 2.7%'
				},
				Eagleridge: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Furry Creek': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Gleneagles: {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$2,962,100',
					one_year_change: '1.8%'
				},
				Glenmore: {
					sales: 1,
					active_listings: 21,
					benchmark_price: '$2,327,300',
					one_year_change: '+ 1.0%'
				},
				'Horseshoe Bay WV': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$2,030,100',
					one_year_change: '- 3.1%'
				},
				'Howe Sound': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Lions Bay': {
					sales: 2,
					active_listings: 16,
					benchmark_price: '$2,124,700',
					one_year_change: '0.2%'
				},
				'Olde Caulfeild': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Panorama Village': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Park Royal': {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Passage Island': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queens: {
					sales: 1,
					active_listings: 15,
					benchmark_price: '$3,781,500',
					one_year_change: '+ 0.2%'
				},
				Rockridge: {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sandy Cove': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sentinel Hill': {
					sales: 1,
					active_listings: 22,
					benchmark_price: '$2,898,700',
					one_year_change: '- 0.8%'
				},
				'Upper Caulfeild': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$3,148,400',
					one_year_change: '+ 0.3%'
				},
				'West Bay': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$3,896,600',
					one_year_change: '- 3.0%'
				},
				Westhill: {
					sales: 0,
					active_listings: 10,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Westmount WV': {
					sales: 0,
					active_listings: 12,
					benchmark_price: '$4,604,000',
					one_year_change: '- 2.8%'
				},
				'Whitby Estates': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Whytecliff: {
					sales: 2,
					active_listings: 4,
					benchmark_price: '$2,534,100',
					one_year_change: '- 1.6%'
				}
			},
			condos: {
				Altamont: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Ambleside: {
					sales: 5,
					active_listings: 35,
					benchmark_price: '$896,400',
					one_year_change: '- 12.0%'
				},
				Bayridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'British Properties': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Canterbury WV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Caulfeild: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cedardale: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Chartwell: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Chelsea Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cypress: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cypress Park Estates': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$2,028,400',
					one_year_change: '- 5.1%'
				},
				'Deer Ridge WV': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dundarave: {
					sales: 1,
					active_listings: 25,
					benchmark_price: '$1,466,300',
					one_year_change: '- 5.6%'
				},
				'Eagle Harbour': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Eagleridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Furry Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Gleneagles: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Glenmore: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Horseshoe Bay WV': {
					sales: 0,
					active_listings: 21,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Howe Sound': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Lions Bay': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Olde Caulfeild': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Panorama Village': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$1,450,500',
					one_year_change: '- 9.5%'
				},
				'Park Royal': {
					sales: 2,
					active_listings: 34,
					benchmark_price: '$1,267,700',
					one_year_change: '- 8.0%'
				},
				'Passage Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queens: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Rockridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sandy Cove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sentinel Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Caulfeild': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Bay': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Westhill: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Westmount WV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whitby Estates': {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Whytecliff: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				Altamont: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Ambleside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Bayridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'British Properties': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Canterbury WV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Caulfeild: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cedardale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Chartwell: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Chelsea Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Cypress: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cypress Park Estates': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Deer Ridge WV': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dundarave: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Eagle Harbour': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Eagleridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Furry Creek': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Gleneagles: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Glenmore: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Horseshoe Bay WV': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Howe Sound': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Lions Bay': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Olde Caulfeild': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Panorama Village': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Park Royal': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Passage Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queens: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Rockridge: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sandy Cove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sentinel Hill': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Caulfeild': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Bay': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Westhill: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Westmount WV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Whitby Estates': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Whytecliff: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		'Sunshine Coast': {
			detached: {
				'Gambier Island': {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Gibsons & Area': {
					sales: 9,
					active_listings: 108,
					benchmark_price: '$853,600',
					one_year_change: '5.8%'
				},
				'Halfmn Bay Secret Cv Redroofs': {
					sales: 5,
					active_listings: 51,
					benchmark_price: '$879,200',
					one_year_change: '- 6.3%'
				},
				'Keats Island': {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Nelson Island': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pender Harbour Egmont': {
					sales: 6,
					active_listings: 71,
					benchmark_price: '$761,000',
					one_year_change: '- 4.6%'
				},
				'Roberts Creek': {
					sales: 4,
					active_listings: 31,
					benchmark_price: '$933,000',
					one_year_change: '- 6.7%'
				},
				'Sechelt District': {
					sales: 16,
					active_listings: 169,
					benchmark_price: '$822,800',
					one_year_change: '5.4%'
				},
				'TOTAL*': {
					sales: 41,
					active_listings: 452,
					benchmark_price: '$840,000',
					one_year_change: '5.6%'
				}
			},
			condos: {
				'Gambier Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Gibsons & Area': {
					sales: 3,
					active_listings: 20,
					benchmark_price: '$523,500',
					one_year_change: '5.7%'
				},
				'Halfmn Bay Secret Cv Redroofs': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Keats Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Nelson Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pender Harbour Egmont': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Roberts Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sechelt District': {
					sales: 4,
					active_listings: 19,
					benchmark_price: '$497,200',
					one_year_change: '- 2.5%'
				},
				'TOTAL*': {
					sales: 7,
					active_listings: 43,
					benchmark_price: '$507,500',
					one_year_change: '4.5%'
				}
			},
			townhomes: {
				'Gambier Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Gibsons & Area': {
					sales: 1,
					active_listings: 14,
					benchmark_price: '$776,400',
					one_year_change: '- 3.0%'
				},
				'Halfmn Bay Secret Cv Redroofs': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Keats Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Nelson Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pender Harbour Egmont': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Roberts Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sechelt District': {
					sales: 3,
					active_listings: 12,
					benchmark_price: '$732,600',
					one_year_change: '4.5%'
				},
				'TOTAL*': {
					sales: 4,
					active_listings: 34,
					benchmark_price: '$753,700',
					one_year_change: '- 3.8%'
				}
			}
		},
		Richmond: {
			detached: {
				'Boyd Park': {
					sales: 1,
					active_listings: 17,
					benchmark_price: '$2,147,300',
					one_year_change: '-1.1%'
				},
				'Bridgeport RI': {
					sales: 0,
					active_listings: 10,
					benchmark_price: '$1,932,900',
					one_year_change: '+6.0%'
				},
				Brighouse: {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Brighouse South': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Broadmoor: {
					sales: 5,
					active_listings: 47,
					benchmark_price: '$2,599,700',
					one_year_change: '-5.1%'
				},
				'East Cambie': {
					sales: 0,
					active_listings: 15,
					benchmark_price: '$2,017,800',
					one_year_change: '+6.2%'
				},
				'East Richmond': {
					sales: 1,
					active_listings: 13,
					benchmark_price: '$2,218,600',
					one_year_change: '+0.0%'
				},
				'Garden City': {
					sales: 2,
					active_listings: 26,
					benchmark_price: '$1,885,400',
					one_year_change: '-4.2%'
				},
				Gilmore: {
					sales: 0,
					active_listings: 9,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Granville: {
					sales: 1,
					active_listings: 42,
					benchmark_price: '$2,522,900',
					one_year_change: '-1.8%'
				},
				'Hamilton RI': {
					sales: 2,
					active_listings: 21,
					benchmark_price: '$1,395,800',
					one_year_change: '-5.9%'
				},
				Ironwood: {
					sales: 1,
					active_listings: 18,
					benchmark_price: '$1,733,800',
					one_year_change: '-5.3%'
				},
				Lackner: {
					sales: 4,
					active_listings: 22,
					benchmark_price: '$2,279,200',
					one_year_change: '-0.6%'
				},
				McLennan: {
					sales: 0,
					active_listings: 16,
					benchmark_price: '$2,534,000',
					one_year_change: '-6.7%'
				},
				'McLennan North': {
					sales: 0,
					active_listings: 9,
					benchmark_price: '$2,794,200',
					one_year_change: '+6.9%'
				},
				McNair: {
					sales: 1,
					active_listings: 26,
					benchmark_price: '$1,815,600',
					one_year_change: '-4.8%'
				},
				'Quilchena RI': {
					sales: 1,
					active_listings: 40,
					benchmark_price: '$2,204,600',
					one_year_change: '-1.1%'
				},
				'Riverdale RI': {
					sales: 4,
					active_listings: 40,
					benchmark_price: '$2,419,300',
					one_year_change: '-0.7%'
				},
				Saunders: {
					sales: 5,
					active_listings: 24,
					benchmark_price: '$2,322,800',
					one_year_change: '-4.0%'
				},
				'Sea Island': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$1,892,900',
					one_year_change: '+10.7%'
				},
				Seafair: {
					sales: 5,
					active_listings: 30,
					benchmark_price: '$2,633,400',
					one_year_change: '-0.2%'
				},
				'South Arm': {
					sales: 0,
					active_listings: 18,
					benchmark_price: '$2,262,000',
					one_year_change: '-5.0%'
				},
				'Steveston North': {
					sales: 2,
					active_listings: 36,
					benchmark_price: '$1,786,900',
					one_year_change: '-5.1%'
				},
				'Steveston South': {
					sales: 2,
					active_listings: 15,
					benchmark_price: '$1,981,900',
					one_year_change: '+6.0%'
				},
				'Steveston Village': {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$1,903,500',
					one_year_change: '-4.1%'
				},
				'Terra Nova': {
					sales: 1,
					active_listings: 18,
					benchmark_price: '$2,399,700',
					one_year_change: '+0.4%'
				},
				'West Cambie': {
					sales: 2,
					active_listings: 26,
					benchmark_price: '$2,048,600',
					one_year_change: '+6.0%'
				},
				Westwind: {
					sales: 0,
					active_listings: 13,
					benchmark_price: '$2,071,000',
					one_year_change: '-5.5%'
				},
				Woodwards: {
					sales: 4,
					active_listings: 36,
					benchmark_price: '$1,948,800',
					one_year_change: '-3.6%'
				}
			},
			condos: {
				'Boyd Park': {
					sales: 2,
					active_listings: 12,
					benchmark_price: '$559,500',
					one_year_change: '-7.1%'
				},
				'Bridgeport RI': {
					sales: 0,
					active_listings: 14,
					benchmark_price: '$681,500',
					one_year_change: '-4.5%'
				},
				Brighouse: {
					sales: 51,
					active_listings: 461,
					benchmark_price: '$781,400',
					one_year_change: '-3.1%'
				},
				'Brighouse South': {
					sales: 13,
					active_listings: 73,
					benchmark_price: '$668,600',
					one_year_change: '-2.4%'
				},
				Broadmoor: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$493,000',
					one_year_change: '-4.1%'
				},
				'East Cambie': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$509,000',
					one_year_change: '-3.2%'
				},
				'East Richmond': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$774,000',
					one_year_change: '-3.9%'
				},
				'Garden City': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Gilmore: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Granville: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$253,800',
					one_year_change: '-3.2%'
				},
				'Hamilton RI': {
					sales: 1,
					active_listings: 11,
					benchmark_price: '$810,600',
					one_year_change: '-5.2%'
				},
				Ironwood: {
					sales: 2,
					active_listings: 13,
					benchmark_price: '$611,600',
					one_year_change: '-5.3%'
				},
				Lackner: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				McLennan: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'McLennan North': {
					sales: 10,
					active_listings: 42,
					benchmark_price: '$744,400',
					one_year_change: '-7.1%'
				},
				McNair: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Quilchena RI': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Riverdale RI': {
					sales: 1,
					active_listings: 12,
					benchmark_price: '$626,200',
					one_year_change: '-5.9%'
				},
				Saunders: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sea Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Seafair: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$579,400',
					one_year_change: '-7.4%'
				},
				'South Arm': {
					sales: 1,
					active_listings: 8,
					benchmark_price: '$284,800',
					one_year_change: '-5.3%'
				},
				'Steveston North': {
					sales: 2,
					active_listings: 1,
					benchmark_price: '$523,000',
					one_year_change: '-6.9%'
				},
				'Steveston South': {
					sales: 7,
					active_listings: 28,
					benchmark_price: '$787,500',
					one_year_change: '+1.9%'
				},
				'Steveston Village': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Terra Nova': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Cambie': {
					sales: 26,
					active_listings: 234,
					benchmark_price: '$779,100',
					one_year_change: '-5.3%'
				},
				Westwind: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Woodwards: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Boyd Park': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$790,400',
					one_year_change: '-3.6%'
				},
				'Bridgeport RI': {
					sales: 1,
					active_listings: 19,
					benchmark_price: '$1,092,100',
					one_year_change: '-1.9%'
				},
				Brighouse: {
					sales: 1,
					active_listings: 31,
					benchmark_price: '$1,051,500',
					one_year_change: '-0.9%'
				},
				'Brighouse South': {
					sales: 9,
					active_listings: 36,
					benchmark_price: '$1,028,600',
					one_year_change: ''
				},
				Broadmoor: {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$1,086,900',
					one_year_change: '-7.6%'
				},
				'East Cambie': {
					sales: 1,
					active_listings: 16,
					benchmark_price: '$873,400',
					one_year_change: '-3.0%'
				},
				'East Richmond': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Garden City': {
					sales: 3,
					active_listings: 10,
					benchmark_price: '$1,130,600',
					one_year_change: '-7.7%'
				},
				Gilmore: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Granville: {
					sales: 1,
					active_listings: 8,
					benchmark_price: '$1,082,900',
					one_year_change: '+0.0%'
				},
				'Hamilton RI': {
					sales: 1,
					active_listings: 27,
					benchmark_price: '$897,700',
					one_year_change: '-2.4%'
				},
				Ironwood: {
					sales: 3,
					active_listings: 4,
					benchmark_price: '$1,048,300',
					one_year_change: '-5.3%'
				},
				Lackner: {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$1,336,200',
					one_year_change: '-3.8%'
				},
				McLennan: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'McLennan North': {
					sales: 3,
					active_listings: 34,
					benchmark_price: '$1,187,300',
					one_year_change: '-5.3%'
				},
				McNair: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$866,300',
					one_year_change: '+1.2%'
				},
				'Quilchena RI': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$880,100',
					one_year_change: '-3.2%'
				},
				'Riverdale RI': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$1,096,500',
					one_year_change: '-3.8%'
				},
				Saunders: {
					sales: 2,
					active_listings: 13,
					benchmark_price: '$1,028,500',
					one_year_change: '-7.8%'
				},
				'Sea Island': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Seafair: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$981,400',
					one_year_change: '-4.9%'
				},
				'South Arm': {
					sales: 2,
					active_listings: 2,
					benchmark_price: '$1,196,000',
					one_year_change: '+7.5%'
				},
				'Steveston North': {
					sales: 2,
					active_listings: 10,
					benchmark_price: '$974,500',
					one_year_change: '-1.7%'
				},
				'Steveston South': {
					sales: 3,
					active_listings: 16,
					benchmark_price: '$1,225,800',
					one_year_change: '-5.2%'
				},
				'Steveston Village': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$986,600',
					one_year_change: '-1.5%'
				},
				'Terra Nova': {
					sales: 3,
					active_listings: 17,
					benchmark_price: '$1,292,700',
					one_year_change: '-2.0%'
				},
				'West Cambie': {
					sales: 7,
					active_listings: 28,
					benchmark_price: '$1,183,700',
					one_year_change: '-0.8%'
				},
				Westwind: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,072,200',
					one_year_change: '-0.1%'
				},
				Woodwards: {
					sales: 1,
					active_listings: 24,
					benchmark_price: '$1,358,200',
					one_year_change: '-7.4%'
				}
			}
		},
		'Bowen Island': {
			detached: {
				'Bowen Island': {
					sales: '0',
					active_listings: '3',
					benchmark_price: '$1,386,300',
					one_year_change: ''
				}
			},
			condos: {
				'Bowen Island': {
					sales: '0',
					active_listings: '0',
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Bowen Island': {
					sales: '0',
					active_listings: '0',
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		'Pitt Meadows': {
			detached: {
				'Central Meadows': {
					sales: null,
					active_listings: null,
					benchmark_price: null,
					one_year_change: null
				},
				'Mid Meadows': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$1,308,400',
					one_year_change: '0.8%'
				},
				'North Meadows PI': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'South Meadows': {
					sales: 4,
					active_listings: 11,
					benchmark_price: '$1,322,600',
					one_year_change: '-3.3%'
				},
				'West Meadows': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			condos: {
				'Central Meadows': {
					sales: 2,
					active_listings: 12,
					benchmark_price: '$545,700',
					one_year_change: '-3.1%'
				},
				'Mid Meadows': {
					sales: 2,
					active_listings: 17,
					benchmark_price: '$619,400',
					one_year_change: '4.4%'
				},
				'North Meadows PI': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'South Meadows': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Meadows': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Central Meadows': {
					sales: 2,
					active_listings: 7,
					benchmark_price: '$811,300',
					one_year_change: '-3.2%'
				},
				'Mid Meadows': {
					sales: 2,
					active_listings: 2,
					benchmark_price: '$783,700',
					one_year_change: '-3.4%'
				},
				'North Meadows PI': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'South Meadows': {
					sales: 5,
					active_listings: 17,
					benchmark_price: '$891,100',
					one_year_change: '-2.2%'
				},
				'West Meadows': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		'Burnaby East': {
			detached: {
				'East Burnaby': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,957,700',
					one_year_change: '0.3%'
				},
				'Edmonds BE': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$1,811,600',
					one_year_change: '-1.3%'
				},
				'The Crest': {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$1,944,400',
					one_year_change: '-1.5%'
				}
			},
			condos: {
				'East Burnaby': {
					sales: 3,
					active_listings: 11,
					benchmark_price: '$626,400',
					one_year_change: '-3.9%'
				},
				'Edmonds BE': {
					sales: 4,
					active_listings: 68,
					benchmark_price: '$778,900',
					one_year_change: '-2.9%'
				}
			},
			townhomes: {
				'East Burnaby': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$897,100',
					one_year_change: '-0.5%'
				},
				'Edmonds BE': {
					sales: 1,
					active_listings: 23,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'The Crest': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		Coquitlam: {
			detached: {
				'Burke Mountain': {
					sales: 2,
					active_listings: 63,
					benchmark_price: '$2,135,300',
					one_year_change: '- 2.6%'
				},
				'Canyon Springs': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$1,479,500',
					one_year_change: '- 2.6%'
				},
				'Cape Horn': {
					sales: 1,
					active_listings: 12,
					benchmark_price: '$1,483,600',
					one_year_change: '- 1.9%'
				},
				'Central Coquitlam': {
					sales: 12,
					active_listings: 45,
					benchmark_price: '$1,836,200',
					one_year_change: '- 1.9%'
				},
				Chineside: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,678,200',
					one_year_change: '- 8.9%'
				},
				'Coquitlam East': {
					sales: 6,
					active_listings: 34,
					benchmark_price: '$1,735,500',
					one_year_change: '- 1.0%'
				},
				'Coquitlam West': {
					sales: 2,
					active_listings: 90,
					benchmark_price: '$1,844,500',
					one_year_change: '- 4.9%'
				},
				'Eagle Ridge CQ': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$1,297,200',
					one_year_change: '- 2.4%'
				},
				'Harbour Chines': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$2,095,200',
					one_year_change: '5.4%'
				},
				'Harbour Place': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$1,791,000',
					one_year_change: '- 6.3%'
				},
				Hockaday: {
					sales: 2,
					active_listings: 9,
					benchmark_price: '$1,736,700',
					one_year_change: '- 3.2%'
				},
				Maillardville: {
					sales: 5,
					active_listings: 20,
					benchmark_price: '$1,804,600',
					one_year_change: '- 2.7%'
				},
				'Meadow Brook': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,148,500',
					one_year_change: '+ 0.3%'
				},
				'New Horizons': {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$1,344,200',
					one_year_change: '- 2.7%'
				},
				'North Coquitlam': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Park Ridge Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ranch Park': {
					sales: 2,
					active_listings: 115,
					benchmark_price: '$1,657,100',
					one_year_change: '- 2.6%'
				},
				'River Springs': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$1,261,400',
					one_year_change: '- 3.2%'
				},
				'Scott Creek': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$1,795,000',
					one_year_change: '- 2.2%'
				},
				'Summitt View': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Eagle Ridge': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$1,715,400',
					one_year_change: '0.9%'
				},
				'Westwood Plateau': {
					sales: 9,
					active_listings: 68,
					benchmark_price: '$1,971,700',
					one_year_change: '- 2.9%'
				},
				'Westwood Summit CQ': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			condos: {
				'Burke Mountain': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Canyon Springs': {
					sales: 5,
					active_listings: 13,
					benchmark_price: '$632,100',
					one_year_change: '- 1.5%'
				},
				'Cape Horn': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central Coquitlam': {
					sales: 5,
					active_listings: 42,
					benchmark_price: '$585,600',
					one_year_change: '- 2.1%'
				},
				Chineside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Coquitlam East': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$593,800',
					one_year_change: '- 2.0%'
				},
				'Coquitlam West': {
					sales: 33,
					active_listings: 277,
					benchmark_price: '$762,400',
					one_year_change: '- 3.4%'
				},
				'Eagle Ridge CQ': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$692,300',
					one_year_change: '0.4%'
				},
				'Harbour Chines': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Harbour Place': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Hockaday: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Maillardville: {
					sales: 5,
					active_listings: 28,
					benchmark_price: '$487,500',
					one_year_change: '- 2.0%'
				},
				'Meadow Brook': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'New Horizons': {
					sales: 4,
					active_listings: 32,
					benchmark_price: '$824,300',
					one_year_change: '- 2.9%'
				},
				'North Coquitlam': {
					sales: 17,
					active_listings: 134,
					benchmark_price: '$734,000',
					one_year_change: '- 3.1%'
				},
				'Park Ridge Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ranch Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'River Springs': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Scott Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Summitt View': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Eagle Ridge': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Westwood Plateau': {
					sales: 6,
					active_listings: 29,
					benchmark_price: '$716,300',
					one_year_change: '- 3.4%'
				},
				'Westwood Summit CQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Burke Mountain': {
					sales: 37,
					active_listings: 77,
					benchmark_price: '$1,208,200',
					one_year_change: '+ 1.1%'
				},
				'Canyon Springs': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$731,100',
					one_year_change: '- 2.7%'
				},
				'Cape Horn': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central Coquitlam': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$726,100',
					one_year_change: '- 2.8%'
				},
				Chineside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Coquitlam East': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$851,800',
					one_year_change: '- 2.6%'
				},
				'Coquitlam West': {
					sales: 4,
					active_listings: 54,
					benchmark_price: '$1,058,900',
					one_year_change: '- 2.7%'
				},
				'Eagle Ridge CQ': {
					sales: 5,
					active_listings: 5,
					benchmark_price: '$963,200',
					one_year_change: '+ 0.1%'
				},
				'Harbour Chines': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Harbour Place': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Hockaday: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Maillardville: {
					sales: 3,
					active_listings: 15,
					benchmark_price: '$777,500',
					one_year_change: '- 2.0%'
				},
				'Meadow Brook': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'New Horizons': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$1,168,400',
					one_year_change: '+ 0.1%'
				},
				'North Coquitlam': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Park Ridge Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ranch Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$760,300',
					one_year_change: '- 4.5%'
				},
				'River Springs': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Scott Creek': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$1,068,700',
					one_year_change: '- 0.7%'
				},
				'Summitt View': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Eagle Ridge': {
					sales: 2,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Westwood Plateau': {
					sales: 5,
					active_listings: 18,
					benchmark_price: '$1,130,900',
					one_year_change: '- 5.9%'
				},
				'Westwood Summit CQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		'North Vancouver': {
			Detached: {
				'Blueridge NV': {
					sales: 4,
					active_listings: 15,
					benchmark_price: '$2,198,800',
					one_year_change: '- 3.2%'
				},
				Boulevard: {
					sales: 5,
					active_listings: 15,
					benchmark_price: '$2,378,600',
					one_year_change: '6.0%'
				},
				Braemar: {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Calverhall: {
					sales: 1,
					active_listings: 16,
					benchmark_price: '$2,021,100',
					one_year_change: '+ 1.0%'
				},
				'Canyon Heights NV': {
					sales: 6,
					active_listings: 40,
					benchmark_price: '$2,372,100',
					one_year_change: '- 0.6%'
				},
				'Capilano NV': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$2,354,500',
					one_year_change: '- 1.3%'
				},
				'Central Lonsdale': {
					sales: 2,
					active_listings: 26,
					benchmark_price: '$2,023,800',
					one_year_change: '- 3.8%'
				},
				'Deep Cove': {
					sales: 6,
					active_listings: 20,
					benchmark_price: '$1,948,400',
					one_year_change: '4.0%'
				},
				Delbrook: {
					sales: 2,
					active_listings: 5,
					benchmark_price: '$2,303,300',
					one_year_change: '- 2.0%'
				},
				Dollarton: {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$2,535,900',
					one_year_change: '- 5.8%'
				},
				Edgemont: {
					sales: 4,
					active_listings: 21,
					benchmark_price: '$2,935,800',
					one_year_change: '- 3.3%'
				},
				'Forest Hills NV': {
					sales: 0,
					active_listings: 14,
					benchmark_price: '$3,193,400',
					one_year_change: '+ 2.2%'
				},
				'Grouse Woods': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$2,344,500',
					one_year_change: '+ 0.5%'
				},
				Harbourside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Indian Arm': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Indian River': {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$1,985,200',
					one_year_change: '- 3.3%'
				},
				'Lower Lonsdale': {
					sales: 3,
					active_listings: 6,
					benchmark_price: '$2,297,300',
					one_year_change: '4.3%'
				},
				'Lynn Valley': {
					sales: 10,
					active_listings: 33,
					benchmark_price: '$2,005,100',
					one_year_change: '- 1.6%'
				},
				Lynnmour: {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Mosquito Creek': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Norgate: {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$1,651,300',
					one_year_change: '+ 0.6%'
				},
				Northlands: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pemberton Heights': {
					sales: 3,
					active_listings: 11,
					benchmark_price: '$2,317,500',
					one_year_change: '3.0%'
				},
				'Pemberton NV': {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$1,634,300',
					one_year_change: '3.8%'
				},
				'Princess Park': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$2,102,500',
					one_year_change: '- 2.4%'
				},
				Queensbury: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$1,976,400',
					one_year_change: '- 3.6%'
				},
				'Roche Point': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$1,821,400',
					one_year_change: '- 3.9%'
				},
				'Seymour NV': {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$1,965,600',
					one_year_change: '- 3.9%'
				},
				Tempe: {
					sales: 2,
					active_listings: 1,
					benchmark_price: '$2,357,200',
					one_year_change: '+ 1.8%'
				},
				'Upper Delbrook': {
					sales: 4,
					active_listings: 12,
					benchmark_price: '$2,343,200',
					one_year_change: '- 1.2%'
				},
				'Upper Lonsdale': {
					sales: 8,
					active_listings: 28,
					benchmark_price: '$2,187,500',
					one_year_change: '- 2.3%'
				},
				Westlynn: {
					sales: 5,
					active_listings: 11,
					benchmark_price: '$1,840,700',
					one_year_change: '- 3.2%'
				},
				'Westlynn Terrace': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Windsor Park NV': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,999,500',
					one_year_change: '- 4.5%'
				},
				'Woodlands-Sunshine-Cascade': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			Condos: {
				'Blueridge NV': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Boulevard: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Braemar: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Calverhall: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Canyon Heights NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Capilano NV': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,066,000',
					one_year_change: '- 4.1%'
				},
				'Central Lonsdale': {
					sales: 13,
					active_listings: 84,
					benchmark_price: '$830,000',
					one_year_change: '- 1.8%'
				},
				'Deep Cove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Delbrook: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dollarton: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Edgemont: {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,254,700',
					one_year_change: '- 5.5%'
				},
				'Forest Hills NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Grouse Woods': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Harbourside: {
					sales: 3,
					active_listings: 5,
					benchmark_price: '$928,200',
					one_year_change: '- 5.6%'
				},
				'Indian Arm': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Indian River': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$881,300',
					one_year_change: '- 1.2%'
				},
				'Lower Lonsdale': {
					sales: 27,
					active_listings: 122,
					benchmark_price: '$815,400',
					one_year_change: '1.8%'
				},
				'Lynn Valley': {
					sales: 16,
					active_listings: 40,
					benchmark_price: '$933,800',
					one_year_change: '+ 1.5%'
				},
				Lynnmour: {
					sales: 9,
					active_listings: 62,
					benchmark_price: '$932,400',
					one_year_change: '+ 1.0%'
				},
				'Mosquito Creek': {
					sales: 3,
					active_listings: 10,
					benchmark_price: '$712,400',
					one_year_change: '- 0.9%'
				},
				Norgate: {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$834,700',
					one_year_change: '- 4.5%'
				},
				Northlands: {
					sales: 2,
					active_listings: 4,
					benchmark_price: '$1,011,400',
					one_year_change: '+ 0.8%'
				},
				'Pemberton Heights': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pemberton NV': {
					sales: 10,
					active_listings: 57,
					benchmark_price: '$522,100',
					one_year_change: '4.7%'
				},
				'Princess Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queensbury: {
					sales: 2,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Roche Point': {
					sales: 6,
					active_listings: 43,
					benchmark_price: '$782,000',
					one_year_change: '+ 1.1%'
				},
				'Seymour NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Tempe: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Delbrook': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Lonsdale': {
					sales: 3,
					active_listings: 5,
					benchmark_price: '$724,000',
					one_year_change: '+ 3.6%'
				},
				Westlynn: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Westlynn Terrace': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Windsor Park NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Woodlands-Sunshine-Cascade': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			Townhomes: {
				'Blueridge NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Boulevard: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Braemar: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Calverhall: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Canyon Heights NV': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Capilano NV': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central Lonsdale': {
					sales: 2,
					active_listings: 12,
					benchmark_price: '$1,367,700',
					one_year_change: '- 1.8%'
				},
				'Deep Cove': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Delbrook: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Dollarton: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Edgemont: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$1,883,200',
					one_year_change: '- 2.0%'
				},
				'Forest Hills NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Grouse Woods': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Harbourside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Indian Arm': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Indian River': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,393,300',
					one_year_change: '- 8.0%'
				},
				'Lower Lonsdale': {
					sales: 6,
					active_listings: 41,
					benchmark_price: '$1,461,400',
					one_year_change: '- 0.7%'
				},
				'Lynn Valley': {
					sales: 2,
					active_listings: 10,
					benchmark_price: '$1,098,100',
					one_year_change: '- 9.3%'
				},
				Lynnmour: {
					sales: 5,
					active_listings: 16,
					benchmark_price: '$1,118,700',
					one_year_change: '- 8.3%'
				},
				'Mosquito Creek': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$1,218,500',
					one_year_change: '- 2.6%'
				},
				Norgate: {
					sales: 2,
					active_listings: 0,
					benchmark_price: '$1,229,800',
					one_year_change: '+ 0.6%'
				},
				Northlands: {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$1,392,200',
					one_year_change: '8.9%'
				},
				'Pemberton Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Pemberton NV': {
					sales: 1,
					active_listings: 15,
					benchmark_price: '$1,485,700',
					one_year_change: '- 2.3%'
				},
				'Princess Park': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Queensbury: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Roche Point': {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$1,319,700',
					one_year_change: '- 7.3%'
				},
				'Seymour NV': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$1,201,400',
					one_year_change: '8.8%'
				},
				Tempe: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Delbrook': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Lonsdale': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$1,118,900',
					one_year_change: '+ 0.1%'
				},
				Westlynn: {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$1,208,000',
					one_year_change: '- 7.9%'
				},
				'Westlynn Terrace': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Windsor Park NV': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Woodlands-Sunshine-Cascade': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		}
	},
	'May 2025': {
		'Maple Ridge': {
			detached: {
				Albion: {
					sales: 5,
					active_listings: 78,
					benchmark_price: '$1,315,700',
					one_year_change: '+ 1.9%'
				},
				'Cottonwood MR': {
					sales: 8,
					active_listings: 58,
					benchmark_price: '$1,363,900',
					one_year_change: '+ 1.3%'
				},
				'East Central': {
					sales: 15,
					active_listings: 103,
					benchmark_price: '$1,143,300',
					one_year_change: '- 3.3%'
				},
				'North Maple Ridge': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northeast: {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$1,799,300',
					one_year_change: '- 4.9%'
				},
				'Northwest Maple Ridge': {
					sales: 9,
					active_listings: 38,
					benchmark_price: '$1,191,900',
					one_year_change: '- 4.7%'
				},
				'Silver Valley': {
					sales: 9,
					active_listings: 67,
					benchmark_price: '$1,480,500',
					one_year_change: '- 1.2%'
				},
				'Southwest Maple Ridge': {
					sales: 6,
					active_listings: 73,
					benchmark_price: '$1,154,600',
					one_year_change: '- 0.4%'
				},
				'Thornhill MR': {
					sales: 5,
					active_listings: 24,
					benchmark_price: '$1,663,600',
					one_year_change: '2.5%'
				},
				'Websters Corners': {
					sales: 2,
					active_listings: 39,
					benchmark_price: '$1,421,200',
					one_year_change: '0.2%'
				},
				'West Central': {
					sales: 8,
					active_listings: 110,
					benchmark_price: '$1,052,300',
					one_year_change: '- 7.4%'
				},
				Whonnock: {
					sales: 2,
					active_listings: 13,
					benchmark_price: '$1,602,500',
					one_year_change: '+ 1.6%'
				}
			},
			condos: {
				Albion: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cottonwood MR': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'East Central': {
					sales: 14,
					active_listings: 100,
					benchmark_price: '$516,500',
					one_year_change: '- 3.5%'
				},
				'North Maple Ridge': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northeast: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Northwest Maple Ridge': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$545,300',
					one_year_change: '- 3.5%'
				},
				'Silver Valley': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Southwest Maple Ridge': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$419,900',
					one_year_change: '- 3.3%'
				},
				'Thornhill MR': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Websters Corners': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Central': {
					sales: 12,
					active_listings: 61,
					benchmark_price: '$543,200',
					one_year_change: '- 2.6%'
				},
				Whonnock: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				Albion: {
					sales: 7,
					active_listings: 20,
					benchmark_price: '$823,200',
					one_year_change: '+ 0.5%'
				},
				'Cottonwood MR': {
					sales: 11,
					active_listings: 40,
					benchmark_price: '$818,800',
					one_year_change: '+ 0.3%'
				},
				'East Central': {
					sales: 6,
					active_listings: 55,
					benchmark_price: '$775,500',
					one_year_change: '- 1.6%'
				},
				'North Maple Ridge': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northeast: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Northwest Maple Ridge': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$689,300',
					one_year_change: '- 3.5%'
				},
				'Silver Valley': {
					sales: 5,
					active_listings: 11,
					benchmark_price: '$867,600',
					one_year_change: '- 1.9%'
				},
				'Southwest Maple Ridge': {
					sales: 3,
					active_listings: 7,
					benchmark_price: '$644,300',
					one_year_change: '- 2.5%'
				},
				'Thornhill MR': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Websters Corners': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Central': {
					sales: 2,
					active_listings: 15,
					benchmark_price: '$714,100',
					one_year_change: '- 1.8%'
				},
				Whonnock: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		Coquitlam: {
			detached: {
				'Burke Mountain': {
					sales: 5,
					active_listings: 65,
					benchmark_price: '$2,117,600',
					one_year_change: '- 5.8%'
				},
				'Canyon Springs': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$1,498,600',
					one_year_change: '0.2%'
				},
				'Cape Horn': {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$1,474,100',
					one_year_change: '- 3.0%'
				},
				'Central Coquitlam': {
					sales: 12,
					active_listings: 50,
					benchmark_price: '$1,829,400',
					one_year_change: '- 2.7%'
				},
				Chineside: {
					sales: 0,
					active_listings: 10,
					benchmark_price: '$1,662,800',
					one_year_change: '10.4%'
				},
				'Coquitlam East': {
					sales: 7,
					active_listings: 34,
					benchmark_price: '$1,732,700',
					one_year_change: '- 2.0%'
				},
				'Coquitlam West': {
					sales: 6,
					active_listings: 88,
					benchmark_price: '$1,851,800',
					one_year_change: '- 5.5%'
				},
				'Eagle Ridge CQ': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$1,328,800',
					one_year_change: '1.9%'
				},
				'Harbour Chines': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$2,084,600',
					one_year_change: '- 7.6%'
				},
				'Harbour Place': {
					sales: 2,
					active_listings: 5,
					benchmark_price: '$1,778,400',
					one_year_change: '- 9.1%'
				},
				Hockaday: {
					sales: 0,
					active_listings: 9,
					benchmark_price: '$1,734,500',
					one_year_change: '- 6.6%'
				},
				Maillardville: {
					sales: 3,
					active_listings: 31,
					benchmark_price: '$1,780,700',
					one_year_change: '- 2.3%'
				},
				'Meadow Brook': {
					sales: 0,
					active_listings: 8,
					benchmark_price: '$1,145,000',
					one_year_change: '+ 0.9%'
				},
				'New Horizons': {
					sales: 4,
					active_listings: 12,
					benchmark_price: '$1,331,100',
					one_year_change: '- 5.4%'
				},
				'North Coquitlam': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Park Ridge Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Ranch Park': {
					sales: 2,
					active_listings: 116,
					benchmark_price: '$1,655,400',
					one_year_change: '0.3%'
				},
				'River Springs': {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$1,251,800',
					one_year_change: '- 6.1%'
				},
				'Scott Creek': {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$1,780,600',
					one_year_change: '- 2.0%'
				},
				'Summitt View': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Upper Eagle Ridge': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$1,724,600',
					one_year_change: '- 1.0%'
				},
				'Westwood Plateau': {
					sales: 6,
					active_listings: 79,
					benchmark_price: '$1,905,200',
					one_year_change: '- 3.8%'
				},
				'Westwood Summit CQ': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: null
				}
			},
			condos: {
				'Burke Mountain': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Canyon Springs': {
					sales: 7,
					active_listings: 9,
					benchmark_price: '$625,500',
					one_year_change: '- 2.5%'
				},
				'Cape Horn': {
					sales: 0,
					active_listings: 9,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Central Coquitlam': {
					sales: 4,
					active_listings: 46,
					benchmark_price: '$584,000',
					one_year_change: '- 2.3%'
				},
				Chineside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Coquitlam East': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$590,800',
					one_year_change: '- 1.7%'
				},
				'Coquitlam West': {
					sales: 39,
					active_listings: 263,
					benchmark_price: '$758,100',
					one_year_change: '- 3.5%'
				},
				'Eagle Ridge CQ': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$697,500',
					one_year_change: '0.6%'
				},
				'Harbour Chines': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Harbour Place': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Hockaday: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Maillardville: {
					sales: 3,
					active_listings: 25,
					benchmark_price: '$489,100',
					one_year_change: '- 2.3%'
				},
				'Meadow Brook': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'New Horizons': {
					sales: 7,
					active_listings: 33,
					benchmark_price: '$825,800',
					one_year_change: '- 2.2%'
				},
				'North Coquitlam': {
					sales: 28,
					active_listings: 119,
					benchmark_price: '$726,500',
					one_year_change: '- 3.9%'
				},
				'Park Ridge Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Ranch Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'River Springs': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Scott Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Summitt View': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Upper Eagle Ridge': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Westwood Plateau': {
					sales: 10,
					active_listings: 23,
					benchmark_price: '$706,500',
					one_year_change: '- 3.9%'
				},
				'Westwood Summit CQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				}
			},
			townhomes: {
				'Burke Mountain': {
					sales: 13,
					active_listings: 89,
					benchmark_price: '$1,232,000',
					one_year_change: '+ 1.7%'
				},
				'Canyon Springs': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$734,800',
					one_year_change: '- 2.3%'
				},
				'Cape Horn': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Central Coquitlam': {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$717,900',
					one_year_change: '- 6.5%'
				},
				Chineside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Coquitlam East': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$825,900',
					one_year_change: '- 8.3%'
				},
				'Coquitlam West': {
					sales: 3,
					active_listings: 59,
					benchmark_price: '$1,024,100',
					one_year_change: '- 7.4%'
				},
				'Eagle Ridge CQ': {
					sales: 3,
					active_listings: 3,
					benchmark_price: '$977,400',
					one_year_change: '+ 0.2%'
				},
				'Harbour Chines': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Harbour Place': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Hockaday: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				Maillardville: {
					sales: 4,
					active_listings: 15,
					benchmark_price: '$772,600',
					one_year_change: '- 3.9%'
				},
				'Meadow Brook': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'New Horizons': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$1,192,900',
					one_year_change: '+ 0.4%'
				},
				'North Coquitlam': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Park Ridge Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Ranch Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$749,100',
					one_year_change: '- 7.2%'
				},
				'River Springs': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Scott Creek': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$1,081,600',
					one_year_change: '- 1.4%'
				},
				'Summitt View': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				},
				'Upper Eagle Ridge': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$851,900',
					one_year_change: '+ 0.4%'
				},
				'Westwood Plateau': {
					sales: 6,
					active_listings: 16,
					benchmark_price: '$1,098,500',
					one_year_change: '9.8%'
				},
				'Westwood Summit CQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: null
				}
			}
		},
		'Vancouver East': {
			detached: {
				'Champlain Heights': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Collingwood VE': {
					sales: 3,
					active_listings: 126,
					benchmark_price: '$1,670,700',
					one_year_change: '6.3%'
				},
				'Downtown VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Fraser VE': {
					sales: 10,
					active_listings: 64,
					benchmark_price: '$1,859,200',
					one_year_change: '- 0.2%'
				},
				'Fraserview VE': {
					sales: 2,
					active_listings: 34,
					benchmark_price: '$2,144,800',
					one_year_change: '- 4.4%'
				},
				'Grandview Woodland': {
					sales: 8,
					active_listings: 33,
					benchmark_price: '$1,789,100',
					one_year_change: '- 2.7%'
				},
				Hastings: {
					sales: 0,
					active_listings: 13,
					benchmark_price: '$1,772,300',
					one_year_change: '- 0.7%'
				},
				'Hastings Sunrise': {
					sales: 2,
					active_listings: 25,
					benchmark_price: '$1,694,800',
					one_year_change: '+ 0.8%'
				},
				'Killarney VE': {
					sales: 2,
					active_listings: 56,
					benchmark_price: '$1,820,500',
					one_year_change: '- 8.2%'
				},
				Knight: {
					sales: 10,
					active_listings: 62,
					benchmark_price: '$1,802,900',
					one_year_change: '1.7%'
				},
				Main: {
					sales: 3,
					active_listings: 31,
					benchmark_price: '$2,090,600',
					one_year_change: '+ 0.6%'
				},
				'Mount Pleasant VE': {
					sales: 2,
					active_listings: 17,
					benchmark_price: '$2,014,000',
					one_year_change: '- 0.1%'
				},
				'Renfrew Heights': {
					sales: 9,
					active_listings: 64,
					benchmark_price: '$1,789,800',
					one_year_change: '- 3.8%'
				},
				'Renfrew VE': {
					sales: 8,
					active_listings: 90,
					benchmark_price: '$1,773,600',
					one_year_change: '- 3.0%'
				},
				'South Marine': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$1,404,400',
					one_year_change: '- 1.8%'
				},
				'South Vancouver': {
					sales: 7,
					active_listings: 69,
					benchmark_price: '$1,836,100',
					one_year_change: '- 1.5%'
				},
				Strathcona: {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$1,709,400',
					one_year_change: '- 0.1%'
				},
				'Victoria VE': {
					sales: 4,
					active_listings: 34,
					benchmark_price: '$1,771,500',
					one_year_change: '- 1.2%'
				}
			},
			condos: {
				'Champlain Heights': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$795,200',
					one_year_change: '- 4.8%'
				},
				'Collingwood VE': {
					sales: 16,
					active_listings: 105,
					benchmark_price: '$569,000',
					one_year_change: '- 5.4%'
				},
				'Downtown VE': {
					sales: 5,
					active_listings: 58,
					benchmark_price: '$653,100',
					one_year_change: '- 5.2%'
				},
				'Fraser VE': {
					sales: 4,
					active_listings: 14,
					benchmark_price: '$824,700',
					one_year_change: '- 2.9%'
				},
				'Fraserview VE': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Grandview Woodland': {
					sales: 8,
					active_listings: 41,
					benchmark_price: '$652,500',
					one_year_change: '- 2.0%'
				},
				Hastings: {
					sales: 7,
					active_listings: 15,
					benchmark_price: '$573,000',
					one_year_change: '- 1.4%'
				},
				'Hastings Sunrise': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$544,000',
					one_year_change: '- 4.6%'
				},
				'Killarney VE': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$616,800',
					one_year_change: '- 3.0%'
				},
				Knight: {
					sales: 2,
					active_listings: 15,
					benchmark_price: '$707,800',
					one_year_change: '- 2.8%'
				},
				Main: {
					sales: 4,
					active_listings: 10,
					benchmark_price: '$1,027,900',
					one_year_change: '- 2.4%'
				},
				'Mount Pleasant VE': {
					sales: 30,
					active_listings: 151,
					benchmark_price: '$725,100',
					one_year_change: '- 1.7%'
				},
				'Renfrew Heights': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$417,900',
					one_year_change: '- 0.1%'
				},
				'Renfrew VE': {
					sales: 5,
					active_listings: 13,
					benchmark_price: '$730,600',
					one_year_change: '- 1.7%'
				},
				'South Marine': {
					sales: 14,
					active_listings: 118,
					benchmark_price: '$797,200',
					one_year_change: '- 6.5%'
				},
				'South Vancouver': {
					sales: 0,
					active_listings: 14,
					benchmark_price: '$631,900',
					one_year_change: '- 8.1%'
				},
				Strathcona: {
					sales: 2,
					active_listings: 41,
					benchmark_price: '$721,800',
					one_year_change: '- 1.7%'
				},
				'Victoria VE': {
					sales: 4,
					active_listings: 18,
					benchmark_price: '$759,100',
					one_year_change: '- 6.0%'
				}
			},
			townhomes: {
				'Champlain Heights': {
					sales: 5,
					active_listings: 4,
					benchmark_price: '$1,300,200',
					one_year_change: '- 1.2%'
				},
				'Collingwood VE': {
					sales: 3,
					active_listings: 8,
					benchmark_price: '$984,800',
					one_year_change: '- 0.1%'
				},
				'Downtown VE': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Fraser VE': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$1,418,000',
					one_year_change: '- 2.2%'
				},
				'Fraserview VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Grandview Woodland': {
					sales: 4,
					active_listings: 17,
					benchmark_price: '$1,393,300',
					one_year_change: '- 0.3%'
				},
				Hastings: {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$1,210,000',
					one_year_change: '- 1.0%'
				},
				'Hastings Sunrise': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Killarney VE': {
					sales: 0,
					active_listings: 9,
					benchmark_price: '$932,700',
					one_year_change: '- 1.4%'
				},
				Knight: {
					sales: 2,
					active_listings: 4,
					benchmark_price: '$1,306,900',
					one_year_change: '- 5.4%'
				},
				Main: {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$1,193,100',
					one_year_change: '- 6.9%'
				},
				'Mount Pleasant VE': {
					sales: 3,
					active_listings: 17,
					benchmark_price: '$1,141,300',
					one_year_change: '- 5.8%'
				},
				'Renfrew Heights': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Renfrew VE': {
					sales: 2,
					active_listings: 2,
					benchmark_price: '$1,003,500',
					one_year_change: '- 1.7%'
				},
				'South Marine': {
					sales: 5,
					active_listings: 25,
					benchmark_price: '$1,032,800',
					one_year_change: '- 0.1%'
				},
				'South Vancouver': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Strathcona: {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$1,036,300',
					one_year_change: '- 2.9%'
				},
				'Victoria VE': {
					sales: 2,
					active_listings: 5,
					benchmark_price: '$1,280,300',
					one_year_change: '- 0.5%'
				}
			}
		},
		'Burnaby North': {
			detached: {
				'Brentwood Park': {
					sales: 1,
					active_listings: 20,
					benchmark_price: '$2,091,400',
					one_year_change: '- 1.1%'
				},
				'Capitol Hill BN': {
					sales: 4,
					active_listings: 26,
					benchmark_price: '$2,097,200',
					one_year_change: '+ 1.7%'
				},
				Cariboo: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central BN': {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$1,815,400',
					one_year_change: '+ 3.0%'
				},
				'Forest Hills BN': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Government Road': {
					sales: 2,
					active_listings: 21,
					benchmark_price: '$2,290,300',
					one_year_change: '- 8.6%'
				},
				'Lake City Industrial': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Montecito: {
					sales: 3,
					active_listings: 18,
					benchmark_price: '$2,034,500',
					one_year_change: '- 9.4%'
				},
				Oakdale: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Parkcrest: {
					sales: 3,
					active_listings: 46,
					benchmark_price: '$2,122,200',
					one_year_change: '+ 0.9%'
				},
				'Simon Fraser Hills': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Simon Fraser Univer.': {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$2,245,100',
					one_year_change: '- 8.2%'
				},
				'Sperling-Duthie': {
					sales: 1,
					active_listings: 16,
					benchmark_price: '$2,072,000',
					one_year_change: '- 7.8%'
				},
				'Sullivan Heights': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Vancouver Heights': {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$2,099,600',
					one_year_change: '+ 2.2%'
				},
				'Westridge BN': {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$2,419,200',
					one_year_change: '- 12.4%'
				},
				'Willingdon Heights': {
					sales: 4,
					active_listings: 18,
					benchmark_price: '$1,938,400',
					one_year_change: '+ 1.3%'
				}
			},
			condos: {
				'Brentwood Park': {
					sales: 56,
					active_listings: 432,
					benchmark_price: '$804,300',
					one_year_change: '- 3.3%'
				},
				'Capitol Hill BN': {
					sales: 2,
					active_listings: 15,
					benchmark_price: '$571,400',
					one_year_change: '- 0.1%'
				},
				Cariboo: {
					sales: 1,
					active_listings: 11,
					benchmark_price: '$528,000',
					one_year_change: '- 4.6%'
				},
				'Central BN': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$774,500',
					one_year_change: '- 1.5%'
				},
				'Forest Hills BN': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Government Road': {
					sales: 9,
					active_listings: 23,
					benchmark_price: '$583,700',
					one_year_change: '- 5.0%'
				},
				'Lake City Industrial': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Montecito: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Oakdale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Parkcrest: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$844,100',
					one_year_change: '- 2.5%'
				},
				'Simon Fraser Hills': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$475,700',
					one_year_change: '- 3.6%'
				},
				'Simon Fraser Univer.': {
					sales: 7,
					active_listings: 80,
					benchmark_price: '$639,200',
					one_year_change: '- 3.7%'
				},
				'Sperling-Duthie': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sullivan Heights': {
					sales: 17,
					active_listings: 69,
					benchmark_price: '$661,200',
					one_year_change: '- 2.1%'
				},
				'Vancouver Heights': {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$812,200',
					one_year_change: '- 0.6%'
				},
				'Westridge BN': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Willingdon Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$633,600',
					one_year_change: '0.4%'
				}
			},
			townhomes: {
				'Brentwood Park': {
					sales: 1,
					active_listings: 8,
					benchmark_price: '$1,011,000',
					one_year_change: '- 6.9%'
				},
				'Capitol Hill BN': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$828,300',
					one_year_change: '- 5.3%'
				},
				Cariboo: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central BN': {
					sales: 4,
					active_listings: 1,
					benchmark_price: '$925,100',
					one_year_change: '- 3.7%'
				},
				'Forest Hills BN': {
					sales: 2,
					active_listings: 10,
					benchmark_price: '$1,032,900',
					one_year_change: '+ 2.2%'
				},
				'Government Road': {
					sales: 2,
					active_listings: 3,
					benchmark_price: '$1,080,600',
					one_year_change: '- 3.7%'
				},
				'Lake City Industrial': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Montecito: {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$778,800',
					one_year_change: '+ 1.6%'
				},
				Oakdale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Parkcrest: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Simon Fraser Hills': {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$861,400',
					one_year_change: '+ 2.8%'
				},
				'Simon Fraser Univer.': {
					sales: 3,
					active_listings: 9,
					benchmark_price: '$793,500',
					one_year_change: '+ 0.4%'
				},
				'Sperling-Duthie': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sullivan Heights': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$826,500',
					one_year_change: '+ 0.3%'
				},
				'Vancouver Heights': {
					sales: 2,
					active_listings: 1,
					benchmark_price: '$951,300',
					one_year_change: '- 4.4%'
				},
				'Westridge BN': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$749,800',
					one_year_change: '+ 2.0%'
				},
				'Willingdon Heights': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$970,400',
					one_year_change: '- 3.8%'
				}
			}
		}
	},
	'June 2025': {
		'Maple Ridge': {
			detached: {
				Albion: {
					sales: 7,
					active_listings: 83,
					benchmark_price: '$1,304,600',
					one_year_change: '+ 1.2%'
				},
				'Cottonwood MR': {
					sales: 4,
					active_listings: 66,
					benchmark_price: '$1,323,000',
					one_year_change: '3.0%'
				},
				'East Central': {
					sales: 15,
					active_listings: 96,
					benchmark_price: '$1,146,400',
					one_year_change: '- 3.8%'
				},
				'North Maple Ridge': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northeast: {
					sales: 1,
					active_listings: 13,
					benchmark_price: '$1,776,500',
					one_year_change: '- 4.0%'
				},
				'Northwest Maple Ridge': {
					sales: 5,
					active_listings: 34,
					benchmark_price: '$1,218,200',
					one_year_change: '- 3.1%'
				},
				'Silver Valley': {
					sales: 8,
					active_listings: 73,
					benchmark_price: '$1,483,400',
					one_year_change: '- 0.9%'
				},
				'Southwest Maple Ridge': {
					sales: 10,
					active_listings: 75,
					benchmark_price: '$1,119,100',
					one_year_change: '1.3%'
				},
				'Thornhill MR': {
					sales: 0,
					active_listings: 28,
					benchmark_price: '$1,645,800',
					one_year_change: '- 2.2%'
				},
				'Websters Corners': {
					sales: 1,
					active_listings: 43,
					benchmark_price: '$1,421,300',
					one_year_change: '+ 0.7%'
				},
				'West Central': {
					sales: 6,
					active_listings: 116,
					benchmark_price: '$1,105,400',
					one_year_change: '- 3.8%'
				},
				Whonnock: {
					sales: 0,
					active_listings: 14,
					benchmark_price: '$1,569,600',
					one_year_change: '+ 1.5%'
				}
			},
			condos: {
				Albion: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Cottonwood MR': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'East Central': {
					sales: 20,
					active_listings: 94,
					benchmark_price: '$507,100',
					one_year_change: '- 3.8%'
				},
				'North Maple Ridge': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northeast: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Northwest Maple Ridge': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$529,300',
					one_year_change: '- 4.1%'
				},
				'Silver Valley': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Southwest Maple Ridge': {
					sales: 0,
					active_listings: 3,
					benchmark_price: '$416,200',
					one_year_change: '- 2.8%'
				},
				'Thornhill MR': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Websters Corners': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Central': {
					sales: 7,
					active_listings: 65,
					benchmark_price: '$531,500',
					one_year_change: '- 3.3%'
				},
				Whonnock: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				Albion: {
					sales: 3,
					active_listings: 20,
					benchmark_price: '$822,600',
					one_year_change: '- 0.3%'
				},
				'Cottonwood MR': {
					sales: 10,
					active_listings: 36,
					benchmark_price: '$817,900',
					one_year_change: '- 0.5%'
				},
				'East Central': {
					sales: 11,
					active_listings: 56,
					benchmark_price: '$751,200',
					one_year_change: '- 4.9%'
				},
				'North Maple Ridge': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Northeast: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Northwest Maple Ridge': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$701,700',
					one_year_change: '+ 0.9%'
				},
				'Silver Valley': {
					sales: 3,
					active_listings: 16,
					benchmark_price: '$843,300',
					one_year_change: '4.3%'
				},
				'Southwest Maple Ridge': {
					sales: 5,
					active_listings: 7,
					benchmark_price: '$662,600',
					one_year_change: '+ 2.3%'
				},
				'Thornhill MR': {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Websters Corners': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'West Central': {
					sales: 3,
					active_listings: 11,
					benchmark_price: '$694,000',
					one_year_change: '- 4.7%'
				},
				Whonnock: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		Coquitlam: {
			detached: {
				'Burke Mountain': {
					sales: 4,
					active_listings: 62,
					benchmark_price: '$2,040,800',
					one_year_change: '-7.0%'
				},
				'Canyon Springs': {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,516,600',
					one_year_change: '1.8%'
				},
				'Cape Horn': {
					sales: 1,
					active_listings: 11,
					benchmark_price: '$1,463,900',
					one_year_change: '-3.0%'
				},
				'Central Coquitlam': {
					sales: 9,
					active_listings: 50,
					benchmark_price: '$1,802,400',
					one_year_change: '-4.5%'
				},
				Chineside: {
					sales: 1,
					active_listings: 10,
					benchmark_price: '$1,671,000',
					one_year_change: '-9.5%'
				},
				'Coquitlam East': {
					sales: 3,
					active_listings: 31,
					benchmark_price: '$1,687,000',
					one_year_change: '-4.2%'
				},
				'Coquitlam West': {
					sales: 2,
					active_listings: 95,
					benchmark_price: '$1,860,300',
					one_year_change: '-4.5%'
				},
				'Eagle Ridge CQ': {
					sales: 3,
					active_listings: 2,
					benchmark_price: '$1,332,800',
					one_year_change: '-3.7%'
				},
				'Harbour Chines': {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$2,078,700',
					one_year_change: '5.6%'
				},
				'Harbour Place': {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$1,795,700',
					one_year_change: '6.0%'
				},
				Hockaday: {
					sales: 2,
					active_listings: 10,
					benchmark_price: '$1,689,600',
					one_year_change: '-7.2%'
				},
				Maillardville: {
					sales: 5,
					active_listings: 32,
					benchmark_price: '$1,799,300',
					one_year_change: '-1.7%'
				},
				'Meadow Brook': {
					sales: 0,
					active_listings: 13,
					benchmark_price: '$1,170,100',
					one_year_change: '-0.1%'
				},
				'New Horizons': {
					sales: 2,
					active_listings: 13,
					benchmark_price: '$1,309,600',
					one_year_change: '-5.7%'
				},
				'North Coquitlam': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Park Ridge Estates': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ranch Park': {
					sales: 1,
					active_listings: 117,
					benchmark_price: '$1,675,100',
					one_year_change: '+ 0.4%'
				},
				'River Springs': {
					sales: 3,
					active_listings: 3,
					benchmark_price: '$1,223,900',
					one_year_change: '-6.8%'
				},
				'Scott Creek': {
					sales: 1,
					active_listings: 7,
					benchmark_price: '$1,789,700',
					one_year_change: '-3.2%'
				},
				'Summitt View': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Eagle Ridge': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$1,757,400',
					one_year_change: '-2.0%'
				},
				'Westwood Plateau': {
					sales: 8,
					active_listings: 73,
					benchmark_price: '$1,827,600',
					one_year_change: '-5.8%'
				},
				'Westwood Summit CQ': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			condos: {
				'Burke Mountain': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Canyon Springs': {
					sales: 2,
					active_listings: 11,
					benchmark_price: '$628,300',
					one_year_change: '-0.5%'
				},
				'Cape Horn': {
					sales: 0,
					active_listings: 11,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central Coquitlam': {
					sales: 5,
					active_listings: 40,
					benchmark_price: '$570,800',
					one_year_change: '-3.7%'
				},
				Chineside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Coquitlam East': {
					sales: 2,
					active_listings: 6,
					benchmark_price: '$576,300',
					one_year_change: '-4.0%'
				},
				'Coquitlam West': {
					sales: 37,
					active_listings: 273,
					benchmark_price: '$742,600',
					one_year_change: '-4.6%'
				},
				'Eagle Ridge CQ': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$695,400',
					one_year_change: '-2.1%'
				},
				'Harbour Chines': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Harbour Place': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Hockaday: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Maillardville: {
					sales: 3,
					active_listings: 24,
					benchmark_price: '$486,000',
					one_year_change: '-4.0%'
				},
				'Meadow Brook': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'New Horizons': {
					sales: 8,
					active_listings: 32,
					benchmark_price: '$803,300',
					one_year_change: '-4.4%'
				},
				'North Coquitlam': {
					sales: 16,
					active_listings: 127,
					benchmark_price: '$710,300',
					one_year_change: '-5.4%'
				},
				'Park Ridge Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ranch Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'River Springs': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Scott Creek': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Summitt View': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Eagle Ridge': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Westwood Plateau': {
					sales: 4,
					active_listings: 24,
					benchmark_price: '$710,400',
					one_year_change: '-2.4%'
				},
				'Westwood Summit CQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			},
			townhomes: {
				'Burke Mountain': {
					sales: 19,
					active_listings: 99,
					benchmark_price: '$1,249,200',
					one_year_change: '+ 3.8%'
				},
				'Canyon Springs': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$742,400',
					one_year_change: '- 0.6%'
				},
				'Cape Horn': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central Coquitlam': {
					sales: 1,
					active_listings: 0,
					benchmark_price: '$712,600',
					one_year_change: '- 3.8%'
				},
				Chineside: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Coquitlam East': {
					sales: 2,
					active_listings: 5,
					benchmark_price: '$850,900',
					one_year_change: '- 1.0%'
				},
				'Coquitlam West': {
					sales: 5,
					active_listings: 60,
					benchmark_price: '$1,032,400',
					one_year_change: '- 2.6%'
				},
				'Eagle Ridge CQ': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$987,000',
					one_year_change: '+ 1.8%'
				},
				'Harbour Chines': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Harbour Place': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Hockaday: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Maillardville: {
					sales: 2,
					active_listings: 14,
					benchmark_price: '$766,000',
					one_year_change: '- 1.6%'
				},
				'Meadow Brook': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'New Horizons': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$1,218,800',
					one_year_change: '+ 3.6%'
				},
				'North Coquitlam': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Park Ridge Estates': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Ranch Park': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$757,300',
					one_year_change: '- 2.4%'
				},
				'River Springs': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Scott Creek': {
					sales: 1,
					active_listings: 5,
					benchmark_price: '$1,095,500',
					one_year_change: '+ 1.7%'
				},
				'Summitt View': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Upper Eagle Ridge': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$862,800',
					one_year_change: '+ 2.6%'
				},
				'Westwood Plateau': {
					sales: 6,
					active_listings: 14,
					benchmark_price: '$1,094,500',
					one_year_change: '+ 11.0%'
				},
				'Westwood Summit CQ': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				}
			}
		},
		'Vancouver East': {
			detached: {
				'Champlain Heights': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Collingwood VE': {
					sales: 6,
					active_listings: 111,
					benchmark_price: '$1,667,100',
					one_year_change: '-6.7%'
				},
				'Downtown VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Fraser VE': {
					sales: 9,
					active_listings: 66,
					benchmark_price: '$1,944,000',
					one_year_change: '+3.4%'
				},
				'Fraserview VE': {
					sales: 2,
					active_listings: 39,
					benchmark_price: '$2,151,800',
					one_year_change: '-6.5%'
				},
				'Grandview Woodland': {
					sales: 5,
					active_listings: 45,
					benchmark_price: '$1,829,100',
					one_year_change: '-2.1%'
				},
				Hastings: {
					sales: 2,
					active_listings: 12,
					benchmark_price: '$1,729,700',
					one_year_change: '-0.0%'
				},
				'Hastings Sunrise': {
					sales: 5,
					active_listings: 30,
					benchmark_price: '$1,714,000',
					one_year_change: '+1.8%'
				},
				'Killarney VE': {
					sales: 11,
					active_listings: 60,
					benchmark_price: '$1,856,500',
					one_year_change: '-6.2%'
				},
				Knight: {
					sales: 13,
					active_listings: 60,
					benchmark_price: '$1,712,600',
					one_year_change: '6.8%'
				},
				Main: {
					sales: 3,
					active_listings: 32,
					benchmark_price: '$2,153,500',
					one_year_change: '+2.2%'
				},
				'Mount Pleasant VE': {
					sales: 5,
					active_listings: 15,
					benchmark_price: '$1,962,600',
					one_year_change: '+1.2%'
				},
				'Renfrew Heights': {
					sales: 7,
					active_listings: 60,
					benchmark_price: '$1,777,500',
					one_year_change: '-3.8%'
				},
				'Renfrew VE': {
					sales: 16,
					active_listings: 89,
					benchmark_price: '$1,790,800',
					one_year_change: '-2.3%'
				},
				'South Marine': {
					sales: 1,
					active_listings: 3,
					benchmark_price: '$1,402,100',
					one_year_change: '-2.9%'
				},
				'South Vancouver': {
					sales: 5,
					active_listings: 74,
					benchmark_price: '$1,782,100',
					one_year_change: '8.4%'
				},
				Strathcona: {
					sales: 0,
					active_listings: 6,
					benchmark_price: '$1,673,000',
					one_year_change: '0.6%'
				},
				'Victoria VE': {
					sales: 5,
					active_listings: 33,
					benchmark_price: '$1,680,800',
					one_year_change: '-7.2%'
				}
			},
			condos: {
				'Champlain Heights': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$773,100',
					one_year_change: '-5.3%'
				},
				'Collingwood VE': {
					sales: 15,
					active_listings: 103,
					benchmark_price: '$559,400',
					one_year_change: '5.8%'
				},
				'Downtown VE': {
					sales: 8,
					active_listings: 48,
					benchmark_price: '$636,700',
					one_year_change: '-4.1%'
				},
				'Fraser VE': {
					sales: 3,
					active_listings: 19,
					benchmark_price: '$797,900',
					one_year_change: '-5.5%'
				},
				'Fraserview VE': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Grandview Woodland': {
					sales: 15,
					active_listings: 39,
					benchmark_price: '$650,600',
					one_year_change: '-1.9%'
				},
				Hastings: {
					sales: 5,
					active_listings: 22,
					benchmark_price: '$556,700',
					one_year_change: '-1.1%'
				},
				'Hastings Sunrise': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$543,500',
					one_year_change: '-5.0%'
				},
				'Killarney VE': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$601,300',
					one_year_change: '4.9%'
				},
				Knight: {
					sales: 5,
					active_listings: 11,
					benchmark_price: '$679,500',
					one_year_change: '-5.9%'
				},
				Main: {
					sales: 1,
					active_listings: 13,
					benchmark_price: '$1,001,300',
					one_year_change: '-5.4%'
				},
				'Mount Pleasant VE': {
					sales: 26,
					active_listings: 149,
					benchmark_price: '$720,400',
					one_year_change: '-2.5%'
				},
				'Renfrew Heights': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$408,500',
					one_year_change: '+0.3%'
				},
				'Renfrew VE': {
					sales: 3,
					active_listings: 13,
					benchmark_price: '$748,400',
					one_year_change: '+1.4%'
				},
				'South Marine': {
					sales: 14,
					active_listings: 121,
					benchmark_price: '$778,900',
					one_year_change: '-6.9%'
				},
				'South Vancouver': {
					sales: 0,
					active_listings: 15,
					benchmark_price: '$610,800',
					one_year_change: '10.7%'
				},
				Strathcona: {
					sales: 8,
					active_listings: 41,
					benchmark_price: '$724,300',
					one_year_change: '1.6%'
				},
				'Victoria VE': {
					sales: 3,
					active_listings: 17,
					benchmark_price: '$764,500',
					one_year_change: '-3.8%'
				}
			},
			townhomes: {
				'Champlain Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$966,800',
					one_year_change: '-5.3%'
				},
				'Collingwood VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$958,900',
					one_year_change: '-4.9%'
				},
				'Downtown VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Fraser VE': {
					sales: 6,
					active_listings: 6,
					benchmark_price: '$1,472,900',
					one_year_change: '+0.9%'
				},
				'Fraserview VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Grandview Woodland': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$1,348,800',
					one_year_change: '-5.0%'
				},
				Hastings: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$1,172,200',
					one_year_change: '-4.4%'
				},
				'Hastings Sunrise': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Killarney VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$905,500',
					one_year_change: '-5.9%'
				},
				Knight: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$1,342,700',
					one_year_change: '-2.4%'
				},
				Main: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$1,236,900',
					one_year_change: '-1.0%'
				},
				'Mount Pleasant VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$1,160,100',
					one_year_change: '-2.1%'
				},
				'Renfrew Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Renfrew VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$972,200',
					one_year_change: '4.5%'
				},
				'South Marine': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$994,500',
					one_year_change: '-5.6%'
				},
				'South Vancouver': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Strathcona: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$1,057,300',
					one_year_change: '-2.2%'
				},
				'Victoria VE': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$1,243,900',
					one_year_change: '-5.2%'
				}
			}
		},
		'Burnaby North': {
			detached: {
				'Brentwood Park': {
					sales: 1,
					active_listings: 20,
					benchmark_price: '$2,084,700',
					one_year_change: '- 3.9%'
				},
				'Capitol Hill BN': {
					sales: 1,
					active_listings: 28,
					benchmark_price: '$2,104,500',
					one_year_change: '+ 3.1%'
				},
				Cariboo: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central BN': {
					sales: 2,
					active_listings: 13,
					benchmark_price: '$1,876,500',
					one_year_change: '+ 1.2%'
				},
				'Forest Hills BN': {
					sales: 0,
					active_listings: 4,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Government Road': {
					sales: 1,
					active_listings: 25,
					benchmark_price: '$2,376,500',
					one_year_change: '- 4.0%'
				},
				'Lake City Industrial': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Montecito: {
					sales: 1,
					active_listings: 18,
					benchmark_price: '$2,099,400',
					one_year_change: '5.9%'
				},
				Oakdale: {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Parkcrest: {
					sales: 1,
					active_listings: 47,
					benchmark_price: '$2,137,500',
					one_year_change: '- 2.3%'
				},
				'Simon Fraser Hills': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Simon Fraser Univer.': {
					sales: 0,
					active_listings: 13,
					benchmark_price: '$2,415,400',
					one_year_change: '- 1.2%'
				},
				'Sperling-Duthie': {
					sales: 3,
					active_listings: 14,
					benchmark_price: '$2,115,500',
					one_year_change: '- 5.2%'
				},
				'Sullivan Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Vancouver Heights': {
					sales: 3,
					active_listings: 13,
					benchmark_price: '$2,124,900',
					one_year_change: '+ 3.3%'
				},
				'Westridge BN': {
					sales: 0,
					active_listings: 13,
					benchmark_price: '$2,453,200',
					one_year_change: '10.7%'
				},
				'Willingdon Heights': {
					sales: 3,
					active_listings: 20,
					benchmark_price: '$1,996,600',
					one_year_change: '- 0.1%'
				}
			},
			condos: {
				'Brentwood Park': {
					sales: 56,
					active_listings: 406,
					benchmark_price: '$786,800',
					one_year_change: '- 5.6%'
				},
				'Capitol Hill BN': {
					sales: 3,
					active_listings: 16,
					benchmark_price: '$581,200',
					one_year_change: '+ 0.7%'
				},
				Cariboo: {
					sales: 2,
					active_listings: 16,
					benchmark_price: '$527,700',
					one_year_change: '- 4.1%'
				},
				'Central BN': {
					sales: 1,
					active_listings: 6,
					benchmark_price: '$784,400',
					one_year_change: '- 0.4%'
				},
				'Forest Hills BN': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Government Road': {
					sales: 3,
					active_listings: 23,
					benchmark_price: '$575,000',
					one_year_change: '- 4.8%'
				},
				'Lake City Industrial': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Montecito: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Oakdale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Parkcrest: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$865,700',
					one_year_change: '- 0.9%'
				},
				'Simon Fraser Hills': {
					sales: 1,
					active_listings: 2,
					benchmark_price: '$470,300',
					one_year_change: '- 3.4%'
				},
				'Simon Fraser Univer.': {
					sales: 11,
					active_listings: 84,
					benchmark_price: '$628,900',
					one_year_change: '- 4.7%'
				},
				'Sperling-Duthie': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sullivan Heights': {
					sales: 8,
					active_listings: 60,
					benchmark_price: '$647,700',
					one_year_change: '- 3.6%'
				},
				'Vancouver Heights': {
					sales: 2,
					active_listings: 8,
					benchmark_price: '$830,000',
					one_year_change: '+ 1.2%'
				},
				'Westridge BN': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Willingdon Heights': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$646,800',
					one_year_change: '+ 0.5%'
				}
			},
			townhomes: {
				'Brentwood Park': {
					sales: 2,
					active_listings: 5,
					benchmark_price: '$1,027,400',
					one_year_change: '- 3.0%'
				},
				'Capitol Hill BN': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$830,400',
					one_year_change: '- 0.5%'
				},
				Cariboo: {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Central BN': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$935,300',
					one_year_change: '- 2.2%'
				},
				'Forest Hills BN': {
					sales: 3,
					active_listings: 13,
					benchmark_price: '$1,053,700',
					one_year_change: '- 1.5%'
				},
				'Government Road': {
					sales: 0,
					active_listings: 5,
					benchmark_price: '$1,069,500',
					one_year_change: '- 5.1%'
				},
				'Lake City Industrial': {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Montecito: {
					sales: 0,
					active_listings: 7,
					benchmark_price: '$798,800',
					one_year_change: '- 0.7%'
				},
				Oakdale: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				Parkcrest: {
					sales: 0,
					active_listings: 0,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Simon Fraser Hills': {
					sales: 2,
					active_listings: 5,
					benchmark_price: '$859,400',
					one_year_change: '- 2.6%'
				},
				'Simon Fraser Univer.': {
					sales: 1,
					active_listings: 9,
					benchmark_price: '$809,500',
					one_year_change: '- 4.3%'
				},
				'Sperling-Duthie': {
					sales: 0,
					active_listings: 2,
					benchmark_price: '$0',
					one_year_change: ''
				},
				'Sullivan Heights': {
					sales: 2,
					active_listings: 1,
					benchmark_price: '$842,300',
					one_year_change: '- 4.2%'
				},
				'Vancouver Heights': {
					sales: 1,
					active_listings: 1,
					benchmark_price: '$947,200',
					one_year_change: '- 5.3%'
				},
				'Westridge BN': {
					sales: 0,
					active_listings: 1,
					benchmark_price: '$763,500',
					one_year_change: '- 1.7%'
				},
				'Willingdon Heights': {
					sales: 1,
					active_listings: 4,
					benchmark_price: '$976,300',
					one_year_change: '- 1.7%'
				}
			}
		}
	}
};
